import * as cryptoJS from 'crypto-js';
import utf8 from 'utf8';
import forge from 'node-forge';
import {
    BEST5_INDEX, MARKETDEPTH_INDEX, CONSTITUENTS_GRID_INDEX, INDICES_CONSTANTS,
    FACILITY_NUM, FACILITY_STR, FACILITY_BOOL, LOGIN_CONSTANTS,//HiralK : 01-08-2023 : Client Facility Template
    TL_INDEX, WATCHLIST_GRID_INDEX, VALIDITY_TYPES, DYANMIC_URL_CONSTANTS, MARKET_SEGMENT_ID, MAPPED_MARKET_SEGMENT_ID,
    EXCHANGE_NAME_API, MULTIPLIER, DECIMAL_LOCATOR, OPTION_CHAIN_GRID_INDEX, ORDER_PRODUCT_TYPES_VALUES,
    ORDER_PRODUCT_TYPES, APP_INFO_PARAMS, ORDER_ENTRY_BUTTON_TOGGLE, MSG_MASTER, SCRIP_INSTRUMENTS,
    DISPLAY_EXCHANGE_NAME, EXCHANGE_TYPES, MKT_SEGMENTID_HAVING_LOTS, API_SOURCE, MANAGE_COLUMNS_VIEW_TYPES,
    DEPOSITORY_CDSL, clsConstants, COVER, IPO_CODE, SIDE_TRAY_EXPAND_PERCENTAGE, LINK_OPEN_MODES,
    LOCATIONS, THEME_TYPE, LOCAL_STORAGE_KEYS, DISCLAIMER_NOTE, APPLICATION_TYPE,
    NET_POSITION_EXPIRY,
    GRID_SELECT_TYPE,
    GRID_ROW_SELECTION_TYPE,
    HAMBURGER_LIST,
    HIDE_FEATURES,
    NetNetPGQSMode,
    LANDING_PAGE_INDEX,
    MARKET_STATUS,
    EXCHANGE_NAME_NOTIFICATION,
    PRODUCT_DETAILS,
    ORDER_VALIDITY
} from './global_variables';
import config from '../config.json';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { getProductTypes, getScripOrderInfo, getSipSettingDetails, updateSingleScripOrderConfirmed } from '../redux/actions/orders';
import { setRegistrationDetails, updateInAppIFrame } from '../redux/actions/appInfo';
import { isEqual } from 'lodash';
import { store } from '../redux/store';
import { updateCft, updateIsLoading } from '../redux/actions/auth';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connectSocket, getScripbyTokenAndMktSegId } from '../apis';
import { updateReconnectionCount } from '../redux/actions/wfh';
import { sendSubscription, sendTouchlineRequest } from '../apis/web_socket';
import { handleModal, handleModalData } from '../redux/actions/modals';
import { getMessages, getMessagesBroker } from '../redux/actions/messages';
import { _generateUrlForPledgeUnpledge, _getScripsInfo } from '../controllers';
import { toastConfig } from '../redux/actions/toast';
import { getGlobalWatchlistScrips, updateUserColumnProfileAction } from '../redux/actions/watchlist';
import { setScripOverviewData, updateSelectedArrRowData } from '../redux/actions/marketOverview';
import { _resetGridFeatures } from '../controllers/watchlist';
import { getInfo, handshake } from '../apis/authentication';
import { Buffer } from 'buffer';
import { v4 as uuidv4 } from 'uuid';
import { updateCurrentColumnMovingState } from '../redux/actions/columnActions';
import { setIsIndicesOverview } from '../redux/actions/indices';

pdfMake.vfs = pdfFonts && pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : global.pdfMake.vfs;

export const updateColumnProfile = (viewType, column) => {
    //this function updates column profile when called but based on the viewType of Column --Ameersha N
    const userColumnProfiles = store.getState()?.watchList?.userColumnProfiles;
    let filterColumnsProfiles = userColumnProfiles?.filter((eachProfile) => eachProfile?.sViewType === viewType);
    let seletecProfileCopy = filterColumnsProfiles[0];
    let arrRearrangedColumns = column.cols;
    if (viewType === (MANAGE_COLUMNS_VIEW_TYPES.WATCHLIST_VIEW_TYPE || MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE || MANAGE_COLUMNS_VIEW_TYPES.FUTURES_VIEW_TYPE)) {
        arrRearrangedColumns?.unshift({ headerName: 'Symbol' });
    }
    let isIndexChanged = isColumnsSameIndex(seletecProfileCopy?.columnDetails, arrRearrangedColumns, true);
    let finalReArrangedColumsn = rearrangeColumsByIndex(arrRearrangedColumns, seletecProfileCopy?.columnDetails);
    if (isIndexChanged) {
        seletecProfileCopy['columnDetails'] = finalReArrangedColumsn;
        store.dispatch(updateUserColumnProfileAction(seletecProfileCopy, true, true));
        let arrColumnMoviedTypes = store.getState().columns.arrColumnMoviedTypess;
        let nindex = arrColumnMoviedTypes?.findIndex((eachColumn) => eachColumn.viewType === viewType);
        if (nindex > -1) {
            arrColumnMoviedTypes.splice(nindex, 1);
            store.dispatch(updateCurrentColumnMovingState(arrColumnMoviedTypes));
        }
    }
};

export const updateColumnProfileOnGridDestroy = () => {
    //this will be called on grid destroies and based on the grid instance columsn changes thet gird column profile will be Updated
    let arrColumnMoviedTypes = store.getState().columns.arrColumnMoviedTypess;
    if (arrColumnMoviedTypes?.length > 0) {
        arrColumnMoviedTypes?.forEach((eachColumn) => {
            switch (eachColumn.viewType) {
                case MANAGE_COLUMNS_VIEW_TYPES.WATCHLIST_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.WATCHLIST_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.NET_POSITION_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.NET_POSITION_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.ORDER_GOOD_TILL_DATE_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.ORDER_GOOD_TILL_DATE_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.ORDER_MULTI_LEG_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.ORDER_MULTI_LEG_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.ORDER_SINGLE_SCRIP_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.ORDER_SINGLE_SCRIP_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.ORDER_SPREAD_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.ORDER_SPREAD_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.HOLDINGS_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.HOLDINGS_VIEW_TYPE, eachColumn);
                    break;
                case MANAGE_COLUMNS_VIEW_TYPES.FUTURES_VIEW_TYPE:
                    updateColumnProfile(MANAGE_COLUMNS_VIEW_TYPES.FUTURES_VIEW_TYPE, eachColumn);
                    break;
                default:
                    break;
            }
        });
    }
};



export const rearrangeColumsByIndex = (firstArray, secondArray) => {
    //this is just a helper function to help to rearrange columsn according to new index --Ameersha N
    const headerIndexMap = {};
    firstArray?.forEach((item, index) => {
        headerIndexMap[item.headerName] = index;
    });

    secondArray?.sort((a, b) => {
        return (headerIndexMap[a.sColumnName] ?? Infinity) - (headerIndexMap[b.sColumnName] ?? Infinity);
    });
    secondArray?.forEach((item, index) => {
        item.nSequenceNo = index + 1;
    });
    return secondArray;
};


/*
All Grid Function ========================= start
*/
export const handleGridRowDragOnAndOff = (ref, field, isRowDrag) => {
    //helps in enabling or disablign of row dragging
    let arrCurrColumnDefs = ref?.current?.api?.getColumnDefs();
    let nIndex = arrCurrColumnDefs?.findIndex((eachColumn) => eachColumn?.field === field);
    if (nIndex > -1) {
        let symbolColumn = arrCurrColumnDefs[nIndex];
        symbolColumn['rowDrag'] = isRowDrag;
        arrCurrColumnDefs[nIndex] = { ...symbolColumn };
        ref?.current?.api?.setGridOption("columnDefs", arrCurrColumnDefs);
    }
};

export const handleToggleColumnsVisible = (ref, field, isColumnVisible) => {
    // helps to toggle column if needed
    let arrCurrColumnDefs = ref?.current?.api?.getColumnDefs();
    let nIndex = arrCurrColumnDefs?.findIndex((eachColumn) => eachColumn?.colId === field);
    if (nIndex > -1) {
        let symbolColumn = arrCurrColumnDefs[nIndex];
        symbolColumn['hide'] = isColumnVisible;
        arrCurrColumnDefs[nIndex] = { ...symbolColumn };
        ref?.current?.api?.setGridOption("columnDefs", arrCurrColumnDefs);
    }
};

export const handleSelectColumns = (ref, mode = 'all', type) => {
    // mode= all || filtered || currentPage
    // helps in selecting all rows, or deselecting all rows or even filtered rows also
    switch (type) {
        case GRID_SELECT_TYPE.SELECT:
            ref.current.api?.selectAll(mode);
            break;
        case GRID_SELECT_TYPE.DESELECT:
            ref.current.api?.deselectAll(mode);
            break;
        default:
            break;
    }

};

export const getGridRowsAfterDrag = (dragEndEvent) => {
    // returns rows after drag event end
    const { api } = dragEndEvent;
    let rowsAfterDrag = [];
    api?.forEachNode((rowNode) => {
        rowsAfterDrag.push(rowNode?.data);
    });
    return rowsAfterDrag;
};


export const getGridAllRows = (api, onlyData = false) => {
    let arrAllNodes = [];
    api?.forEachNode((rowNode) => {
        if (rowNode?.selectable) {
            arrAllNodes.push(onlyData ? rowNode?.data : rowNode);
        }
    });
    return arrAllNodes;
};

export const handleSelectingGivenRows = (params, ref, isRef = false, arrNodesToSelect, isSelecte = true) => {
    // you can selected row by giving an array also for customisation if needed
    if (params) {
        params.api.setNodesSelected({ nodes: arrNodesToSelect, newValue: isSelecte });
    } else if (ref && isRef) {
        ref?.current?.api?.setNodesSelected({ nodes: arrNodesToSelect, newValue: isSelecte });
    }
};



export const getFilteredNodesAfterFilter = (ref) => {
    // helps to get filtered rows or nodes after f lteration
    let filteredNodes = [];
    ref?.current?.api?.forEachNodeAfterFilter((rowNode) => {
        filteredNodes?.push(rowNode?.data);
    });
    return filteredNodes;
};



export const updateGridColumnDef = (ref, arrCurrColumnDefs) => {
    // helps in updating column def with out rerendering
    ref?.current?.api?.setGridOption("columnDefs", arrCurrColumnDefs);
};

export const updateGridRowSlectionType = (ref, type) => {
    // helps to update row selection type to singleRow or multiRow
    switch (type) {
        case GRID_ROW_SELECTION_TYPE.MULTI_ROW:
            ref?.current?.api.setGridOption('rowSelection', {
                mode: GRID_ROW_SELECTION_TYPE.MULTI_ROW,
                checkboxes: true,
                selectAll: true,
                enableClickSelection: true,
            });
            break;
        case GRID_ROW_SELECTION_TYPE.SINGLE_ROW:
            ref?.current?.api.setGridOption('rowSelection', {
                mode: GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
                checkboxes: true,
                selectAll: true,
                enableClickSelection: true,
            });
            break;
        default:
            break;
    }
};


/*
All Grid Function ========================= end
*/

export const isColumnsSameIndex = (arrInput, arrOutPut, isSplice = false) => {
    if (isSplice) {
        arrOutPut?.splice(0, 1);
    }
    let i = 0, j = 0;
    while (i < arrInput?.length && j < arrOutPut?.length) {
        if (arrInput[i].nSequenceNo === arrOutPut[j].nSequenceNo) {
            i++;
            j++;
        } else {
            return true; // sequence changed
        }
    }
    return false; // reached end of arrInput arry

};

export const globalFunctionsEventDispatcher = (arrTypes) => {
    const funtionevents = new CustomEvent("global_function", { detail: arrTypes, bubbles: true });
    document.dispatchEvent(funtionevents);
};

export const clickWithOutModifiers = (event) => {
    // metaKey is  command key in mac
    return (!event?.shiftKey && !event?.ctrlKey && !event?.altKey && !event?.metaKey);
};

export const handleScripUnsubScriptionOnUnMount = (objScrips = {}, path = '') => {
    if (Object?.keys(objScrips)?.length > 0) {
        let arrDataToUnsubScribe = Object?.keys(objScrips)?.map((eachToken) => {
            return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
        });
        sendTouchlineRequest(arrDataToUnsubScribe);
    }
};



export const scrollContainerObserver = (containerRef, sublevel = false) => {
    return new Promise((resolve) => {
        const observer = new IntersectionObserver((entries) => {
            const visible = entries?.filter((entry) => entry?.isIntersecting)?.map((entry) => entry?.target?.id);
            resolve(visible);
        }, {
            root: containerRef?.current,
            threshold: 0.1
        });
        const container = containerRef?.current;
        if (container && !sublevel) {
            Array?.from(container?.children)?.forEach((child) => observer?.observe(child));
        }
        if (container && sublevel) {
            const innerContainer = container?.children[0];
            Array?.from(innerContainer?.children)?.forEach((child) => observer?.observe(child));
        }
    });

};
// Azeem K:07-05 - 2025 : added conditionally GTT and GTD --Start
const getFilteredValidity = (validities = [], isGTTAllowed = false, bIsAddGTD = false) => {
    if (validities?.length > 0 && !isGTTAllowed) {
        const arrValidities = validities?.filter((validity) => validity !== ORDER_VALIDITY.GTT);
        if (bIsAddGTD) {
            arrValidities.push(ORDER_VALIDITY.GTD);
        }
        return arrValidities;
    } else {
        return validities;
    }

};
// Azeem K:07-05 - 2025 : added conditionally GTT and GTD --end
//to get validity values on the basis of exchange name
// start
function getValidityByExchangeName(exchangeName, isGTTAllowed) {
    try {
        switch (exchangeName) {
            case EXCHANGE_NAME_API.NSE_EQ_API: {
                return getFilteredValidity(VALIDITY_TYPES.NSE_EQ, isGTTAllowed, true);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
            }
            case EXCHANGE_NAME_API.NSE_DERV_API: {
                return getFilteredValidity(VALIDITY_TYPES.NSE_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.BSE_EQ_API: {
                return getFilteredValidity(VALIDITY_TYPES.BSE_EQ, isGTTAllowed, true);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.BSE_DERV_API: {
                return getFilteredValidity(VALIDITY_TYPES.BSE_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.MCX_DERV_API: {
                return VALIDITY_TYPES.MCX_FO;
            }
            case EXCHANGE_NAME_API.ICEX_DERV_API: {
                return VALIDITY_TYPES.ICEX_FO;
            }
            case EXCHANGE_NAME_API.NCDEX_DERV_API: {
                return VALIDITY_TYPES.NCDEX_FO;
            }
            case EXCHANGE_NAME_API.MCXSX_EQ_API: {
                return getFilteredValidity(VALIDITY_TYPES.MSX_EQ, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.MCXSX_CURR_API: {
                return getFilteredValidity(VALIDITY_TYPES.MSX_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
            }
            case EXCHANGE_NAME_API.MCXSX_DERV_API: {
                return getFilteredValidity(VALIDITY_TYPES.MSX_FAO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.NSEL_SPTCOM_DESC_API: {
                return VALIDITY_TYPES.NSEL_FO;
            }
            case EXCHANGE_NAME_API.NMCE_FAO_API: {
                return VALIDITY_TYPES.NMCE_FO;
            }
            case EXCHANGE_NAME_API.DSE_EQUITIES_API: {
                return VALIDITY_TYPES.DSE_CASH;
            }
            case EXCHANGE_NAME_API.NSE_COMM_API: {
                return getFilteredValidity(VALIDITY_TYPES.NSX_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.NSX_DERV_API: {
                return getFilteredValidity(VALIDITY_TYPES.NSX_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
            }
            case EXCHANGE_NAME_API.BSECDX_DERV_API: {
                return getFilteredValidity(VALIDITY_TYPES.BSECDX_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 

            }
            case EXCHANGE_NAME_API.BSE_COMM_API: {
                return getFilteredValidity(VALIDITY_TYPES.BSECDX_FO, isGTTAllowed);// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
            }
            case EXCHANGE_NAME_API.UCX_FO_API: {
                return VALIDITY_TYPES.UCX_FO;
            }
            case EXCHANGE_NAME_API.BFX_FUTURES_API: {
                return VALIDITY_TYPES.BFX_FO;
            }
            case EXCHANGE_NAME_API.IPO_DESC: {
                return VALIDITY_TYPES.IPO_BONDS;
            }
            default: {
                return '';
            }
        }
    } catch (error) {
        console.error('ERROR in getValidityByExchangeName', error.message);
    }
}
//end

const getQtyLotCaption = (MktSegId, LotSize, details) => {
    let _caption = 'Qty';
    try {
        if (MktSegId != undefined && (MKT_SEGMENTID_HAVING_LOTS.indexOf(MktSegId) != -1))
            _caption = details ? "Lot(1 Lot = " + LotSize + ")" : "Lot";
    }
    catch (e) {
        console.error(e);
    }
    return _caption;
};


function convertToDate(seconds, strFormat) {
    try {
        var d1 = new Date("01/01/1980 00:00:00");
        d1.setSeconds(seconds);
        return moment(d1).format(strFormat);
    } catch (error) {
        console.error(error);
    }
}

function TripleDESEncrypt(plainText) {
    try {
        //Convert to base64
        let bkey = COVER.TDES || "1234567890";// "1234567890";

        let encryptedText = encryptTDES(bkey, plainText);//Encrypt using TripleDes
        return encryptedText.toString();

    } catch (e) {
        console.error(e);
        return "";
        //Global.LogManager.WriteLog(e.message, 'TripleDESEncryptOCToken', 'CommonMethods.js', '');

    }
};



function TripleDESDecrypt(plainText) {
    try {
        //Convert to base64
        let bkey = COVER.TDES || "1234567890";// "1234567890";
        if (plainText === null) {
            return null;
        }

        let decryptedText = decryptTDES(bkey, plainText);//Dencrypt using TripleDes
        return decryptedText.toString();

    } catch (e) {
        console.error(e);
        return "";
        //Global.LogManager.WriteLog(e.message, 'TripleDESEncryptOCToken', 'CommonMethods.js', '');
    }
};

// Parshva S : 22/12/2023 : BT-124573 :  R&D for Local Storage Encryption and Decryption start

function setEncryptLocalStorage(key, value) {
    localStorage.setItem(key, TripleDESEncrypt(value));
}

export const isCacheEnabled = () => {
    let { appInfo } = store?.getState()?.appInfo;
    return getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_IS_CACHE, appInfo);
};

function getDecryptLocalStorage(key) {
    let temp = TripleDESDecrypt(localStorage.getItem(key));
    return temp;
}
// Parshva S : 22/12/2023 : BT-124573 : R&D for Local Storage Encryption and Decryption end

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start


function roundToNearest(nValue, nStep, strUpDown) {
    // return Math.round(nValue / nStep) * nStep;
    const invStep = 1 / nStep;
    return (nValue * invStep) / invStep;
    // if (strUpDown === 'up') {
    //     // return Math.floor(nValue * invStep) / invStep;
    // } else if (strUpDown === 'down') {
    //     // return Math.ceil(nValue * invStep) / invStep;
    // } else {
    //     // return Math.round(nValue * invStep) / invStep;
    // }
};

function getOrderIdentifier() {
    const date1 = new Date(); // current date
    const date2 = new Date("01/01/1980"); // mm/dd/yyyy format
    const timeDiff = Math.abs(date1.getTime() - date2.getTime()); // in miliseconds
    const timeDiffInSecond = Math.ceil(timeDiff / 1000); // in second

    return timeDiffInSecond;

}

function validateLTPPriceBand(arrScripInfo, nScripPrice, activeButtonToggleIndex, orderPrice, strOrderType, arrLTPPriceBandMaster, slPrice = null) {
    const objLtpValid = { valid: true, isRestrictive: false, errorMsg: "" };
    try {
        const scripInstrument = arrScripInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.includes('IDX') ? 'INDEX' : (arrScripInfo[WATCHLIST_GRID_INDEX.NSPREAD] == 1 ? 'SPREAD' : 'STOCK');
        let arrPriceBandMaster = arrLTPPriceBandMaster?.filter(
            a => a.market_segment_id == arrScripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]
                && (a.instrument_type.includes(arrScripInfo[WATCHLIST_GRID_INDEX.INSTRUMENT].substr(0, 2)) && (a.scrip_instrument == 'ALL' || scripInstrument == a.scrip_instrument)));
        const arrSymbolPriceBand = arrPriceBandMaster.filter(a => a.symbol == arrScripInfo[WATCHLIST_GRID_INDEX.SYMBOL]);
        const arrSymbolWisePriceBand = arrPriceBandMaster.filter(a => a.symbol_wise == 0);
        if (arrSymbolWisePriceBand) {
            arrPriceBandMaster = arrSymbolWisePriceBand;
        } else if (arrSymbolPriceBand) {
            arrPriceBandMaster = arrSymbolPriceBand;
        }
        let nDecimalLocator = arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
        if (arrScripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]?.includes('COMM')) {
            nDecimalLocator = DECIMAL_LOCATOR.NORMAL;
        } else if (arrScripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]?.includes('CUR')) {
            nDecimalLocator = DECIMAL_LOCATOR.CURRENCY;
        } else { }

        slPrice = slPrice != null && slPrice != '' ? parseFloat(slPrice) * nDecimalLocator : 0;
        nScripPrice = nScripPrice != null && nScripPrice != '' ? parseFloat(nScripPrice) * nDecimalLocator : 0;
        orderPrice = orderPrice != null && orderPrice != '' ? parseFloat(orderPrice) * nDecimalLocator : 0;

        if (nScripPrice <= 0 && arrScripInfo[WATCHLIST_GRID_INDEX.NSPREAD] == 0 && (arrScripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.MCX_SPOT || arrScripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSECOMM_SPOT || arrScripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSECOMM_SPOT)) {
            return objLtpValid;
        }

        if (arrPriceBandMaster?.length > 0) {
            for (let i = 0; i < arrPriceBandMaster.length; i++) {
                const objPriceBandMaster = arrPriceBandMaster[i];
                if (objPriceBandMaster?.lower_ltp <= nScripPrice && objPriceBandMaster?.higher_ltp >= nScripPrice) {
                    const arrAdditionalValidationFor = objPriceBandMaster?.additional_validation_for;
                    if ((strOrderType == 'RL-MKT' && arrAdditionalValidationFor.includes('RL-MKT'))
                        || (strOrderType == 'SL-MKT' && arrAdditionalValidationFor.includes('RL-MKT'))
                        || strOrderType == 'RL'
                        || strOrderType == 'SL') {

                        let _nHigherPrcRange = 0, _nLowerPrcRange = 0;
                        if (objPriceBandMaster?.validation_type == 'PERCENTAGE') {                         // percent
                            if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                                _nHigherPrcRange = nScripPrice + (((objPriceBandMaster?.worst_price_range / 100) * nScripPrice) / 100);
                                _nLowerPrcRange = nScripPrice - (((objPriceBandMaster?.favourable_price_range / 100) * nScripPrice) / 100);
                            } else {
                                _nHigherPrcRange = nScripPrice + ((nScripPrice * (objPriceBandMaster?.favourable_price_range / 100)) / 100);
                                _nLowerPrcRange = nScripPrice - ((nScripPrice * (objPriceBandMaster?.worst_price_range / 100)) / 100);
                            }
                        } else if (objPriceBandMaster?.validation_type == 'FLAT_PRICE') {                  // flat price
                            if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                                _nHigherPrcRange = nScripPrice + objPriceBandMaster?.worst_price_range;
                                _nLowerPrcRange = nScripPrice - objPriceBandMaster?.favourable_price_range;
                            } else {
                                _nHigherPrcRange = nScripPrice + objPriceBandMaster?.favourable_price_range;
                                _nLowerPrcRange = nScripPrice - objPriceBandMaster?.worst_price_range;
                            }
                        }
                        const nHigherPrcRange = _nHigherPrcRange, nLowerPrcRange = _nLowerPrcRange;

                        if ((activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY && (orderPrice > nHigherPrcRange || (objPriceBandMaster?.favourable_price_range != 0 && orderPrice < nLowerPrcRange)))
                            || (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL && ((objPriceBandMaster?.favourable_price_range != 0 && orderPrice > nHigherPrcRange) || orderPrice < nLowerPrcRange))) {
                            objLtpValid.valid = false;
                            let triggerName = strOrderType === 'SL' ? 'Trigger ' : '';

                            if (objPriceBandMaster?.alert_type == 'INFORMATIVE') {                          // 1: informative
                                objLtpValid.isRestrictive = false;
                                objLtpValid.errorMsg = orderPrice > nHigherPrcRange ? triggerName + MSG_MASTER.OE123.replace('{0}', (nHigherPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]))
                                    : triggerName + MSG_MASTER.OE124.replace('{0}', (nLowerPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                            } else {                                            // 2: restrictive
                                objLtpValid.isRestrictive = true;
                                objLtpValid.errorMsg = orderPrice > nHigherPrcRange ? triggerName + MSG_MASTER.OE125.replace('{0}', (nHigherPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])).replace('{0}', (nHigherPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]))
                                    : triggerName + MSG_MASTER.OE126.replace('{0}', (nLowerPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])).replace('{0}', (nLowerPrcRange / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                            }
                        }

                        if (arrAdditionalValidationFor.includes('SL') && slPrice > 0) {
                            let _nHigherPrcRange2 = 0, _nLowerPrcRange2 = 0;
                            if (objPriceBandMaster?.validation_type == 'PERCENTAGE') {                         // percent
                                if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                                    _nHigherPrcRange2 = nScripPrice + (((objPriceBandMaster?.worst_price_range / 100) * nScripPrice) / 100);
                                    _nLowerPrcRange2 = nScripPrice - (((objPriceBandMaster?.favourable_price_range / 100) * nScripPrice) / 100);
                                } else {
                                    _nHigherPrcRange2 = nScripPrice + ((nScripPrice * (objPriceBandMaster?.favourable_price_range / 100)) / 100);
                                    _nLowerPrcRange2 = nScripPrice - ((nScripPrice * (objPriceBandMaster?.worst_price_range / 100)) / 100);
                                }
                            } else if (objPriceBandMaster?.validation_type == 'FLAT_PRICE') {                  // flat price
                                if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                                    _nHigherPrcRange2 = nScripPrice + objPriceBandMaster?.worst_price_range;
                                    _nLowerPrcRange2 = nScripPrice - objPriceBandMaster?.favourable_price_range;
                                } else {
                                    _nHigherPrcRange2 = nScripPrice + objPriceBandMaster?.favourable_price_range;
                                    _nLowerPrcRange2 = nScripPrice - objPriceBandMaster?.worst_price_range;
                                }
                            }
                            const nHigherPrcRange2 = _nHigherPrcRange2, nLowerPrcRange2 = _nLowerPrcRange2;
                            if (((activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL && (slPrice > nHigherPrcRange2 || (objPriceBandMaster?.favourable_price_range != 0 && slPrice < nLowerPrcRange2)))
                                || (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY && ((objPriceBandMaster?.favourable_price_range != 0 && slPrice > nHigherPrcRange2) || slPrice < nLowerPrcRange2)))) {
                                objLtpValid.valid = false;
                                if (objPriceBandMaster?.alert_type == 'INFORMATIVE') {                       // 1: informative
                                    objLtpValid.isRestrictive = false;
                                    objLtpValid.errorMsg +=
                                        // (objLtpValid.errorMsg != '' ? '' : '') +
                                        (slPrice > nHigherPrcRange2 ? 'SL Trigger ' + MSG_MASTER.OE123.replace('{0}', (nHigherPrcRange2 / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]))
                                            : 'SL Trigger ' + MSG_MASTER.OE124.replace('{0}', (nLowerPrcRange2 / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])));
                                } else {                                            // 2: restrictive
                                    objLtpValid.isRestrictive = true;
                                    objLtpValid.errorMsg +=
                                        // (objLtpValid.errorMsg != '' ? '' : '') +
                                        (slPrice > nHigherPrcRange2 ? 'SL Trigger ' + MSG_MASTER.OE125.replace('{0}', (nHigherPrcRange2 / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]))
                                            : 'SL Trigger ' + MSG_MASTER.OE126.replace('{0}', (nLowerPrcRange2 / nDecimalLocator).toFixed(arrScripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])));
                                }
                            }
                        }
                    }
                }
            }
        } else { }
    } catch (error) {
        console.error(error);
    }
    return objLtpValid;
}

function getGSMGradeDescriptionFromScrip(arrScrip) {
    try {
        if (arrScrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] && (arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_CASH || arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSE_CASH)) {
            const GSMCategoryGrade = arrScrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION];
            return "Security is under Surveillance Measure - " + GSMCategoryGrade + ", Do you wish to continue?";
        } else {
            return null;
        }
    } catch (error) {
        console.error(error);
    }
}

function isValidDecimalDigits(_value, _noOfDecimals) {
    let _bIsValidDec = true;
    let _intDecIdx = _value.indexOf(".");
    if (_intDecIdx != -1) {
        _intDecIdx = _value.length - _intDecIdx - 1;
        if (_intDecIdx > _noOfDecimals) _bIsValidDec = false;
    }

    return _bIsValidDec;
}

function getToFixedParseFloat(strValue, nDecimalLocatorLength) {
    if (strValue) {
        if (parseFloat(strValue) == 0) {
            return 0;
        } else {
            return parseFloat(strValue).toFixed(nDecimalLocatorLength);
        }
    } else {
        return strValue;
    }
}
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

function getMktSegIdFromMappedMktSegId(nMappedMarketSegmentId) {
    let nMarketSegmentId = nMappedMarketSegmentId;
    try {
        switch (parseInt(nMappedMarketSegmentId)) {
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSE_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSE_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH:
                nMarketSegmentId = MARKET_SEGMENT_ID.BSE_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.BSE_DERIVATIVES;
                break;
            // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MSE_CASH:
                nMarketSegmentId = MARKET_SEGMENT_ID.MSX_CASH;
                break;
            // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.MCX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.MCX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.NCDEX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.NCDEX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSEL_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSEL_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSEL_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSEL_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.MSX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.MSX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.NSX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECDX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.BSECDX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECDX_SPOT:
                nMarketSegmentId = MARKET_SEGMENT_ID.BSECDX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_CASH:
                nMarketSegmentId = MARKET_SEGMENT_ID.MSX_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_FAO:
                nMarketSegmentId = MARKET_SEGMENT_ID.MSX_FAO;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NMCE_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.NMCE_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_DSE_CASH:
                nMarketSegmentId = MARKET_SEGMENT_ID.DSE_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_UCX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.UCX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_DGCX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.DGCX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BFX_DERIVATIVES:
                nMarketSegmentId = MARKET_SEGMENT_ID.BFX_DERIVATIVES;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_OFS_IPO_BONDS:
                nMarketSegmentId = MARKET_SEGMENT_ID.OFS_IPO_BONDS;
                break;
            default:
                nMarketSegmentId = nMappedMarketSegmentId;
                break;
        }
    }
    catch (e) {
        throw e;
    }
    finally {
        return nMarketSegmentId;
    }
}
// srik
function getApiExchangeNameFromMktSegId(nMktSegId) {
    let strExName = '';
    try {
        switch (parseInt(nMktSegId)) {
            case MARKET_SEGMENT_ID.NSE_CASH:
                strExName = EXCHANGE_NAME_API.NSE_EQ_API;
                break;
            case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSE_DERV_API;
                break;
            case MARKET_SEGMENT_ID.MSX_FIM:
                strExName = EXCHANGE_NAME_API.MSX_FIM_API;
                break;
            case MARKET_SEGMENT_ID.NSEL_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSEL_SPTCOM_DESC_API;
                break;
            case MARKET_SEGMENT_ID.BSE_CASH:
                strExName = EXCHANGE_NAME_API.BSE_EQ_API;
                break;
            case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.BSE_DERV_API;
                break;
            case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.MCX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.MCX_SPOT:
                strExName = EXCHANGE_NAME_API.MCX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.ICEX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.ICEX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.BSE_COMM_API;
                break;
            case MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSE_COMM_API;
                break;
            case MARKET_SEGMENT_ID.BSECOMM_SPOT:
                strExName = EXCHANGE_NAME_API.BSECOMM_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NSECOMM_SPOT:
                strExName = EXCHANGE_NAME_API.NSECOMM_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NCDEX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.NCDEX_SPOT:
                strExName = EXCHANGE_NAME_API.NCDEX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.MCXSX_CURR_API;
                break;
            case MARKET_SEGMENT_ID.MSX_CASH:
                strExName = EXCHANGE_NAME_API.MCXSX_EQ_API;
                break;
            case MARKET_SEGMENT_ID.MSX_FAO:
                strExName = EXCHANGE_NAME_API.MCXSX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.MSX_SPOT:
                strExName = EXCHANGE_NAME_API.MCXSX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.NSX_SPOT:
                strExName = EXCHANGE_NAME_API.NSX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.BSECDX_DERV_API;
                break;
            case MARKET_SEGMENT_ID.BSECDX_SPOT:
                strExName = EXCHANGE_NAME_API.BSECDX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.OFS_IPO_BONDS:
                strExName = EXCHANGE_NAME_API.NSE_OTS_API;
                break;
            default: {
                strExName = '';
                break;
            }
        }
    } catch (error) {
        strExName = '';
        console.error("Unable to get exchange name : getApiExchangeName:" + error);
    }
    finally {
        return strExName;
    }
}

function getMktSegIdFromApiExchangeName(strExchange) {
    let mktSegId = -1;
    switch (strExchange) {
        case EXCHANGE_NAME_API.NSE_EQ_API:
            mktSegId = MARKET_SEGMENT_ID.NSE_CASH;
            break;
        case EXCHANGE_NAME_API.NSE_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.NSE_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.BSE_EQ_API:
            mktSegId = MARKET_SEGMENT_ID.BSE_CASH;
            break;
        case EXCHANGE_NAME_API.BSE_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.BSE_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.MCX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.MCX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.NCDEX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.NCDEX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.NSEL_SPTCOM_DESC_API:
            mktSegId = MARKET_SEGMENT_ID.NSEL_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.MCXSX_CURR_API:
            mktSegId = MARKET_SEGMENT_ID.MSX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.MCXSX_EQ_API:
            mktSegId = MARKET_SEGMENT_ID.MSX_CASH;
            break;
        case EXCHANGE_NAME_API.MCXSX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.MSX_FAO;
            break;
        case EXCHANGE_NAME_API.DSE_EQUITIES_API:
            mktSegId = MARKET_SEGMENT_ID.DSE_CASH;
            break;
        case EXCHANGE_NAME_API.NSX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.NSX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.BSECDX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.BSECDX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.COMBINED_CASH:
            mktSegId = MARKET_SEGMENT_ID.COMBINED_CASH;
            break;
        case EXCHANGE_NAME_API.COMBINED_FNO:
            mktSegId = MARKET_SEGMENT_ID.COMBINED_FNO;
            break;
        case EXCHANGE_NAME_API.COMBINED_CDS:
            mktSegId = MARKET_SEGMENT_ID.COMBINED_CDS;
            break;
        case EXCHANGE_NAME_API.MSX_FIM_API:
            mktSegId = MARKET_SEGMENT_ID.MSX_FIM;
            break;
        case EXCHANGE_NAME_API.MCX_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.MCX_SPOT;
            break;
        case EXCHANGE_NAME_API.ICEX_DERV_API:
            mktSegId = MARKET_SEGMENT_ID.ICEX_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.BSE_COMM_API:
            mktSegId = MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.NSE_COMM_API:
            mktSegId = MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES;
            break;
        case EXCHANGE_NAME_API.BSECOMM_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.BSECOMM_SPOT;
            break;
        case EXCHANGE_NAME_API.NSECOMM_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.NSECOMM_SPOT;
            break;
        case EXCHANGE_NAME_API.NCDEX_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.NCDEX_SPOT;
            break;
        case EXCHANGE_NAME_API.MCXSX_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.MSX_SPOT;
            break;
        case EXCHANGE_NAME_API.BSECDX_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.BSECDX_SPOT;
            break;
        case EXCHANGE_NAME_API.NSE_OTS_API:
            mktSegId = MARKET_SEGMENT_ID.OFS_IPO_BONDS;
            break;
        case EXCHANGE_NAME_API.NSX_SPOT_API:
            mktSegId = MARKET_SEGMENT_ID.NSX_SPOT;
            break;
        default:
            mktSegId = -1;
            break;
    }

    return mktSegId;
}

function getMappedMktSegIdFromApiExchangeName(strExchName) {
    let nMtSegVal = -1;

    switch (strExchName) {
        case EXCHANGE_NAME_API.NSE_EQ_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH;
            break;
        case EXCHANGE_NAME_API.NSE_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_DERIVATIVES;
            break;

        case EXCHANGE_NAME_API.BSE_EQ_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH;
            break;

        // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
        case EXCHANGE_NAME_API.MSE_EQ_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_MSE_CASH;
            break;
        // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

        case EXCHANGE_NAME_API.BSE_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_DERIVATIVES;
            break;

        case EXCHANGE_NAME_API.MCX_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES;
            break;

        case EXCHANGE_NAME_API.NCDEX_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES;
            break;
        //NSE CUR
        case EXCHANGE_NAME_API.NSX_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_DERIVATIVES;
            break;
        //BSE CUR
        case EXCHANGE_NAME_API.BSECDX_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECDX_DERIVATIVES;
            break;
        //NSE_COMM
        case EXCHANGE_NAME_API.NSE_COMM_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSECOMM_DERIVATIVES;
            break;
        //BSE_COMM
        case EXCHANGE_NAME_API.BSE_COMM_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECOMM_DERIVATIVES;
            break;
        // ICEX_DERV_API
        case EXCHANGE_NAME_API.ICEX_DERV_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_ICEX_DERIVATIVES;
            break;
        // NSE_OTS_API
        case EXCHANGE_NAME_API.NSE_OTS_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_OFS_IPO_BONDS;
            break;

        case EXCHANGE_NAME_API.MUTUAL_FUND:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_MUTUAL_FUND;
            break;
        case EXCHANGE_NAME_API.MCX_SPOT_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_SPOT;
            break;
        case EXCHANGE_NAME_API.NSX_SPOT_API:
            nMtSegVal = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_SPOT;
            break;
        default:
            nMtSegVal = -1;
            break;
    }

    return nMtSegVal;
}

function getAssetExchangeNameFromMktSegId(nMktSegId) {
    let strExName = '';
    try {
        switch (parseInt(nMktSegId)) {
            case MARKET_SEGMENT_ID.NSE_CASH:
            case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSE_EQ_API;
                break;
            case MARKET_SEGMENT_ID.BSE_CASH:
            case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.BSE_EQ_API;
                break;
            case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
            case MARKET_SEGMENT_ID.MCX_SPOT:
                strExName = EXCHANGE_NAME_API.MCX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.BSECOMM_SPOT:
            case MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.BSECOMM_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NSECOMM_SPOT:
            case MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NSECOMM_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NCDEX_SPOT:
            case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
                strExName = EXCHANGE_NAME_API.NCDEX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
            case MARKET_SEGMENT_ID.MSX_CASH:
                strExName = EXCHANGE_NAME_API.MCXSX_EQ_API;
                break;
            case MARKET_SEGMENT_ID.MSX_FAO:
            case MARKET_SEGMENT_ID.MSX_SPOT:
                strExName = EXCHANGE_NAME_API.MCXSX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
            case MARKET_SEGMENT_ID.NSX_SPOT:
                strExName = EXCHANGE_NAME_API.NSX_SPOT_API;
                break;
            case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
            case MARKET_SEGMENT_ID.BSECDX_SPOT:
                strExName = EXCHANGE_NAME_API.BSECDX_SPOT_API;
                break;
            default: {
                strExName = '';
                break;
            }
        }
    } catch (error) {
        strExName = '';
        console.error("Unable to get exchange name : getApiExchangeName:" + error);
    }
    finally {
        return strExName;
    }
}

function getExchangeNameDescBySegmentId(nMktSegId) {
    let strExName = '';
    try {
        switch (parseInt(nMktSegId)) {
            case MARKET_SEGMENT_ID.NSE_CASH:
                strExName = EXCHANGE_NAME_NOTIFICATION.NSE_EQ;
                break;
            case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_NOTIFICATION.NSE_FO;
                break;
            case MARKET_SEGMENT_ID.BSE_CASH:
                strExName = EXCHANGE_NAME_NOTIFICATION.BSE_EQ;
                break;
            case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
                strExName = EXCHANGE_NAME_NOTIFICATION.BSE_FO;
                break;
            case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
            case MARKET_SEGMENT_ID.MCX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.MCX_FO;
                break;
            case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
            case MARKET_SEGMENT_ID.NCDEX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.NCDEX_FO;
                break;
            case MARKET_SEGMENT_ID.NSEL_DERIVATIVES:
            case MARKET_SEGMENT_ID.NSEL_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.NSEL_SPTCOM_DESC;
                break;
            case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
                strExName = EXCHANGE_NAME_NOTIFICATION.MCXSX_FUTURES;
                break;
            case MARKET_SEGMENT_ID.MSX_CASH:
                strExName = EXCHANGE_NAME_NOTIFICATION.MCXSX_EQUITIES;
                break;
            case MARKET_SEGMENT_ID.MSX_FAO:
                strExName = EXCHANGE_NAME_NOTIFICATION.MCXSX_FAO;
                break;
            case MARKET_SEGMENT_ID.DSE_CASH:
                strExName = EXCHANGE_NAME_NOTIFICATION.DSE_EQUITIES;
                break;
            case MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES:
                strExName = EXCHANGE_NAME_NOTIFICATION.BSE_COMM;
                break;
            case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
            case MARKET_SEGMENT_ID.NSX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.NSX_FUTURES;
                break;
            case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
            case MARKET_SEGMENT_ID.BSECDX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.BSECDX_FUTURES;
                break;
            case MARKET_SEGMENT_ID.UCX_DERIVATIVES:
            case MARKET_SEGMENT_ID.UCX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.NSE_COMM;
                break;
            case MARKET_SEGMENT_ID.DGCX_DERIVATIVES:
            case MARKET_SEGMENT_ID.DGCX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.DGCX_FUTURES;
                break;
            case MARKET_SEGMENT_ID.BFX_DERIVATIVES:
            case MARKET_SEGMENT_ID.BFX_SPOT:
                strExName = EXCHANGE_NAME_NOTIFICATION.BFX_FUTURES_DESC;
                break;
            case MARKET_SEGMENT_ID.OFS_IPO_BONDS:
                strExName = EXCHANGE_NAME_NOTIFICATION.IPO;
                break;
            case MARKET_SEGMENT_ID.MUTUAL_FUND:
                strExName = EXCHANGE_NAME_NOTIFICATION.MUTUAL_FUND;
                break;
            case MARKET_SEGMENT_ID.MSX_FIM:
                strExName = EXCHANGE_NAME_NOTIFICATION.MSX_FIM_API;
                break;
            case MARKET_SEGMENT_ID.ICEX_DERIVATIVES:
                strExName = EXCHANGE_NAME_NOTIFICATION.ICEX_FO;
                break;
            default: {
                strExName = '';
                break;
            }
        }
    } catch (error) {
        strExName = '';
        console.error("Unable to get exchange name : getExchangeNameDescBySegmentId:" + error);
    }
    finally {
        return strExName;
    }
}

const getMktStatusColor = (sMktStatus) => {
    let sColor = '';
    if (sMktStatus != undefined) {
        if (sMktStatus.toUpperCase() == MARKET_STATUS.OPEN || sMktStatus.toUpperCase() == MARKET_STATUS.PRE_OPEN || sMktStatus.toUpperCase() == MARKET_STATUS.SPOS_OPEN
            || sMktStatus.toUpperCase() == MARKET_STATUS.MATCHING_OPEN) {
            sColor += "chips open";
        }
        else {
            if (sMktStatus.toUpperCase() == MARKET_STATUS.CLOSE || sMktStatus.toUpperCase() == MARKET_STATUS.SPOS_CLOSE || sMktStatus.toUpperCase() == MARKET_STATUS.MATCHING_CLOSE || sMktStatus.toUpperCase() == MARKET_STATUS.PRE_OPEN_ENDED) {
                sColor += "chips close";
            }
            else {
                if (sMktStatus.toUpperCase() == MARKET_STATUS.UNAVAILABLE || sMktStatus.toUpperCase() == "" ||
                    sMktStatus.toUpperCase() == "-") {
                    sColor += "chips unavailable";
                }
                else {
                    sColor += "chips amo";
                }
            }
        }
    }
    return sColor;
};
function convertNumberWithCommasForCurrency(number, isCurrencySymbol) {
    let strValue = '';
    if (isCurrencySymbol) {
        strValue = number.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR',
        });
    } else {
        strValue = number.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
        });
    }
    return strValue;
}

function changeNumberFormatWithCurrecyUnit(number, isCurrencySymbol = false) {
    let value = number;

    value = Math.abs(number);

    if (value >= 10000000) {
        value = value / 10000000;
        value = convertNumberWithCommasForCurrency(value, isCurrencySymbol) + ' Cr';

    } else if (value >= 100000) {
        value = value / 100000;
        value = convertNumberWithCommasForCurrency(value, isCurrencySymbol) + ' Lac';
    }
    // else if (value >= 1000) {
    //     value = value / 1000;
    //     value = convertNumberWithCommasForCurrency(value) + ' K';
    // }
    else {
        value = convertNumberWithCommasForCurrency(value, isCurrencySymbol);
    }

    if (number < 0) {
        value = '-' + value;
    }
    return value;
}

function arrayGroupBy(arr, key) {
    return arr.reduce(function (rv, x) {
        ; (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

function timeConvert(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
        time,
    ];
    if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? ' AM' : ' PM';
        time[0] = +time[0] % 12 || 12;
    }
    return time.join('');
}
function getItemShade(arrStock) {
    let shadeIndex = -1;
    if (arrStock && arrStock.length > 0) {
        const netChangePrevClose = parseFloat(
            arrStock[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
        );
        if (netChangePrevClose >= 10.0) {
            shadeIndex = 4;
        } else if (netChangePrevClose >= 5.0) {
            shadeIndex = 5;
        } else if (netChangePrevClose >= 2.0) {
            shadeIndex = 6;
        } else if (netChangePrevClose > 0.0) {
            shadeIndex = 7;
        } else if (netChangePrevClose >= -2.0 && netChangePrevClose < 0.0) {
            shadeIndex = 3;
        } else if (netChangePrevClose >= -5.0) {
            shadeIndex = 2;
        } else if (netChangePrevClose >= -10.0) {
            shadeIndex = 1;
        } else if (netChangePrevClose < -10.0) {
            shadeIndex = 0;
        }
        // console.error('shadeIndex->', shadeIndex);
    }
    return shadeIndex;
}

function calculateHistogram(sum, qty) {
    try {
        if (parseFloat(sum) !== 0 && parseFloat(qty) !== 0) {
            let histovalue = Math.round(((parseFloat(qty) * 100) / parseFloat(sum)) * 100) / 100;
            return histovalue;
        } else {
            return 0;
        }
    } catch (error) {
        return 0;
    }
}



function encryptTDES(key, text) {
    try {
        key = cryptoJS.MD5(utf8.encode(key)).toString(cryptoJS.enc.Latin1);
        key = key + key.substring(0, 8);
        const cipher = forge.cipher.createCipher('3DES-ECB', forge.util.createBuffer(key));
        cipher.start({ iv: '' });
        cipher.update(forge.util.createBuffer(text, 'utf-8'));
        cipher.finish();
        const encrypted = cipher.output;
        return forge.util.encode64(encrypted.getBytes());
    } catch (error) {
        console.error(error);
        return '';
    }
}

function decryptTDES(key, encrypted_text) {
    try {
        key = cryptoJS.MD5(utf8.encode(key)).toString(cryptoJS.enc.Latin1);
        key = key + key.substring(0, 8);
        const decipher = forge.cipher.createDecipher('3DES-ECB', forge.util.createBuffer(key));
        encrypted_text = forge.util.decode64(encrypted_text);
        decipher.start({ iv: '' });
        decipher.update(forge.util.createBuffer(encrypted_text, 'utf-8'));
        decipher.finish();
        const decrypted = decipher.output;
        return hTS(decrypted.toHex());
    } catch (error) {
        console.error(error);
        return '';
    }
}

function entangle(key, initVec, text) {
    try {
        const iv = cryptoJS.enc.Utf8.parse(initVec);
        const parsedKey = cryptoJS.enc.Utf8.parse(key);
        const encryptResp = cryptoJS.AES.encrypt(text, parsedKey, {
            iv: iv,
            mode: cryptoJS.mode.CBC,
            padding: cryptoJS.pad.Pkcs7
        }).toString();
        return encryptResp;
    } catch (error) {
        console.error(error);
        return '';
    }
}

function disentangle(key, initVec, encrypted_text) {
    try {
        const iv = cryptoJS.enc.Utf8.parse(initVec);
        const parsedKey = cryptoJS.enc.Utf8.parse(key);
        const decryptResp = cryptoJS.AES.decrypt(encrypted_text, parsedKey, {
            iv: iv,
            mode: cryptoJS.mode.CBC,
            padding: cryptoJS.pad.Pkcs7
        }).toString(cryptoJS.enc.Utf8);
        return decryptResp;
    } catch (error) {
        console.error(error);
        return '';
    }
}

// Ajitesh 23/05/2024 - AES key and iv generation function for appsyncdetails v2 api start
function keyIvFromSalt() {
    const saltedValue = config.TenantId + COVER.APP_SYNC_DETAILS;
    return {
        key: cryptoJS.SHA256(saltedValue).toString().substring(0, 32),
        iv: cryptoJS.SHA256(saltedValue).toString().substring(0, 16)
    };
}
// Ajitesh 23/05/2024 - AES key and iv generation function for appsyncdetails v2 api end

function hTS(hex_String) {
    var hex = hex_String.toString();
    var str = '';
    for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;

}


function setInitialConfigs(appSyncInfos) {
    let strCdnBasePath = '';
    let strOdinApiKey = '';
    if (appSyncInfos && appSyncInfos.length > 0) {
        let nCdnBasePathIndex = appSyncInfos.findIndex(
            (obj) => obj.sParamName === 'APP_CDN_BASE_PATH' && obj?.sTenantId === config.TenantId,
        );
        if (nCdnBasePathIndex >= 0) {
            strCdnBasePath = appSyncInfos[nCdnBasePathIndex]?.sParamValue;
        } else {
            nCdnBasePathIndex = appSyncInfos.findIndex(function (appInfo) {
                return appInfo?.sParamName === "APP_CDN_BASE_PATH" && appInfo?.sTenantId === LOGIN_CONSTANTS.CHIEF_TENANT_ID.toString();
            });
            if (nCdnBasePathIndex >= 0) {
                strCdnBasePath = appSyncInfos[nCdnBasePathIndex]?.sParamValue;
            } else { }
        }
        config.Wave.Cloudfront_S3_URL = strCdnBasePath;

        let nOdinApiKey = appSyncInfos.findIndex(
            (obj) => obj.sParamName === 'APP_ODIN_API_KEY' && obj?.sTenantId === config.TenantId,
        );

        if (nOdinApiKey >= 0) {
            strOdinApiKey = appSyncInfos[nOdinApiKey]?.sParamValue;
        } else {
            nOdinApiKey = appSyncInfos.findIndex(function (appInfo) {
                return appInfo?.sParamName === "APP_ODIN_API_KEY" && appInfo?.sTenantId === LOGIN_CONSTANTS.CHIEF_TENANT_ID.toString();
            });
            if (nOdinApiKey >= 0) {
                strOdinApiKey = appSyncInfos[nOdinApiKey]?.sParamValue;
            } else { }
        }
        config.Wave.ApiKey = strOdinApiKey;

        let appApiCover = getAppInfoData(APP_INFO_PARAMS?.APP_API_TRANSFORM_FLAG, appSyncInfos);
        if (appApiCover !== undefined &&
            (appApiCover?.toString()?.toUpperCase() === FACILITY_STR.OFF || appApiCover === FACILITY_NUM.OFF || appApiCover?.toString()?.toLowerCase() === FACILITY_BOOL.OFF)) {
            config.appApiFlag = true;
        }
        else {
            config.appApiFlag = true;
        }

        //BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023  - Start
        //let nChartUrlIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_MULTI_CHART", config.TenantId);
        //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: Start
        let nMultiChartUrlIndex = getAppInfoData(APP_INFO_PARAMS?.APP_MULTI_CHART, appSyncInfos);
        let nChartUrlIndex = "";
        let nMultiChartPresent = true;
        if (typeof nMultiChartUrlIndex === "string" || nMultiChartUrlIndex?.length === 0) {
            nChartUrlIndex = getAppInfoData(APP_INFO_PARAMS?.APP_CHART_URL, appSyncInfos);
            nMultiChartPresent = false;
        }
        // if (nChartUrlIndex < 0) {
        //     nChartUrlIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_MULTI_CHART", "0");
        // }
        // else {
        // }
        let nChartStyleIndex = getAppInfoData(APP_INFO_PARAMS?.APP_CHART_ADVANCE_STYLE, appSyncInfos);
        // if (nChartStyleIndex < 0) {
        //     nChartStyleIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_CHART_ADVANCE_STYLE", "0");
        // }
        // else {
        // }


        let nChartApiKeyIndex = getAppInfoData(APP_INFO_PARAMS?.APP_CHART_API_KEY, appSyncInfos);
        // if (nChartApiKeyIndex < 0) {
        //     nChartApiKeyIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_CHART_API_KEY", "0");
        // }
        // else {
        // }


        let nChartBrodcastIndex = getAppInfoData(APP_INFO_PARAMS?.APP_CHART_BROADCAST, appSyncInfos);
        // if (nChartBrodcastIndex < 0) {
        //     nChartBrodcastIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_CHART_BROADCAST", "0");
        // }
        // else {
        // }


        let nChartIntervalIndex = getAppInfoData(APP_INFO_PARAMS?.APP_CHART_DATA_INTERVAL, appSyncInfos);
        // if (nChartIntervalIndex < 0) {
        //     nChartIntervalIndex = appSyncInfos && appSyncInfos.length > 0 && findAppInfoParameters(appSyncInfos, "APP_CHART_DATA_INTERVAL", "0");
        // }
        // else {
        // }

        // const objChartAttribute = {
        //     nChartUrl: appSyncInfos[nChartUrlIndex]?.sParamValue ? JSON.parse(appSyncInfos[nChartUrlIndex]?.sParamValue) : '',
        //     nChartStyle: appSyncInfos[nChartStyleIndex]?.sParamValue ? appSyncInfos[nChartStyleIndex]?.sParamValue : '',
        //     nChartApiKey: appSyncInfos[nChartApiKeyIndex]?.sParamValue ? appSyncInfos[nChartApiKeyIndex]?.sParamValue : '',
        //     nChartBrodcast: appSyncInfos[nChartBrodcastIndex]?.sParamValue ? appSyncInfos[nChartBrodcastIndex]?.sParamValue : '',
        //     nChartInterval: appSyncInfos[nChartIntervalIndex]?.sParamValue ? appSyncInfos[nChartIntervalIndex]?.sParamValue : ''

        // };
        const objChartAttribute = {
            nChartUrl: !(typeof nMultiChartUrlIndex === "string" || nMultiChartUrlIndex?.length === 0) ? nMultiChartUrlIndex : nChartUrlIndex,
            nChartStyle: nChartStyleIndex,
            nChartApiKey: nChartApiKeyIndex,
            nChartBrodcast: nChartBrodcastIndex,
            nChartInterval: nChartIntervalIndex,
            nMultiChartPresent: nMultiChartPresent
        };
        //Vaibhav Singh: 18-08-24: Updated changes: Start
        if (nMultiChartPresent) {
            const chartId = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.PREFFERED_CHART));
            if (!chartId) {
                const tradingViewPresent = nMultiChartUrlIndex?.filter(each => each?.id === "tradingview");
                setEncryptLocalStorage('PREFFERED_CHART', JSON.stringify(nMultiChartUrlIndex?.length ? tradingViewPresent?.length ? tradingViewPresent[0] : nMultiChartUrlIndex[0] : nChartUrlIndex));
            }
        }
        //Vaibhav Singh: 18-08-24: Updated changes: End
        //BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023  - Start
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES, JSON.stringify(objChartAttribute));

    } else { }
    //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: End
    // ##### SETTING ALL REQUIRED CONFIGS ######
}

// Neha : 17-05-2023 : toFixed() global function with dynamic parameters as decimal locator - Start
function getDynamicParamsForToFixed(strExchange) {
    //By HiralK : 05-08-2023 - Decimal Locator Optimization - Start
    let nDecimalLocator = 2;
    switch (strExchange) {
        case DISPLAY_EXCHANGE_NAME.NSX_SPOT_TEXT:
        case EXCHANGE_NAME_API.NSX_DERV_API:
        case EXCHANGE_NAME_API.BSECDX_DERV_API:
        case DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT:
        case DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT: {
            nDecimalLocator = 4;
            break;
        }
        default: {
            nDecimalLocator = 2;
            break;
        }
    }
    return nDecimalLocator;
    //By HiralK : 05-08-2023 - Decimal Locator Optimization - End
}
// Neha : 17-05-2023 : toFixed() global function with dynamic parameters as decimal locator - End

function addAdditionalScripDetailstoWatchlist(nMarketSegmentId, nToken) {
    const arrScripsAdditionalInfo = store.getState().watchList?.arrScripsAdditionalInfo;
    if (arrScripsAdditionalInfo?.length > 0) {
        let nIndex = deepClone(arrScripsAdditionalInfo)?.findIndex(eachScrip => eachScrip?.nMarketSegmentId === nMarketSegmentId && eachScrip?.nToken === nToken);
        if (nIndex >= 0) {
            let selectedScrip = arrScripsAdditionalInfo[nIndex];
            return { yesterdayHigh: selectedScrip?.nYesterdayHigh, yesterdayLow: selectedScrip?.nYesterdayLow };
        }
    } else {
        return { yesterdayHigh: 0, yesterdayLow: 0 };
    }
}

//Vaibhav Singh: 06-03-24: Added for Popover: Start
function convertScripResponseWatchlistGrid(arrScripsReponse, convertScreener = false) {


    // Scrips API Response from getScripbyTokenAndMktSegId in argument
    if (arrScripsReponse?.length > 0) {
        const arrWatchlistGridData = arrScripsReponse.map((element) => {
            const arrWatchlistIndex = Object.values(WATCHLIST_GRID_INDEX).sort((a, b) => a - b);
            const arrWatchlistGridRowData = new Array(arrWatchlistIndex[arrWatchlistIndex.length - 1] + 1).fill('0.00');
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.ASK_QTY] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.BID_QUANTITY] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.DONT_MISS] = '';
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.VOLUME] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] = element.MktSegId;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = element.nMarketSegmentId;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOKEN] = element.nToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = element.MktSegId + '_' + element.nToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL] = element.sSymbol;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE] = element.sExchange;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SERIES] = element.sSeries;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] = element.sInstrumentName;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] = element.nExpiryDate1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] = element.nStrikePrice1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE] = element.sOptionType;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = element.DecimalLocator;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = getDynamicParamsForToFixed(element.ExchangeSegment);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = element.nAssetToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_TICK] = (element.nPriceTick / element.DecimalLocator);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.NSPREAD] = element.nSpread;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.REGULAR_LOT] = element.nRegularLot;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] = element.sSurvMeasureDescription;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [];
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DONT_MISS] = element?.dontMiss ? element?.dontMiss : [];
            //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR] = element.nPriceNum ? element.nPriceNum : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR] = element.nPriceDen ? element.nPriceDen : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN] = element.nAVMBuyMargin ? element.nAVMBuyMargin : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN] = element.nAVMSellMargin ? element.nAVMSellMargin : 1;
            //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Esnd
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] = element.nMaxSingleTransactionQty; //BT-138033 : Order Slicing: ManasaB : 26-06-2024 
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.IS_FO_EXIST] = element?.nFOExists;
            //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = element?.sQtyUnit?.trim() || 'Qty';
            //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
            //Vaibhav Singh: 16-12-23: BT-107055: ISIN code added : start
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] = element?.sISINCode;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] = element?.nIssuedCapital === ('' || undefined || null) ? '0' : element?.nIssuedCapital;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ASSET_SEGMENT_ID] = getMktSegIdFromApiExchangeName(getAssetExchangeNameFromMktSegId(element.MktSegId));
            //Vaibhav Singh: 16-12-23: BT-107055: ISIN code added : End
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.SECURITY_DESCRIPTION] = element?.sSecurityDesc; //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order 
            if (element?.nExpiryDate === 0) {
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL];
            } else {
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE];
            }
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SECTOR] = element.sSector;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = element.ExchangeSegment;
            if (convertScreener) {
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = element?.nLTP;
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = element?.nPercChange;
            }
            return arrWatchlistGridRowData;
        });
        return arrWatchlistGridData;
    } else {
        return [];
    }
}
//Vaibhav Singh: 06-03-24: Added for Popover: End
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start


export function convertDataIntoOptionChainIndex(arrOptionChainData = []) {
    if (arrOptionChainData?.length > 0) {
        const arrWatchlistGridData = arrOptionChainData.map((element, index) => {
            const arrOptionChainIndex = Object.values(OPTION_CHAIN_GRID_INDEX).sort((a, b) => a - b);
            let arrOptionChainGridRowData = new Array(arrOptionChainIndex[arrOptionChainIndex.length - 1] + 1).fill('0.00');
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.STRIKE_PRICE] = element?.STRIKE_PRICE;
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.ID_FOR_OPTION_CHAIN_GRID] = index;
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN] = element?.callId + '_CALL';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE] = element?.putId + '_PUT';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = false;
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = false;
            return arrOptionChainGridRowData;
        });
        return arrWatchlistGridData;
    } else {
        return [];
    }
}


export function convertLiveResponseIntoOptionGridIndexForCall(arrVisibleRows, arrLiveData) {
    let arrVisibleRowscopy = arrVisibleRows?.map((eachItem) => {
        let eachItemCopy = eachItem;
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.DELTA_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.VEGA_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.GAMMA_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.THETA_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.IV_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.VOLUME_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.OI_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.LTP_CALL] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        return eachItemCopy;
    });
    return arrVisibleRowscopy;
}

export function convertLiveResponseIntoOptionGridIndexForPut(arrVisibleRows, arrLiveData) {
    let arrVisibleRowscopy = arrVisibleRows?.map((eachItem) => {
        let eachItemCopy = eachItem;
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.LTP_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.OI_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.VOLUME_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.IV_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.THETA_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.GAMMA_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.VEGA_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];
        eachItemCopy[OPTION_CHAIN_GRID_INDEX.DELTA_PUT] = arrLiveData[TL_INDEX.LAST_TRADE_PRICE];

        return eachItemCopy;
    });
    return arrVisibleRowscopy;
}

function convertAlertToWatchlistGrid(objAlert) {
    const arrAlert = convertScripResponseWatchlistGrid([objAlert?.scripObj]);



    // const arrAlert = Array(Object.keys(WATCHLIST_GRID_INDEX)?.length)?.fill('');
    // arrAlert[WATCHLIST_GRID_INDEX.SEGMENT_ID] = objAlert?.segmentId;
    // arrAlert[WATCHLIST_GRID_INDEX.TOKEN] = objAlert?.nToken;
    // arrAlert[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = objAlert?.mktIdToken;
    // arrAlert[WATCHLIST_GRID_INDEX.SYMBOL] = objAlert?.symbol;
    // arrAlert[WATCHLIST_GRID_INDEX.EXCHANGE] = objAlert?.exchange;
    // arrAlert[WATCHLIST_GRID_INDEX.SERIES] = objAlert?.series;
    // arrAlert[WATCHLIST_GRID_INDEX.INSTRUMENT] = objAlert.instrument;
    // arrAlert[WATCHLIST_GRID_INDEX.EXPIRYDATE] = objAlert.expiryDate;
    // arrAlert[WATCHLIST_GRID_INDEX.STRIKEPRICE] = objAlert.nStrikePrice1;
    // arrAlert[WATCHLIST_GRID_INDEX.OPTIONTYPE] = objAlert.optionType;
    // arrAlert[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = objAlert.segmentId;
    // arrAlert[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = objAlert.decimalLocator;
    // arrAlert[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION] = objAlert.securityDesc;
    // arrAlert[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = getDynamicParamsForToFixed(objAlert?.exchange);
    // arrAlert[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = objAlert.assetToken;
    // arrAlert[WATCHLIST_GRID_INDEX.DONT_MISS] = objAlert?.dontMiss;
    // arrAlert[WATCHLIST_GRID_INDEX.ISIN_CODE] = objAlert?.sISINCode; //Azeem K : 16-12-2023 :adde ISIN code


    if (arrAlert?.length > 0) {
        return arrAlert[0];

    } else {
        return [];
    }
}
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End
//abhijeetvarude : 2023-05-25 :scrip responce to constituents data format - Start

function convertScripResponseConstituents(arrScripsReponse, indiceSegmentID) {
    if (arrScripsReponse?.length > 0) {
        //Vaibhav Singh:01-03-24: Issue Fixed for Indices : Start
        const arrWatchlistGridData = arrScripsReponse.map((element) => {
            const exchangeData = indiceSegmentID === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT ? element?.ScripData_NSE : indiceSegmentID === DISPLAY_EXCHANGE_NAME.BSE_EXCHANGE_TEXT ? element?.ScripData_BSE : undefined;
            const mktSegId = getMktSegIdFromMappedMktSegId(exchangeData?.MarketSegmentId); // Hari K:22-08-2024 converted  mapped segment to market segment
            const nToken = exchangeData?.ODINCode;
            const arrWatchlistIndex = Object.values(WATCHLIST_GRID_INDEX).sort((a, b) => a - b);
            const arrWatchlistGridRowData = new Array(arrWatchlistIndex[arrWatchlistIndex.length - 1] + 1).fill("0");
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] = mktSegId;
            // Deepti B. [BT-107398]: adjested market segment id field according to api response --start
            // arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = element.nMarketSegmentId;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = indiceSegmentID === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT ? element.ScripData_NSE.MarketSegmentId : element.ScripData_BSE.MarketSegmentId;
            // Deepti B. [BT-107398]: adjested market segment id field according to api response --end
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOKEN] = nToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = mktSegId + '_' + nToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL] = element?.Symbol;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE] = exchangeData !== "-" ? indiceSegmentID : null;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SERIES] = exchangeData?.Series;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = exchangeData !== "-" ? parseFloat(element.Price)?.toFixed(2) : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LTP_PERCENT] = exchangeData !== "-" ? parseFloat(element.Change)?.toFixed(2) : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = exchangeData !== "-" ? parseFloat(element.PriceDifference)?.toFixed(2) : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.BID_PRICE] = exchangeData !== "-" ? parseFloat(element.PreviousClosePrice)?.toFixed(2) : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = getDecimalLocatorFromApiExchangeName(exchangeData !== "-" ? indiceSegmentID : null);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = getDynamicParamsForToFixed(exchangeData !== "-" ? indiceSegmentID : null);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] = exchangeData !== "-" ? element.sInstrumentName : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] = exchangeData !== "-" ? element.nExpiryDate1 : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] = exchangeData !== "-" ? element.nStrikePrice1 : (0).toFixed(2);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE] = exchangeData !== "-" ? element.sOptionType : (0).toFixed(2);
            return arrWatchlistGridRowData;
        });
        //Vaibhav Singh:01-03-24: Issue Fixed for Indices : End
        return arrWatchlistGridData;
    } else {
        return [];
    }
}
//abhijeetvarude : 2023-05-25 :scrip responce to constituents data format - End

//abhijeetvarude : 2023-05-25 :scrip responce to constituents data format - Start
// {
//     "IndexID": "38",
//     "sIndexDesc": "Nasdaq 100",
//     "price": "14298.41",
//     "profit": "359.88",
//     "loss": "2.58",
//     "date": "27-May-2023 04:30:00"
// }
function convertScripResponseGlobalIndices(arrScripsReponse) {
    if (arrScripsReponse?.length > 0) {
        const arrWatchlistGridData = arrScripsReponse.map((element) => {
            const mktSegId = element?.ScripData_NSE?.MarketSegmentId;
            const nToken = element?.ScripData_NSE?.ODINCode;
            const arrWatchlistIndex = Object.values(CONSTITUENTS_GRID_INDEX).sort((a, b) => a - b);
            const arrWatchlistGridRowData = new Array(arrWatchlistIndex[arrWatchlistIndex.length - 1] + 1).fill("0");
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.SEGMENT_ID] = mktSegId;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.MAPPED_SEGMENT_ID] = element.nMarketSegmentId;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.TOKEN] = nToken;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.SEGMENT_ID_TOKEN] = mktSegId + '_' + nToken;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.SYMBOL] = element?.sIndexDesc;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.LAST_TRADE_PRICE] = element?.price;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.LTP_PERCENT] = element?.loss;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.CHANGE_IN_LTP] = element?.profit;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.MIN_CHART] = element?.date;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.DON] = element?.date;
            arrWatchlistGridRowData[CONSTITUENTS_GRID_INDEX.COUNTRY] = element?.country;
            return arrWatchlistGridRowData;
        });
        return arrWatchlistGridData;
    } else {
        return [];
    }
}
//abhijeetvarude : 2023-05-25 :scrip responce to constituents data format - End

/* Neha Kumari : 20-07-23 : Market Depth Grid data  --> start  */
function getBidAndAskGridRowData(arrBestfiveLiveData) {
    const arrMarketDepthGridData = convertBestFiveResponseToMarketDepthGrid(arrBestfiveLiveData);
    const arrBidData = arrMarketDepthGridData?.slice(MARKETDEPTH_INDEX.BUY_QTY_1, MARKETDEPTH_INDEX.BUY_PRICE_5 + 1);
    const arrAskData = arrMarketDepthGridData?.slice(MARKETDEPTH_INDEX.SELL_PRICE_1, MARKETDEPTH_INDEX.SELL_QTY_5 + 1);
    const arrBidPer = arrMarketDepthGridData?.slice(MARKETDEPTH_INDEX.BUY_QTY_PERCENT_1, MARKETDEPTH_INDEX.BUY_QTY_PERCENT_5 + 1);
    const arrAskPer = arrMarketDepthGridData?.slice(MARKETDEPTH_INDEX.SELL_QTY_PERCENT_1, MARKETDEPTH_INDEX.SELL_QTY_PERCENT_5 + 1);
    const arrBidGridData = [];
    const arrAskGridData = [];
    //Vaibhav Singh: 01-12-23:BT-109089:  Adding '-' in AMrket depth in case of no data: Start
    for (let i = 0; i < arrBidData?.length; i += 3) {
        arrBidGridData.push({ id: arrMarketDepthGridData[MARKETDEPTH_INDEX.SEGMENT_ID] + '_' + arrMarketDepthGridData[MARKETDEPTH_INDEX.TOKEN] + '_' + i, qty: parseFloat(arrBidData[i]) ? arrBidData[i] : '-', orders: parseFloat(arrBidData[i + 1]) ? arrBidData[i + 1] : '-', bid: parseFloat(arrBidData[i + 2]) ? arrBidData[i + 2] : '-', exchange: getExchangeName(arrMarketDepthGridData[MARKETDEPTH_INDEX.SEGMENT_ID]), percent: parseFloat(arrBidPer[i]) });
    }

    for (let i = 0; i < arrAskData?.length; i += 3) {
        arrAskGridData.push({
            id: arrMarketDepthGridData[MARKETDEPTH_INDEX.SEGMENT_ID] + '_' + arrMarketDepthGridData[MARKETDEPTH_INDEX.TOKEN] + '_' + i,
            ask: parseFloat(arrAskData[i]) ? arrAskData[i] : '-',
            orders: parseFloat(arrAskData[i + 1]) ? arrAskData[i + 1] : '-',
            qty: parseFloat(arrAskData[i + 2]) ? arrAskData[i + 2] : '-',
            exchange: getExchangeName(arrMarketDepthGridData[MARKETDEPTH_INDEX.SEGMENT_ID]),
            percent: ''
        });
        //Vaibhav Singh: 01-12-23:BT-109089: Adding '-' in AMrket depth in case of no data: End
    }
    // Vaibhav Singh: 29-10-24: This adds a new field called percent in ask and bid object
    arrAskGridData.forEach((obj, i) => {
        obj.percent = arrAskPer[i];
    });
    arrBidGridData.forEach((obj, i) => {
        obj.percent = arrBidPer[i];
    });
    return [arrBidGridData, arrAskGridData, arrBidPer, arrAskPer];
}
/* Neha Kumari : 20-07-23 : Market Depth Grid data  --> start  */

function convertBestFiveResponseToMarketDepthGrid(arrScripsReponse) {
    // Scrips API Response from getScripbyTokenAndMktSegId in argument
    const arrMarketDepthIndex = Object.values(MARKETDEPTH_INDEX).sort((a, b) => a - b);
    const arrMarketDepthGridRowData = new Array(arrMarketDepthIndex[arrMarketDepthIndex.length - 1] + 1).fill("0");
    if (arrScripsReponse?.length > 0) {
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SEGMENT_ID] = arrScripsReponse[BEST5_INDEX.SEGMENT_ID];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.TOKEN] = arrScripsReponse[BEST5_INDEX.TOKEN];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.OPEN_PRICE] = arrScripsReponse[BEST5_INDEX.OPEN_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.CLOSE_PRICE] = arrScripsReponse[BEST5_INDEX.CLOSE_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.HIGH_PRICE] = arrScripsReponse[BEST5_INDEX.HIGH_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.LOW_PRICE] = arrScripsReponse[BEST5_INDEX.LOW_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.LIFE_TIME_HIGH] = arrScripsReponse[BEST5_INDEX.LIFE_TIME_HIGH];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.LIFE_TIME_LOW] = arrScripsReponse[BEST5_INDEX.LIFE_TIME_LOW];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.AVG_TRADED_PRICE] = arrScripsReponse[BEST5_INDEX.AVG_TRADED_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.VOLUME] = arrScripsReponse[BEST5_INDEX.VOLUME];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_1] = arrScripsReponse[BEST5_INDEX.BUY_QTY_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_BUY_ORDER_1] = arrScripsReponse[BEST5_INDEX.NO_OF_BUY_ORDER_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_PRICE_1] = arrScripsReponse[BEST5_INDEX.BUY_PRICE_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_2] = arrScripsReponse[BEST5_INDEX.BUY_QTY_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_BUY_ORDER_2] = arrScripsReponse[BEST5_INDEX.NO_OF_BUY_ORDER_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_PRICE_2] = arrScripsReponse[BEST5_INDEX.BUY_PRICE_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_3] = arrScripsReponse[BEST5_INDEX.BUY_QTY_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_BUY_ORDER_3] = arrScripsReponse[BEST5_INDEX.NO_OF_BUY_ORDER_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_PRICE_3] = arrScripsReponse[BEST5_INDEX.BUY_PRICE_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_4] = arrScripsReponse[BEST5_INDEX.BUY_QTY_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_BUY_ORDER_4] = arrScripsReponse[BEST5_INDEX.NO_OF_BUY_ORDER_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_PRICE_4] = arrScripsReponse[BEST5_INDEX.BUY_PRICE_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_5] = arrScripsReponse[BEST5_INDEX.BUY_QTY_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_BUY_ORDER_5] = arrScripsReponse[BEST5_INDEX.NO_OF_BUY_ORDER_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_PRICE_5] = arrScripsReponse[BEST5_INDEX.BUY_PRICE_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_PRICE_1] = arrScripsReponse[BEST5_INDEX.SELL_PRICE_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_SELL_ORDER_1] = arrScripsReponse[BEST5_INDEX.NO_OF_SELL_ORDER_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_1] = arrScripsReponse[BEST5_INDEX.SELL_QTY_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_PRICE_2] = arrScripsReponse[BEST5_INDEX.SELL_PRICE_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_SELL_ORDER_2] = arrScripsReponse[BEST5_INDEX.NO_OF_SELL_ORDER_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_2] = arrScripsReponse[BEST5_INDEX.SELL_QTY_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_PRICE_3] = arrScripsReponse[BEST5_INDEX.SELL_PRICE_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_SELL_ORDER_3] = arrScripsReponse[BEST5_INDEX.NO_OF_SELL_ORDER_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_3] = arrScripsReponse[BEST5_INDEX.SELL_QTY_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_PRICE_4] = arrScripsReponse[BEST5_INDEX.SELL_PRICE_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_SELL_ORDER_4] = arrScripsReponse[BEST5_INDEX.NO_OF_SELL_ORDER_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_4] = arrScripsReponse[BEST5_INDEX.SELL_QTY_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_PRICE_5] = arrScripsReponse[BEST5_INDEX.SELL_PRICE_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NO_OF_SELL_ORDER_5] = arrScripsReponse[BEST5_INDEX.NO_OF_SELL_ORDER_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_5] = arrScripsReponse[BEST5_INDEX.SELL_QTY_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.TOTAL_BUY_QTY] = arrScripsReponse[BEST5_INDEX.TOTAL_BUY_QTY];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.TOTAL_SELL_QTY] = arrScripsReponse[BEST5_INDEX.TOTAL_SELL_QTY];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SYMBOL] = arrScripsReponse[BEST5_INDEX.SYMBOL];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.EXCHANGE] = arrScripsReponse[BEST5_INDEX.EXCHANGE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.LAST_TRADE_PRICE] = arrScripsReponse[BEST5_INDEX.LAST_TRADE_PRICE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NET_CHANGE_INDICATOR] = arrScripsReponse[BEST5_INDEX.NET_CHANGE_INDICATOR];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = arrScripsReponse[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.DAILY_PRICE_RANGE] = arrScripsReponse[BEST5_INDEX.DAILY_PRICE_RANGE];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_PERCENT_1] = arrScripsReponse[BEST5_INDEX.BUY_QTY_PERCENT_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_PERCENT_2] = arrScripsReponse[BEST5_INDEX.BUY_QTY_PERCENT_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_PERCENT_3] = arrScripsReponse[BEST5_INDEX.BUY_QTY_PERCENT_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_PERCENT_4] = arrScripsReponse[BEST5_INDEX.BUY_QTY_PERCENT_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.BUY_QTY_PERCENT_5] = arrScripsReponse[BEST5_INDEX.BUY_QTY_PERCENT_5];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_PERCENT_1] = arrScripsReponse[BEST5_INDEX.SELL_QTY_PERCENT_1];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_PERCENT_2] = arrScripsReponse[BEST5_INDEX.SELL_QTY_PERCENT_2];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_PERCENT_3] = arrScripsReponse[BEST5_INDEX.SELL_QTY_PERCENT_3];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_PERCENT_4] = arrScripsReponse[BEST5_INDEX.SELL_QTY_PERCENT_4];
        arrMarketDepthGridRowData[MARKETDEPTH_INDEX.SELL_QTY_PERCENT_5] = arrScripsReponse[BEST5_INDEX.SELL_QTY_PERCENT_5];


    } else { }

    return arrMarketDepthGridRowData;
}
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
let ADD_END_DUM_NOTICE_GRID_REF = null;
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End
let WATCHLIST_GRID_REF = null;
let MULTISCRIP_ORDER_CART_GRID_REF = null;
let ORDERS_GRID_REF = null;
let NETPOSITION_GRID_REF = null;
let HOILDING_GRID_REF = null;
let ORDERCART_GRID_REF = null;
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
let ORDER_ENTRY_GRID_REF = null;
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
let HEAT_MAP_REF = null;
let ORDERBOOK_IPO_REF = null;

/*Mahesh S  : 02-05-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
let LOGIN_QR_INTERVAL = null;

let INFINITY_GRID_REF = null;

let ADDENDUM_STATUS_MODAL_REF = null;
let USED_MARGIN_MODAL_GRID_REF = null;
let MUTUAL_FUND_HOLDINGS_GRID_REF = null;
let MUTUAL_FUND_ORDERS_REF = null;
let COMMENTRY_GRID_REF = null;
function setAddendumStatusModalGridRef(obj) {
    ADDENDUM_STATUS_MODAL_REF = obj;
}
function setUsedMarginModalGridRef(obj) {
    USED_MARGIN_MODAL_GRID_REF = obj;
}
function setMutualFundHoldingGridRef(obj) {
    MUTUAL_FUND_HOLDINGS_GRID_REF = obj;
}
function setMutualFundOrdersGridRef(obj) {
    MUTUAL_FUND_ORDERS_REF = obj;
}
function setCommentryGridRef(obj) {
    COMMENTRY_GRID_REF = obj;
};


function setInfinityGridRef(obj) {
    INFINITY_GRID_REF = obj;
};

function setLoginQRInterval(objTime) {
    LOGIN_QR_INTERVAL = objTime;
}

function clearLoginQRInterval() {
    clearInterval(LOGIN_QR_INTERVAL);
}
/*Mahesh S  : 02-05-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - End */

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
function setOrderEntryModalRef(objRef) {
    ORDER_ENTRY_GRID_REF = objRef;
}
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
function setOrderbookIpoRef(objGridRef) {
    ORDERBOOK_IPO_REF = objGridRef;
}
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
function setAddendumNoticeGridref(objGridRef) {
    ADD_END_DUM_NOTICE_GRID_REF = objGridRef;
}
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End
function setGridRef(objGridRef) {
    WATCHLIST_GRID_REF = objGridRef;
}

//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
let SCREENERS_HOLDINGS_GRID_REF = null;
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End

//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
function setScreenersGoldingsGrifRef(objGridRef) {
    SCREENERS_HOLDINGS_GRID_REF = objGridRef;
}
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End
function setMultiScripOrderCartGridRef(objGridRef) {
    MULTISCRIP_ORDER_CART_GRID_REF = objGridRef;
}
function setOrdersGridRef(objGridRef) {
    ORDERS_GRID_REF = objGridRef;
}
function setNetPositionGridRef(objGridRef) {
    NETPOSITION_GRID_REF = objGridRef;
}
function setHoldingsGridRef(objGridRef) {
    HOILDING_GRID_REF = objGridRef;
}

function setHeatMapGridRef(objGridRef) {
    HEAT_MAP_REF = objGridRef;
}

function setOrderCartGridRef(objGridRef) {
    ORDERCART_GRID_REF = objGridRef;
}

let MUTUAL_FUNDS_WATCHLIST_GRID = null;

function setMutualFundsWatchlistGrid(objGridRef) {
    MUTUAL_FUNDS_WATCHLIST_GRID = objGridRef;
}
function setHoldingpPortfolioGrid(objGridRef) {
    HOILDING_GRID_REF = objGridRef;
}
//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - Start
let FUTURE_GRID_REF = null;

function setFutureTabGridRef(objGridRef) {
    FUTURE_GRID_REF = objGridRef;
}
//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start
let LIVE_PULSE_GRID_REF = null;
function setLivePulseGridRef(objGridRef) {
    LIVE_PULSE_GRID_REF = objGridRef;
}
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End

let ALERT_GRID_REF = null;
function setAlertGridRef(objGridRef) {
    ALERT_GRID_REF = objGridRef;
}

function deepClone(data) {
    return cloneDeep(data);
}


function setActiveTheme() {
    const strActiveTheme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);
    if (strActiveTheme && strActiveTheme === 'dark') {
        document.body.classList.add('dark');
    } else {
        document.body.classList.remove('dark');
    }

}

function capitalizeFirstLetter(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
}

// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - getting blank pdf – Start
const createAndDownLoadPDF = (pdfName = '', pageSize = 'A4', pageOrientation = 'landscape', content = [], styles = {}) => {
    // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - getting blank pdf – Start
    //Ameersha N - BT-109369 Breeze- Watchlist- Share Watchlist issue - Making pdf function was changed according to requirements --start
    const docDefinition = {
        pageSize: pageSize,
        pageOrientation: pageOrientation,
        content: [...content],
        styles: { ...styles }
    };
    //Ameersha N - BT-109369 Breeze- Watchlist- Share Watchlist issue - Making pdf function was changed according to requirements --End
    // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - getting blank pdf – End


    pdfMake.createPdf(docDefinition).getBlob((blob) => {
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = pdfName;

        a.click();

        window.URL.revokeObjectURL(url);
    });

};

function onChangeToggleTheme(isDark) {
    if (isDark) {
        document.body.classList.add('dark');
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.THEME, 'dark');
    } else {
        document.body.classList.remove('dark');
        localStorage.removeItem(LOCAL_STORAGE_KEYS.THEME);
    }
}


function bIsProd() {
    return HIDE_FEATURES;
}




/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */

function getIsConfigExist() {

    if (config.bIsProd === 'true') {
        return true;
    } else {
        let objEnvSettings = TripleDESDecrypt(localStorage.getItem(LOCAL_STORAGE_KEYS.ENV_SETTINGS));
        if (objEnvSettings) {
            const { TenantId, URL } = JSON.parse(objEnvSettings);
            if (TenantId && URL) {
                config.TenantId = TenantId;
                config.Wave.URL = URL;
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}


function getAppInfoData(paramsName, appInfo = [], defValue = '') {
    try {
        if (appInfo && appInfo.length > 0) {
            let nIndex = appInfo.findIndex(function (appInfo) {
                return appInfo?.sParamName === paramsName && appInfo?.sTenantId === config.TenantId;
            });
            if (nIndex >= 0) {
                try {
                    return JSON.parse(appInfo[nIndex]?.sParamValue);
                }
                catch {
                    return appInfo[nIndex]?.sParamValue;
                }
            } else {
                nIndex = appInfo.findIndex(function (appInfo) {
                    return appInfo?.sParamName === paramsName && appInfo?.sTenantId === LOGIN_CONSTANTS.CHIEF_TENANT_ID.toString();
                });
                if (nIndex >= 0) {
                    try {
                        return JSON.parse(appInfo[nIndex]?.sParamValue);
                    }
                    catch {
                        return appInfo[nIndex]?.sParamValue;
                    }
                } else {
                    return defValue;
                }
            }
        } else {
            return defValue;
        }
    }
    catch (e) {
        console.error(e);
        return defValue;
    }
}

async function onUserLoggedInActiveSession(objLoginSession, dispatch, handleDoneMessage, appInfo, userId = '') {
    let activeSession;
    let activeUserDetails = JSON.parse(getDecryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userId}`));
    if (objLoginSession?.data?.reg_date) {
        activeSession = { ...objLoginSession, guestMode: true, userId: userId };
        config.WFH = ''; // NEED TO CHECK WFH FOR GUEST LOGIN
        activeUserDetails = {
            ...activeUserDetails,
            ...activeSession
        };
    }
    else {
        config.WFH = objLoginSession?.data?.others?.broadCastSocket;
        activeSession = { ...objLoginSession };
        //BT-115082 : Creating common function for search : Generating ViewAllowed : ManasaB : 03/08/2023 - Start
        const nViewAllowed = getViewAllowed(objLoginSession);
        activeSession.nExchangesViewAllowed = nViewAllowed;
        //Prachi Tawde : 13-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
        activeUserDetails = {
            ...activeUserDetails,
            data: objLoginSession?.data,
            userId: objLoginSession?.data?.user_id,
            userName: objLoginSession?.data?.user_name,
            isMPINEnable: objLoginSession?.data?.mpin_enabled,
            isFingerprint: objLoginSession?.data?.fingerprint_enabled,
            lastLoginTime: objLoginSession?.lastLoginTime || objLoginSession?.data?.login_time,
            isTOTPEnable: objLoginSession?.data?.totp_enabled,
            bIsDefault: activeUserDetails?.bIsDefault || false,
            nExchangesViewAllowed: nViewAllowed,
            aliasId: objLoginSession?.data?.alias_id
        };
        //BT-115082 : Creating common function for search : Generating ViewAllowed : ManasaB : 03/08/2023 - End
        //Prachi Tawde : 13-07-2023 : BT-108578 -  Breeze - Quick user switch - End
    }
    setEncryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION, JSON.stringify(activeSession));
    //Prachi Tawde : 04-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
    //along with other user-details also set data( userinfo ) in localStorage
    if (userId) {
        setEncryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userId}`, JSON.stringify(activeUserDetails));
    } else { }
    localStorage.removeItem(LOCAL_STORAGE_KEYS.IS_PASSWORD_CHANGED);
    //Prachi Tawde : 04-07-2023 : BT-108578 -  Breeze - Quick user switch - End
    // sip settings

    // ---get_CFT_object---- SrikanthRao-Start
    const cft = getClientFacilityTemplate(objLoginSession?.data?.others?.CFT, appInfo, dispatch);
    dispatch(updateCft(cft));
    // ---get_CFT_object---- SrikanthRao-End
    if (!isGuestUser()) {
        const udid = uuidv4() || '';
        const pluginData = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.DEVICE_INFO)) || {};
        pluginData.UDID = udid;
        const payload = {
            "Type": 3,
            "userId": userId,
            "groupId": objLoginSession?.data?.others?.groupId,
            "userType": "R",
            "email": "",
            "mobile": "",
            "deviceType": "T",
            "pluginData": pluginData
        };

        dispatch(setRegistrationDetails(payload));
    }
    const strNavigationPage = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE);
    handleDoneMessage().then(() => {
        const landingPage = getAppInfoData(APP_INFO_PARAMS?.APP_GUEST_USER_LANDING_PAGE, appInfo);
        if (objLoginSession?.data?.trial_expired === false && landingPage) {
            if (parseInt(landingPage) === 2) {
                window.location.href = LOCATIONS.DASHBOARD;
            }
            else {
                window.location.href = LOCATIONS.WATCHLIST;
            }
        }
        else if (strNavigationPage) {
            window.location.href = '/' + strNavigationPage;
        } else {
            window.location.href = defaultLandingPage(appInfo);
        }
    });
    // await dispatch(appDetailsByUser());
    dispatch(getProductTypes());
    if (!isGuestUser()) {
        dispatch(getSipSettingDetails());
    } else {

    }

}

const defaultLandingPage = (appInfo) => {
    // BREEZE : 4266 : DEFAULT LANDING PAGE : WiLL CREATE A CHECK HERE WITH THE VALUE THAT COMES FROM MOBILE ADMIN AND MAKE THAT PAGE LOAD ONCE LOGGED IN IF NO DEFAULT_STORAGE AVAILABLE IN LOCALSTORAGE
    let selectedLandingPage = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE);
    if (!selectedLandingPage) {
        let defLandingPage = getAppInfoData(APP_INFO_PARAMS?.APP_REGISTER_USERLANDINGPAGE_BREEZE, appInfo, 0);
        return LANDING_PAGE_INDEX?.[defLandingPage];
    } else {
        return selectedLandingPage;
    }
};

//Kamesh Rane 01-08-2023 global ref
let INDICES_REF = null;
let MY_SUMMARY_REF = null;
let INVESTMENTS_REF = null;
let SCREENER_REF = null;
let LIVE_PULSE_REF = null;
let NEWS_REF = null;
let EVENT_REF = null;
let RECOMMENDATION_REF = null;
function setIndicesRef(objGridRef) {
    INDICES_REF = objGridRef;
}
function setMySummaryRef(objGridRef) {
    MY_SUMMARY_REF = objGridRef;
}
function setInvestmentsRef(objGridRef) {
    INVESTMENTS_REF = objGridRef;
}
function setScreenersRef(objGridRef) {
    SCREENER_REF = objGridRef;
}
function setLivePulseRef(objGridRef) {
    LIVE_PULSE_REF = objGridRef;
}

function setNewsRef(objGridRef) {
    NEWS_REF = objGridRef;
}
function setEventsRef(objGridRef) {
    EVENT_REF = objGridRef;
}
function setRecommendationsRef(objGridRef) {
    RECOMMENDATION_REF = objGridRef;
}

/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - End */

function getUserLoggedIn() {
    let objStorageLoginSession = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
    if (objStorageLoginSession) {
        objStorageLoginSession = JSON.parse(objStorageLoginSession);
        if (objStorageLoginSession?.data?.access_token) {
            return objStorageLoginSession;
        } else {
            // Ameersha N : 12-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.REJECTED_NOTICES_ID);
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.CHECKBOX_NOTICES_ID);
            // Ameersha N : 12-02-2024 : BT-116461 Breeze - Addendum and Notices --End
            return false;
        }
    } else {
        // Ameersha N : 12-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.REJECTED_NOTICES_ID);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.CHECKBOX_NOTICES_ID);
        // Ameersha N : 12-02-2024 : BT-116461 Breeze - Addendum and Notices --End
        return false;
    }
}

function postDataToChart(data) {
    //to handle multiple frame return from getElementsByTagName.
    // if (document.getElementsByTagName("iframe")[0]?.id == "chartObject")//means quotes frame.
    //     frame = Array.from(document.getElementsByTagName("iframe"))?.find(el=>el?.id==='chartObject')?.contentWindow;
    // else
    //     frame = Array.from(document.getElementsByTagName("iframe"))?.find(el=>el?.id==='chartObject')?.contentWindow;//means only one frame available. 
    //Above code is commented as if and else perform same action writing new condition below
    var frame;
    if (Array?.from(document.getElementsByTagName("iframe"))?.length) {
        frame = Array?.from(document.getElementsByTagName("iframe"))?.find(el => el?.id === 'chartObject')?.contentWindow;
        frame?.postMessage(data, '*');
    } else { }
}

function sendDataToChartBestFive(bestFive, scripData) {
    try {
        let data = {
            messageCode: 'chartiq-bCast',
            data: { //Vaibhav Singh : BT-117493 : 13-09-2023 : Removed division by decimal locator
                Scrip: { MktSegId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], Token: scripData[WATCHLIST_GRID_INDEX.TOKEN] },
                LUT: bestFive[BEST5_INDEX.LAST_UPDATED_TIME].replaceAll(':', ""),
                LTT: bestFive[BEST5_INDEX.LAST_TRADE_TIME].replaceAll(':', ""),
                LTP: bestFive[BEST5_INDEX.LAST_TRADE_PRICE],
                LTQ: bestFive[BEST5_INDEX.LAST_TRADE_QTY],
                Volume: bestFive[BEST5_INDEX.VOLUME],
                ClosePrice: bestFive[BEST5_INDEX.CLOSE_PRICE],
                OpenPrice: bestFive[BEST5_INDEX.OPEN_PRICE],
                HighPrice: bestFive[BEST5_INDEX.HIGH_PRICE],
                LowPrice: bestFive[BEST5_INDEX.LOW_PRICE]
            }
        };
        // let objectChart = document.getElementById("chartObject")?.contentWindow;
        // if (objectChart) {
        //     objectChart.postMessage(data, "*");
        // }

        postDataToChart(data);
    } catch (error) {
        console.error(error);
    }
}

function sendDataToChart(touchlineData, scripData) {
    try {
        let data = {
            messageCode: 'chartiq-bCast',
            data: { //Vaibhav Singh : BT-117493 : 13-09-2023 : Removed division by decimal locator
                Scrip: { MktSegId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], Token: scripData[WATCHLIST_GRID_INDEX.TOKEN] },
                LUT: touchlineData[TL_INDEX.LAST_UPDATED_TIME].replaceAll(':', ""),
                LTT: touchlineData[TL_INDEX.LAST_TRADE_TIME].replaceAll(':', ""),
                LTP: touchlineData[TL_INDEX.LAST_TRADE_PRICE],
                LTQ: touchlineData[TL_INDEX.LAST_TRADE_QTY],
                Volume: touchlineData[TL_INDEX.VOLUME],
                ClosePrice: touchlineData[TL_INDEX.CLOSE_PRICE],
                OpenPrice: touchlineData[TL_INDEX.OPEN_PRICE],
                HighPrice: touchlineData[TL_INDEX.HIGH_PRICE],
                LowPrice: touchlineData[TL_INDEX.LOW_PRICE]
            }
        };
        // let objectChart = document.getElementById("chartObject")?.contentWindow;
        // if (objectChart) {
        //     objectChart.postMessage(data, "*");
        // }

        postDataToChart(data);
    } catch (error) {
        console.error(error);
    }
}

//abhijeetvarude : 31-03-2023 : create chart url - Start
//Vaibhav SIngh : BT-117493 : 13-09-2023 : added lookup checkup for analysis and watchlist side tray Updated :18-02-24: Start
function createChartUrl(mktsegid, token, chartAttributes, localToggleData = "") {
    // Get User id from auth reducer
    let userId = '';
    //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: Start
    let chartUrl = '';
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).startsWith(LOCAL_STORAGE_KEYS.USER_DETAILS)) {
            let key = localStorage.key(i);
            let value = getDecryptLocalStorage(key);

            if (value) {
                userId = JSON.parse(value)?.userId;
            }
            else { }
        }
    }
    if (chartAttributes.nChartUrl) {
        if (chartAttributes?.nMultiChartPresent) {
            if (localToggleData) {
                chartUrl = localToggleData?.endpoint;
            } else {
                const chartId = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.PREFFERED_CHART));
                chartUrl = chartId?.endpoint;
            }
        } else {
            chartUrl = chartAttributes?.nChartUrl;
        }
        const strActiveTheme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);
        return chartUrl  //key
            + "broadcastMode=" + chartAttributes.nChartBrodcast //'n' //this.broadcastMode
            + "&range=y"
            + "&ver=v1"
            + "&mode=adv"
            + "&pid=21"
            + "&mktsegid=" + mktsegid
            + "&tkn=" + token
            + "&period=1"
            + "&interval=" + chartAttributes.nChartInterval //"MIN" //KEY
            + "&style=" + chartAttributes.nChartStyle//"candle" //KEY
            + "&span="
            + "&continuous="
            // + "&lookup=" + lookup // dont remove might need for later //Vaibhav Singh: BT-113703 : 31-08-2023 : added Compare button in chratIQ
            + "&title=y"
            + "&headsup=y"
            + "&xaxis=y"
            + "&yaxis=y"
            + "&hdr=y"
            + "&zoom=y"
            + "&buysell=n"
            + "&theme=" + (strActiveTheme === THEME_TYPE.DARK ? 'n' : 'd')//(CHART_URL_CONFIG.THEME == "light" ? "d" : "n")
            + "&group=g1"
            + "&apikey=" + chartAttributes.nChartApiKey //"ABCD12233" //key
            + "&uid=" + userId;
    } else {
        return '';
    }
    //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: End

}
//abhijeetvarude : 31-03-2023 : create chart url - End

//abhijeetvarude : 31-03-2023 : create chart url - Start
function findAppInfoParameters(appInfoAttribute, sParamName, tenentId) {
    const index = appInfoAttribute.findIndex(function (appInfo) {
        return appInfo?.sParamName === sParamName && appInfo?.sTenantId === tenentId;
    });

    return index;


}
//abhijeetvarude : 31-03-2023 : create chart url - End


//INDICES

//abhijeetvarude : 12-05-2023 : convert one dimentional data to multidimentional - start
const changeDataInGridFormat = (dataToConvert, singleOrMultidimentional) => {

    var tempdata = [];
    var arrData = [];

    if (!singleOrMultidimentional) {
        arrData.push(dataToConvert);
    }
    else {
        if (dataToConvert?.length <= INDICES_CONSTANTS.CARDS_PER_SCREEN) { //Prachi T - 22-11-2023 :- BT-104813 -- Dashboard Indices
            arrData.push(dataToConvert);
        }
        else {
            dataToConvert.forEach((each, index) => {
                tempdata.push(each);
                if (tempdata?.length >= INDICES_CONSTANTS.CARDS_PER_SCREEN) { //Prachi T - 22-11-2023 :- BT-104813 -- Dashboard Indices
                    arrData.push(tempdata);
                    tempdata = [];
                }
                if (index === dataToConvert?.length - 1 && tempdata?.length && tempdata?.length < INDICES_CONSTANTS.CARDS_PER_SCREEN) { //Prachi T - 22-11-2023 :- BT-104813 -- Dashboard Indices
                    arrData.push(tempdata);
                    tempdata = [];
                }
            });
        }
    }
    return arrData;
};
//abhijeetvarude : 12-05-2023 : convert one dimentional data to multidimentional - END

const EncodeToBase64 = (strVal) => {
    var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64; } else if (isNaN(i)) { a = 64; } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a); } return t; }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r); } if (a != 64) { t = t + String.fromCharCode(i); } } t = Base64._utf8_decode(t); return t; }, _utf8_encode: function (e) { e = e.replace(/\r\n/g, "\n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128); } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128); } } return t; }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = 0; var c1 = 0; var c2 = 0; var c3 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++; } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2; } else { c2 = e.charCodeAt(n + 1); c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3; } } return t; } };
    return Base64.encode(strVal);
};


const getEncryptString = (sDataToEncrypt, size = undefined) => {
    try {
        var pwd = sDataToEncrypt;
        var sEncryptedData;
        var doOaepPadding = true;
        var xmlParams =
            "<RSAKeyValue>" +
            "<Modulus>lnLDMeWvTgO17E50M5DQ1dbMLMKfOv2YclgyJIs+6Bls+/0ngDiLtROdMYBftJwQYD8g9OSJ5p2uMxVFucSFOG9Cwjy2g5+yw910TIYIVrmB3mHV8U9yoVNYq8ZXoc/r/MnCNDsnJv4HBeP4HcSM7IlyIYFX64HPJDztuimqUFs=</Modulus>" +
            "<Exponent>AQAB</Exponent>" +
            "<P>y/p1jfwg4RiabQ6gBkRliYCsQ+zaU4miKFNr1SXLwpH8Ia5TAG5yKU//0dekq4wlYmrvaW/J2FgoL4NUxFPwPQ==</P>" +
            "<Q>vNFhIFKITGZtYBvEZFEunnx/+yVMk2GOEN2tqWklWys3tOnyjyvK45qXunIMMJNK9tZeP0CwVAtMohKv95J0dw==</Q>" +
            "<DP>nxNWtkJYyfNMC50KQ5j3rsKAlgCTS+7cXaKhR/tP6w+6l/HBnWaE9Z8EHPyV2YtUZGqNB6c8vNITlOpRI0Nq6Q==</DP>" +
            "<DQ>u31daG8LkHGU4f4wgTxrgkw1+PgMlbwlCXJV4wbZZTIA2tADX08o4+C6ERT2LbXUlk4+v6hIbuvZaIYN3VO7+Q==</DQ>" +
            "<InverseQ>DSKvNnM0wLqBUsB4vG/JMR4rBOAjquj9+u3F1oJ//vLH/NL+dyB4MTNYfWht0kztMMd1qr0bjn2x90TmQuhvkg==</InverseQ>" +
            "</RSAKeyValue>";
        var rsa;
        if (size != undefined) {
            rsa = new window.System.Security.Cryptography.RSACryptoServiceProvider();
        }
        else
            rsa = new window.System.Security.Cryptography.RSACryptoServiceProvider();
        rsa.FromXmlString(xmlParams);
        var rsaParamsPublic = rsa.ExportParameters(false);
        var decryptedPwdBytes = window.System.Text.Encoding.UTF8.GetBytes(pwd);
        if (size != undefined) {
            rsa = new window.System.Security.Cryptography.RSACryptoServiceProvider();
        }
        else
            rsa = new window.System.Security.Cryptography.RSACryptoServiceProvider();
        rsa.ImportParameters(rsaParamsPublic);
        var encryptedPwdBytes = rsa.Encrypt(decryptedPwdBytes, doOaepPadding);
        var encryptedPwd = window.System.Convert.ToBase64String(encryptedPwdBytes);
        sEncryptedData = encryptedPwd;
        return sEncryptedData;
    } catch (e) {
        console.error("Error in RSA encryption." + e);
        return '';
    }
};




const createPGURL = (param, url, type = "") => {
    let arr = url.split('?');
    let sURL = arr[0];
    let sQSParam;
    if (NetNetPGQSMode == 1) {
        if (param) {
            sQSParam = arr[1] + "&" + param;
        } else {
            sQSParam = arr[1];
        }
        let sEncQParam = "enct=" + EncodeToBase64(sQSParam);
        let sPGURL = "";
        if (type) {
            sPGURL = sURL + "?" + sEncQParam + `&${type}=` + NetNetPGQSMode;
        } else {
            sPGURL = sURL + "?" + sEncQParam + "&Mode=" + NetNetPGQSMode;
        }
        return sPGURL;
    }
};



//BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Replaced and added fucntion for Dyanmic URL creation
// Deepti B: Bt-144474 if function is calling from voluntary block online access then fields like UID, Group ID and Token will not double encrypt
const getDyanmicURL = (req, objLoginSession, isEncrypted = false, isVoluntaryBlock = false) => {
    try {
        let url;
        if (req?.url != '' && req?.url != undefined && req?.url != null) {
            url = req?.url?.split('?')[0];
            let params = req?.url?.split('?')[1]

            if(req?.url?.indexOf('ENCR') > -1 || req?.url?.indexOf('crypt=1') > -1 ){
            isEncrypted = true
            }else{
            isEncrypted = false
            } 
            if (isEncrypted) {  
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.UID) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_UID) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_UID) ? DYANMIC_URL_CONSTANTS.ENCR_UID : DYANMIC_URL_CONSTANTS.UID;
                    params = params?.replace(keyToReplace, !isVoluntaryBlock ? 
                        getEncryptString(objLoginSession?.data?.user_id) : objLoginSession?.data?.user_id);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.SESSION, objLoginSession?.data?.others?.ocToken);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPID) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_GROUPID) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_GROUPID) ? DYANMIC_URL_CONSTANTS.ENCR_GROUPID : DYANMIC_URL_CONSTANTS.GROUPID;
                    params = params?.replace(keyToReplace, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.others?.groupId) : objLoginSession?.data?.others?.groupId);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.THEME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.THEME, req.theme);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTNAME, API_SOURCE.BREEZE);
                }
                // Deepti B [22/11/2024]: BT-144474 Voluntary block online access
                // check if the "Product" key exist in the quesry string
                // if it exists, replace it with current application type
                if (params?.includes(DYANMIC_URL_CONSTANTS.PRODUCT_KEY)) {
                    params = params?.replace(/(Product=)[^&]*/, `$1${APPLICATION_TYPE}`); // regular expression to match "Product=" followed by any value and replace it with current application type
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MKTSEGID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.MKTSEGID, req.mktsegid);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.SERIES) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.SERIES, req.series);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTTYPE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTTYPE, req.producttype);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.TRANSACTIONTYPE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.TRANSACTIONTYPE, req.transactiontype);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.QTY) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.QTY, req.quantity);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRICE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRICE, req.price);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BROKERAGE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BROKERAGE, req.brokerage);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.LEGINDICATOR) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.LEGINDICATOR, req.legIndicator);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.INSTRUMENT) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.INSTRUMENT, req.instrument);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRICELOCATOR) > -1 && req.priceLocator) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRICELOCATOR, req.priceLocator);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.HEX_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.HEX_UID, objLoginSession?.userIdHexaValue);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.OCTOKEN) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN) ? DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN : DYANMIC_URL_CONSTANTS.OCTOKEN;
                    params = params?.replace(keyToReplace, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.others?.ocToken) : objLoginSession?.data?.others?.ocToken);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.USERCODE) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_USERCODE) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_USERCODE) ? DYANMIC_URL_CONSTANTS.ENCR_USERCODE : DYANMIC_URL_CONSTANTS.USERCODE;
                    params = params?.replace(keyToReplace, getEncryptString(objLoginSession?.data?.others?.userCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.DEALERCODE) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE) ? DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE : DYANMIC_URL_CONSTANTS.DEALERCODE;
                    params = params?.replace(keyToReplace, getEncryptString(objLoginSession?.data?.others?.userCode));
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPCODE) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_GROUPCODE) > -1) {
                    let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_GROUPCODE) ? DYANMIC_URL_CONSTANTS.ENCR_GROUPCODE : DYANMIC_URL_CONSTANTS.GROUPCODE;
                    params = params?.replace(keyToReplace, getEncryptString(objLoginSession?.data?.others?.groupCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MANAGERID) > -1 || params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP) > -1) {
                   let keyToReplace = params.includes(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP) ? DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP : DYANMIC_URL_CONSTANTS.MANAGERID;
                    params = params?.replace(keyToReplace, getEncryptString(objLoginSession?.data?.others?.managerIP));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.HEX_PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.HEX_PANNO, objLoginSession?.PAN);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PANNO, objLoginSession?.PAN);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PANNO, EncodeToBase64(objLoginSession?.PAN));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.EMAIL, objLoginSession?.data?.email);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.MOBILE, objLoginSession?.data?.mobile);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTCODE, 21);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.USERNAME, objLoginSession?.data?.userName);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_UID, EncodeToBase64(objLoginSession?.data?.userId));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_SESSION, EncodeToBase64(objLoginSession?.data?.access_token));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_OCTOKEN, EncodeToBase64(objLoginSession?.data?.others?.ocToken));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_USERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_USERCODE, EncodeToBase64(objLoginSession?.data?.others?.userCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_DEALERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_DEALERCODE, EncodeToBase64(objLoginSession?.data?.others?.userCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_GROUPID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_GROUPID, EncodeToBase64(objLoginSession?.data?.others?.groupId));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_GROUPCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_GROUPCODE, EncodeToBase64(objLoginSession?.data?.others?.groupCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_MANAGERIP) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_MANAGERIP, EncodeToBase64(objLoginSession?.data?.others?.managerIP));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_EMAIL, EncodeToBase64(objLoginSession?.data?.email));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_MOBILE, EncodeToBase64(objLoginSession?.data?.mobile));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTNAME, EncodeToBase64("BREEZE"));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTCODE, EncodeToBase64(21));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_USERNAME, EncodeToBase64(objLoginSession?.data?.userName));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_UID, objLoginSession?.data?.userId); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_SESSION, objLoginSession?.data?.access_token);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN, objLoginSession?.data?.others?.ocToken);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_USERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_USERCODE, objLoginSession?.data?.others?.userCode);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE, objLoginSession?.data?.others?.userCode);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP, objLoginSession?.data?.others?.managerIP);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_EMAIL, objLoginSession?.data?.email);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PAN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PAN, objLoginSession?.PAN); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_MOBILE, objLoginSession?.data?.mobile);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTNAME, "BREEZE"); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTCODE, 21); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_USERNAME, objLoginSession?.data?.userName);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.TDES_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.TDES_OCTOKEN, TripleDESEncrypt(objLoginSession?.data?.others?.OCToken));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.VERSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.VERSION, "");
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.APPLICATION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.APPLICATION, "BREEZE");
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ALIASID, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.alias_id) : objLoginSession?.data?.alias_id);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_ALIASID, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.alias_id) : objLoginSession?.data?.alias_id);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_ALIASID, EncodeToBase64(objLoginSession?.data?.alias_id));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_CLIENTID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_CLIENTID, objLoginSession.registerresponse.data.sso_response.UserID);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_SESSIONID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_SESSIONID, objLoginSession.registerresponse.data.sso_response.SessionID);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_TRADINGID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_TRADINGID, objLoginSession.registerresponse.data.sso_response.TradingClientID);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION) > -1) {
                    let strToEncrypt = params?.substring(params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION) + DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION.length, params?.indexOf(DYANMIC_URL_CONSTANTS.ENCRYPTION_ENDTAG));
                    let encryptedStr = EncodeToBase64(strToEncrypt);
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION + strToEncrypt + DYANMIC_URL_CONSTANTS.ENCRYPTION_ENDTAG, encryptedStr);
                }
                if (req.type != '' && req.type != undefined && req.type != null) {
                    if (parseInt(req.type) == 1) {
                        url += `?type=${req.type}&enct=` + EncodeToBase64(params);
                    }
                    if (parseInt(req.type) == 2) //7 APP_BROKERAGE_MODE encryptiontype=1 [Base64], encryptiontype=2 [TDES] & encryptiontype=0 Plain text)
                    {
                        url += `?type=${req.type}&enct=` + TripleDESEncrypt(params);
                    }
                } else // APP_BROKERAGE_MODE encryptiontype=1 [Base64], encryptiontype=2 [TDES] & encryptiontype=0 Plain text
                {
                    url += '?' + params;
                }
            } else {
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.UID, objLoginSession?.data?.user_id);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.SESSION, objLoginSession?.data?.others?.ocToken);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.GROUPID, objLoginSession?.data?.others?.groupId);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.THEME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.THEME, req.theme);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTNAME, API_SOURCE.BREEZE);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MKTSEGID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.MKTSEGID, req.mktsegid);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.SERIES) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.SERIES, req.series);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTTYPE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTTYPE, req.producttype);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.TRANSACTIONTYPE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.TRANSACTIONTYPE, req.transactiontype);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.QTY) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.QTY, req.quantity);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRICE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRICE, req.price);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BROKERAGE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BROKERAGE, req.brokerage);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.LEGINDICATOR) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.LEGINDICATOR, req.legIndicator);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.INSTRUMENT) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.INSTRUMENT, req.instrument);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRICELOCATOR) > -1 && req.priceLocator) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRICELOCATOR, req.priceLocator);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.HEX_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.HEX_UID, objLoginSession?.userIdHexaValue);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.OCTOKEN, objLoginSession?.data?.others?.ocToken);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.USERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.USERCODE, objLoginSession?.data?.others?.userCode);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.DEALERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.DEALERCODE, objLoginSession?.data?.others?.userCode);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.GROUPCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.GROUPCODE, objLoginSession?.data?.others?.groupCode);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MANAGERID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.MANAGERID, objLoginSession?.data?.others?.managerIP);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.HEX_PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.HEX_PANNO, objLoginSession?.PAN);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PANNO, objLoginSession?.PAN);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PANNO) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PANNO, EncodeToBase64(objLoginSession?.PAN));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.EMAIL, objLoginSession?.data?.email);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.MOBILE, objLoginSession?.data?.mobile);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.PRODUCTCODE, 21);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.USERNAME, objLoginSession?.data?.userName);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_UID, EncodeToBase64(objLoginSession?.data?.userId));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_SESSION, EncodeToBase64(objLoginSession?.data?.access_token));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_OCTOKEN, EncodeToBase64(objLoginSession?.data?.others?.ocToken));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_USERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_USERCODE, EncodeToBase64(objLoginSession?.data?.others?.userCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_DEALERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_DEALERCODE, EncodeToBase64(objLoginSession?.data?.others?.userCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_GROUPID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_GROUPID, EncodeToBase64(objLoginSession?.data?.others?.groupId));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_GROUPCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_GROUPCODE, EncodeToBase64(objLoginSession?.data?.others?.groupCode));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_MANAGERIP) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_MANAGERIP, EncodeToBase64(objLoginSession?.data?.others?.managerIP));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_EMAIL, EncodeToBase64(objLoginSession?.data?.email));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_MOBILE, EncodeToBase64(objLoginSession?.data?.mobile));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTNAME, EncodeToBase64("BREEZE"));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_PRODUCTCODE, EncodeToBase64(21));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_USERNAME, EncodeToBase64(objLoginSession?.data?.userName));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_UID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_UID, objLoginSession?.data?.userId); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_SESSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_SESSION, objLoginSession?.data?.access_token);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_OCTOKEN, objLoginSession?.data?.others?.ocToken);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_USERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_USERCODE, objLoginSession?.data?.others?.userCode);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_DEALERCODE, objLoginSession?.data?.others?.userCode);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_GROUPCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_GROUPCODE, objLoginSession?.data?.others?.groupCode);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_MANAGERIP, objLoginSession?.data?.others?.managerIP);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_EMAIL) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_EMAIL, objLoginSession?.data?.email);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PAN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PAN, objLoginSession?.PAN); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_MOBILE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_MOBILE, objLoginSession?.data?.mobile);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTNAME, "BREEZE"); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTCODE) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_PRODUCTCODE, 21); //Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_USERNAME) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_USERNAME, objLoginSession?.data?.userName);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.TDES_OCTOKEN) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.TDES_OCTOKEN, TripleDESEncrypt(objLoginSession?.data?.others?.OCToken));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.VERSION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.VERSION, "");
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.APPLICATION) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.APPLICATION, "BREEZE");
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ALIASID, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.alias_id) : objLoginSession?.data?.alias_id);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.ENCR_ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.ENCR_ALIASID, !isVoluntaryBlock ? getEncryptString(objLoginSession?.data?.alias_id) : objLoginSession?.data?.alias_id);//Vaibhav Singh: BT-107437: Note: Need to implement EncryptString Here later on
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ALIASID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_ALIASID, EncodeToBase64(objLoginSession?.data?.alias_id));
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_CLIENTID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_CLIENTID, objLoginSession.registerresponse.data.sso_response.UserID);
                }

                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_SESSIONID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_SESSIONID, objLoginSession.registerresponse.data.sso_response.SessionID);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.KOTAK_TRADINGID) > -1) {
                    params = params?.replace(DYANMIC_URL_CONSTANTS.KOTAK_TRADINGID, objLoginSession.registerresponse.data.sso_response.TradingClientID);
                }
                if (params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION) > -1) {
                    let strToEncrypt = params?.substring(params?.indexOf(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION) + DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION.length, params?.indexOf(DYANMIC_URL_CONSTANTS.ENCRYPTION_ENDTAG));
                    let encryptedStr = EncodeToBase64(strToEncrypt);
                    params = params?.replace(DYANMIC_URL_CONSTANTS.BASE64_ENCRYPTION + strToEncrypt + DYANMIC_URL_CONSTANTS.ENCRYPTION_ENDTAG, encryptedStr);
                }
                if (req.type != '' && req.type != undefined && req.type != null) {
                    if (parseInt(req.type) == 1) {
                        url += `?type=${req.type}&enct=` + EncodeToBase64(params);
                    }
                    if (parseInt(req.type) == 2) //7 APP_BROKERAGE_MODE encryptiontype=1 [Base64], encryptiontype=2 [TDES] & encryptiontype=0 Plain text)
                    {
                        url += `?type=${req.type}&enct=` + TripleDESEncrypt(params);
                    }
                } else // APP_BROKERAGE_MODE encryptiontype=1 [Base64], encryptiontype=2 [TDES] & encryptiontype=0 Plain text
                {
                    if (params) {
                        url += '?' + params;
                    }
                }
            }
        }
        return url;
    } catch (error) {
        console.error(error);
    }
};




function handleUpdateWatchlistGrid(arrTouchLineData, activeWatchList, objArrayIndexes) {
    const arrActiveWatchListScrips = deepClone(activeWatchList?.scrips);
    if (arrActiveWatchListScrips && arrActiveWatchListScrips?.length > 0) {
        let scripsAdditonalInfo = store.getState().watchList.objscripsAdditionalInfo;
        // pivotPointResistanceLevelCalculate
        // Azeem K -05-07-2024 : Watchlist Optimization --Start
        const nIndexofScripToBeUpdated = objArrayIndexes[arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]];
        const arrScripToBeUpdated = nIndexofScripToBeUpdated >= 0 ? arrActiveWatchListScrips[nIndexofScripToBeUpdated] : [];
        // Azeem K -05-07-2024 : Watchlist Optimization --End
        if (arrScripToBeUpdated && arrScripToBeUpdated?.length > 0) {
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.YESTERDAY_HIGH] = scripsAdditonalInfo[getMappedMktSegIdFromApiExchangeName(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]) + '_' + arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOKEN]] ? scripsAdditonalInfo[getMappedMktSegIdFromApiExchangeName(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]) + '_' + arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOKEN]]?.nPrevDayHigh : 0.00;
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.YESTERDAY_LOW] = scripsAdditonalInfo[getMappedMktSegIdFromApiExchangeName(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]) + '_' + arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOKEN]] ? scripsAdditonalInfo[getMappedMktSegIdFromApiExchangeName(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]) + '_' + arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOKEN]]?.nPrevDayLow : 0.00;
            //By HiralK : 06-09-2023 : For Price optimization - Start
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            // const nAbsPrevColse = (arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);
            // if (nAbsPrevColse > 0) {
            //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = '+' + nAbsPrevColse.toString();
            // } else if (nAbsPrevColse < 0) {
            //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
            // }
            // else {
            //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
            // }
            //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[TL_INDEX.BUY_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[TL_INDEX.SELL_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[TL_INDEX.HIGH_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[TL_INDEX.LOW_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[TL_INDEX.OPEN_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[TL_INDEX.VOLUME];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] = arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN_INTEREST] = arrTouchLineData[TL_INDEX.OPEN_INTEREST];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.PERCENT_OI] = arrTouchLineData[TL_INDEX.OPEN_INTEREST_PERCENT] === '' ? (0)?.toFixed(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) : arrTouchLineData[TL_INDEX.OPEN_INTEREST_PERCENT];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_UPDATED_TIME] = arrTouchLineData[TL_INDEX.LAST_UPDATED_TIME];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOTAL_BUY_QTY] = arrTouchLineData[TL_INDEX.TOTAL_BUY_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOTAL_SELL_QTY] = arrTouchLineData[TL_INDEX.TOTAL_SELL_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_HIGH] = arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH] === '' ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? '0000' : '00'}` : arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_LOW] = arrTouchLineData[TL_INDEX.LIFE_TIME_LOW] === '' ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? '0000' : '00'}` : arrTouchLineData[TL_INDEX.LIFE_TIME_LOW];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_QTY] = arrTouchLineData[TL_INDEX.LAST_TRADE_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.AVG_TRADED_PRICE] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TRADE_EXECUTION_RANGE] = arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"} - 0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VALUE] = (arrTouchLineData[TL_INDEX.VOLUME] * arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE]);
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CODE] = arrTouchLineData[TL_INDEX.TOKEN];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] = arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] === ('' || undefined || null) ? '0' : arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_HIGH] = arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_LOW] = arrTouchLineData[TL_INDEX.LIFE_TIME_LOW] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[TL_INDEX.LIFE_TIME_LOW];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION] = parseFloat((arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * arrTouchLineData[TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES);
            //Azeem K 01-07-2024 : added premium discount and spot rate column in watchlist --- Start

            const objLasTickData = store?.getState()?.wfh?.objTouchlineLastTick;
            const arrSpotPriceTouchLineData = objLasTickData?.[arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASSET_SEGMENT_ID] + '_' + arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASSET_TOKEN]];

            if (arrSpotPriceTouchLineData?.length > 0) {
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX.PREMIUM_DISCOUNT] = (parseFloat(arrTouchLineData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrSpotPriceTouchLineData[TL_INDEX.LAST_TRADE_PRICE]))?.toFixed(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX.SPOT_RATE] = arrSpotPriceTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
            }
            //Azeem K 01-07-2024 : added premium discount and spot rate column in watchlist --- End


            const isPiviotPresent = store?.getState()?.watchList?.isPiviotPresent;
            if (isPiviotPresent) {
                const piviotData = calculateSupportRestistanceValues(arrScripToBeUpdated, 'Classic', '(H+L+C)/3');
                const { pivotPoint } = piviotData;
                const { R1, R2, R3 } = piviotData?.supportResistanceInfo?.resistance;
                const { S1, S2, S3 } = piviotData?.supportResistanceInfo?.support;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.RESISTANCE_ONE] = R1;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.RESISTANCE_TWO] = R2;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.RESISTANCE_THREE] = R3;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.PIVIOT] = pivotPoint;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.SUPPORT_ONE] = S1;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.SUPPORT_TWO] = S2;
                arrScripToBeUpdated[WATCHLIST_GRID_INDEX?.SUPPORT_THREE] = S3;
            } else { }
            //By HiralK : 06-09-2023 : For Price optimization - End
            return arrScripToBeUpdated;
        } else {
            return [];
        }
    } else {
        return [];
    }
}

export function convertBestFiveToWatchlistIndex(arrTouchLineData, activeWatchList, objArrayIndexes) {
    const arrActiveWatchListScrips = deepClone(activeWatchList?.scrips);
    if (arrActiveWatchListScrips && arrActiveWatchListScrips?.length > 0) {
        const nIndexofScripToBeUpdated = objArrayIndexes[arrTouchLineData[BEST5_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[BEST5_INDEX.TOKEN]];
        const arrScripToBeUpdated = nIndexofScripToBeUpdated >= 0 ? arrActiveWatchListScrips[nIndexofScripToBeUpdated] : [];
        if (arrScripToBeUpdated && arrScripToBeUpdated?.length > 0) {
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[BEST5_INDEX.LAST_TRADE_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[BEST5_INDEX.BUY_PRICE_1];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[BEST5_INDEX.BUY_PRICE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[BEST5_INDEX.NET_CHANGE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[BEST5_INDEX.BUY_QTY_1];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[BEST5_INDEX.SELL_PRICE_1];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[BEST5_INDEX.SELL_PRICE_INDICATOR];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[BEST5_INDEX.SELL_QTY_1];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[BEST5_INDEX.HIGH_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[BEST5_INDEX.LOW_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[BEST5_INDEX.OPEN_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[BEST5_INDEX.CLOSE_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[BEST5_INDEX.VOLUME];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[BEST5_INDEX.AVG_TRADED_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] = arrTouchLineData[BEST5_INDEX.DAILY_PRICE_RANGE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN_INTEREST] = arrTouchLineData[BEST5_INDEX.OPEN_INTEREST];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.PERCENT_OI] = arrTouchLineData[BEST5_INDEX.OPEN_INTEREST_PERCENT] === '' ? (0)?.toFixed(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) : arrTouchLineData[BEST5_INDEX.OPEN_INTEREST_PERCENT];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_UPDATED_TIME] = arrTouchLineData[BEST5_INDEX.LAST_UPDATED_TIME];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOTAL_BUY_QTY] = arrTouchLineData[BEST5_INDEX.TOTAL_BUY_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TOTAL_SELL_QTY] = arrTouchLineData[BEST5_INDEX.TOTAL_SELL_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_HIGH] = arrTouchLineData[BEST5_INDEX.LIFE_TIME_HIGH] === '' ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? '0000' : '00'}` : arrTouchLineData[BEST5_INDEX.LIFE_TIME_HIGH];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_LOW] = arrTouchLineData[BEST5_INDEX.LIFE_TIME_LOW] === '' ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? '0000' : '00'}` : arrTouchLineData[BEST5_INDEX.LIFE_TIME_LOW];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_QTY] = arrTouchLineData[BEST5_INDEX.LAST_TRADE_QTY];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.AVG_TRADED_PRICE] = arrTouchLineData[BEST5_INDEX.AVG_TRADED_PRICE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.TRADE_EXECUTION_RANGE] = arrTouchLineData[BEST5_INDEX.TRADE_EXECUTION_RANGE] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"} - 0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[BEST5_INDEX.TRADE_EXECUTION_RANGE];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VALUE] = (arrTouchLineData[BEST5_INDEX.VOLUME] * arrTouchLineData[BEST5_INDEX.AVG_TRADED_PRICE]);
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CODE] = arrTouchLineData[BEST5_INDEX.TOKEN];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] = arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] === ('' || undefined || null) ? '0' : arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_HIGH] = arrTouchLineData[BEST5_INDEX.LIFE_TIME_HIGH] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[BEST5_INDEX.LIFE_TIME_HIGH];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_LOW] = arrTouchLineData[BEST5_INDEX.LIFE_TIME_LOW] === "" ? `0.${arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] > 2 ? "0000" : "00"}` : arrTouchLineData[BEST5_INDEX.LIFE_TIME_LOW];
            arrScripToBeUpdated[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION] = parseFloat((arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * arrTouchLineData[BEST5_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES);
            return arrScripToBeUpdated;
        } else {
            return [];
        }
    } else {
        return [];
    }
}


//abhijeetvarude : 2023-05-23 : constituents update grid - Start

const handleIndicesCardColor = (perChange) => {
    if (parseFloat(perChange) > 0 && parseFloat(perChange) < 1) {
        return 'background-hitmap-mild-6';
    }
    else if (parseFloat(perChange) > 1 && parseFloat(perChange) < 2) {
        return 'background-hitmap-mild-5';
    }
    else if (parseFloat(perChange) > 2 && parseFloat(perChange) < 5) {
        return 'background-hitmap-mild-4';
    }
    else if (parseFloat(perChange) > 5 && parseFloat(perChange) < 7.5) {
        return 'background-hitmap-mild-3';
    }
    else if (parseFloat(perChange) > 7.5 && parseFloat(perChange) < 10) {
        return 'background-hitmap-mild-2';
    }
    else if (parseFloat(perChange) > 10) {
        return 'background-hitmap-mild-1';
    }
    else if (parseFloat(perChange) < 0 && parseFloat(perChange) > -1) {
        return 'background-hitmap-hot-6';
    }
    else if (parseFloat(perChange) < -1 && parseFloat(perChange) > -2) {
        return 'background-hitmap-hot-5';
    }
    else if (parseFloat(perChange) < -2 && parseFloat(perChange) > -5) {
        return 'background-hitmap-hot-4';
    }
    else if (parseFloat(perChange) < -5 && parseFloat(perChange) > -7.5) {
        return 'background-hitmap-hot-3';
    }
    else if (parseFloat(perChange) < -7.5 && parseFloat(perChange) > -10) {
        return 'background-hitmap-hot-2';
    }
    else if (parseFloat(perChange) < -10) {
        return 'background-hitmap-hot-1';
    }
    else {
        return '';
    }
};


function handleUpdateConstituentsGrid(arrTouchLineData, constituentsData, decimalLocator) {
    const arrConstituentsDataScrips = deepClone(constituentsData);
    if (arrConstituentsDataScrips && arrConstituentsDataScrips?.length > 0) {
        const arrScripToBeUpdated = arrConstituentsDataScrips.find(scrip => scrip[CONSTITUENTS_GRID_INDEX.SEGMENT_ID_TOKEN] === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
        if (arrScripToBeUpdated) {
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.SEGMENT_ID] = arrTouchLineData[TL_INDEX.SEGMENT_ID];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.TOKEN] = arrTouchLineData[TL_INDEX.TOKEN];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.SEGMENT_ID_TOKEN] = arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.LAST_TRADE_PRICE] = (arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]);
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.CHANGE_IN_LTP] = (arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.BID_PRICE] = (arrTouchLineData[TL_INDEX.BUY_PRICE]);
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
            arrScripToBeUpdated[CONSTITUENTS_GRID_INDEX.DECIMAL_LOCATOR] = decimalLocator;

            return arrScripToBeUpdated;
        } else { }
    } else { }
}

//abhijeetvarude : 2023-05-23 : constituents update grid - End

//PrachiTawde : 09-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
const isCommodityExchange = (_sMktSegId) => {
    try {
        if (_sMktSegId == MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECOMM_DERIVATIVES ||
            _sMktSegId == MAPPED_MARKET_SEGMENT_ID.MAPPED_NSECOMM_DERIVATIVES ||
            _sMktSegId == MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES ||
            _sMktSegId == MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (e) {
        console.error(e);
    }
};
//PrachiTawde : 09-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End
const dateFormatter = (date) => {
    return moment(date).format('DDMMMYYYY').toLocaleUpperCase();
};
//PrachiTawde : 25-05-2023 : BT-109117 - Dashboard || My Summary || Portfolio - API Integration and Data Binding - Start
const getNumberWithCurrencyFormat = (sNumber) => {
    return Number(sNumber).toLocaleString('en-IN', { minimumFractionDigits: 2 });
};

const getFormattedNumbers = (sNumber) => {
    if (!isNaN(sNumber)) {
        return getNumberWithCurrencyFormat(sNumber);
    } else {
        return 0.00;
    }
};
//PrachiTawde : 25-05-2023 : BT-109117 -  Dashboard || My Summary || Portfolio - API Integration and Data Binding - End

function arrangeObjectsInSequence(firstArray, secondArray) {
    // this function is used to arrange the scrips according to the sequence number
    try {
        const mapping = {};
        firstArray?.forEach(obj => {
            const key = obj.nMarketSegmentId + '_' + obj.nToken;
            mapping[key] = obj?.nSequenceNo;
        });

        secondArray.sort((a, b) => {
            const keyA = a.nMarketSegmentId + '_' + a.nToken;
            const keyB = b.nMarketSegmentId + '_' + b.nToken;
            const sequenceA = mapping[keyA] || 0;
            const sequenceB = mapping[keyB] || 0;
            return sequenceA - sequenceB;
        });
        return secondArray;
    }
    catch (e) {
        console.error(e);
    }
}

const maskNumber = (number, string) => {
    try {
        let num = number;
        const substringToBeReplaced = number?.substr(0, number.length - 4);//number.substring(2, number.length - 4);
        num = num?.replace(substringToBeReplaced, string); //result will be *******4567
        return num;
    } catch (error) {
        console.error(error);
    }
};

/*Mahesh S  : 01-06-2023 : BT-107422 -  Breeze- Positions Overview - Start*/

function getDecimalLocatorFromApiExchangeName(strExchange) {
    //By HiralK : 05-08-2023 - Decimal Locator Optimization - Start
    let nDecimalLocator = DECIMAL_LOCATOR.NORMAL;
    switch (strExchange) {
        case EXCHANGE_NAME_API.NSX_DERV_API:
        case EXCHANGE_NAME_API.BSECDX_DERV_API:
        case DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT:
        case DISPLAY_EXCHANGE_NAME.NSX_SPOT_TEXT:
        case DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT: {
            nDecimalLocator = DECIMAL_LOCATOR.CURRENCY;
            break;
        }
        case EXCHANGE_NAME_API.NSE_COMM_API:
            nDecimalLocator = DECIMAL_LOCATOR.NSECOMM;
            break;
        default: {
            nDecimalLocator = DECIMAL_LOCATOR.NORMAL;
            break;
        }
    }
    //By HiralK : 05-08-2023 - Decimal Locator Optimization - End

    // switch (strExchange) {
    //     case EXCHANGE_NAME_API.NSE_EQ_API:
    //         DecimalLocator = DECIMAL_LOCATOR.NSE_EQ_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.NSE_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.NSE_FO_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.BSE_EQ_API:
    //         DecimalLocator = DECIMAL_LOCATOR.BSE_EQ_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.BSE_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.BSE_FO_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.MCX_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.MCX_FO_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.NCDEX_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.NCDEX_FO_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.NSX_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.NSE_CUR_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.BSECDX_DERV_API:
    //         DecimalLocator = DECIMAL_LOCATOR.BSE_CUR_DECIMAL_LOCATOR;
    //         break;
    //     case EXCHANGE_NAME_API.NSE_COMM_API:
    //         DecimalLocator = DECIMAL_LOCATOR.NSE_COMM_DECIMAL_LOCATOR;
    //         break;
    //     default:
    //         DecimalLocator = 100;
    //         break;
    // }

    return nDecimalLocator;
}
/*Mahesh S  : 03-08-2023 : BT-107422 -  Breeze- Positions Summary - Start*/
const getExchangeName = (intMktSegId) => {
    let strExName = "";
    switch (intMktSegId) {
        case MARKET_SEGMENT_ID.NSE_CASH:
        case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
            strExName = DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.BSE_CASH:
        case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
            strExName = DISPLAY_EXCHANGE_NAME.BSE_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
        case MARKET_SEGMENT_ID.MCX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
        case MARKET_SEGMENT_ID.NCDEX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.NSEL_DERIVATIVES:
        case MARKET_SEGMENT_ID.NSEL_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.NSEL_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
        case MARKET_SEGMENT_ID.MSX_SPOT:
        case MARKET_SEGMENT_ID.MSX_CASH:
        case MARKET_SEGMENT_ID.MSX_FAO:
            strExName = DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.DSE_CASH:
            strExName = DISPLAY_EXCHANGE_NAME.DSE_EXCHANGE_TEXT;
            break;
        //Azeem K : 27-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSECOMM bug fixing - Start
        case MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES:
        case MARKET_SEGMENT_ID.BSECOMM_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.BSECOMM_EXCHANGE_TEXT;
            break;
        //Azeem K : 27-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSECOMM bug fixing - End
        case MARKET_SEGMENT_ID.NMCE_DERIVATIVES:
            strExName = DISPLAY_EXCHANGE_NAME.NMCE_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
        case MARKET_SEGMENT_ID.NSX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
        case MARKET_SEGMENT_ID.BSECDX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT;
            break;
        //Azeem K : 10-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSECOMM - Start
        case MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES:
        case MARKET_SEGMENT_ID.NSECOMM_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.NSECOMM_EXCHANGE_TEXT;
            break;
        //Azeem K : 10-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSECOMM - End

        case MARKET_SEGMENT_ID.UCX_DERIVATIVES:
        case MARKET_SEGMENT_ID.UCX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.UCX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.DGCX_DERIVATIVES:
        case MARKET_SEGMENT_ID.DGCX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.DGCX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.BFX_DERIVATIVES:
        case MARKET_SEGMENT_ID.BFX_SPOT:
            strExName = DISPLAY_EXCHANGE_NAME.BFX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.OFS_IPO_BONDS:
            strExName = DISPLAY_EXCHANGE_NAME.OTSTXT_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.ADX_CASH:
            strExName = DISPLAY_EXCHANGE_NAME.ADX_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.DFM_CASH:
            strExName = DISPLAY_EXCHANGE_NAME.DFM_EXCHANGE_TEXT;
            break;
        case MARKET_SEGMENT_ID.COMBINED_CASH:
            strExName = EXCHANGE_NAME_API.COMBINED_CASH;
            break;
        case MARKET_SEGMENT_ID.COMBINED_FNO:
            strExName = EXCHANGE_NAME_API.COMBINED_FNO;
            break;
        case MARKET_SEGMENT_ID.COMBINED_CDS:
            strExName = EXCHANGE_NAME_API.COMBINED_CDS;
            break;
        default:
            strExName = '';
            break;
    }
    return strExName;
};

const calculateCVF = (netPositionData) => {
    // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- Start
    let nCVF = 1;
    let price_num = netPositionData?.price_num ? netPositionData?.price_num : 1;
    let price_den = netPositionData?.price_den ? netPositionData?.price_den : 1;
    let gen_num = netPositionData?.gen_num ? netPositionData.gen_num : 1;
    let gen_den = netPositionData?.gen_den ? netPositionData.gen_den : 1;
    let market_lot = netPositionData?.market_lot ? netPositionData.market_lot : 1;

    try {
        switch (netPositionData.preferred_mktSegId.toString()) {
            case MARKET_SEGMENT_ID.MCX_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.MSX_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.NSX_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.NSEL_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.UCX_DERIVATIVES.toString():
            case MARKET_SEGMENT_ID.MSX_FAO.toString():
                nCVF = ((parseFloat(price_num.toString()) / parseFloat(price_den.toString()))
                    * (parseFloat(gen_num.toString()) / parseFloat(gen_den.toString()))) * market_lot;
                break;

            case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES.toString():
                nCVF = (parseFloat(price_num.toString()) / parseFloat(price_den.toString())) * market_lot;
                break;
            default:
                nCVF = 1;
                break;
        }
    } catch (error) {
        nCVF = 1;
    }
    // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- End
    return nCVF;
};

const getGroupedSegement = (exchange, segment) => {
    try {
        var strSelectedExch = exchange?.trim()?.toUpperCase();
        var strSelectedInst = segment?.trim()?.toUpperCase();
        var strGroupedSeg = "";

        if (strSelectedExch == DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.EQUITIES:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQUITY;
                    break;
                case SCRIP_INSTRUMENTS.FUTURES_TEXT:
                case SCRIP_INSTRUMENTS.FUTIDX:
                case SCRIP_INSTRUMENTS.FUTIVX:
                case SCRIP_INSTRUMENTS.FUTSTK:
                case SCRIP_INSTRUMENTS.OPTIONS_TEXT:
                case SCRIP_INSTRUMENTS.OPTIDX:
                case SCRIP_INSTRUMENTS.OPTSTK:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQFAO;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.BSE_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.EQUITIES:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQUITY;
                    break;
                case SCRIP_INSTRUMENTS.FUTURES_TEXT:
                case SCRIP_INSTRUMENTS.FUTIDX:
                case SCRIP_INSTRUMENTS.FUTSTK:
                case SCRIP_INSTRUMENTS.OPTIONS_TEXT:
                case SCRIP_INSTRUMENTS.OPTIDX:
                case SCRIP_INSTRUMENTS.OPTSTK:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQFAO;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTCOM:
                case SCRIP_INSTRUMENTS.OPTFUT:
                case SCRIP_INSTRUMENTS.FUTSPT_TEXT:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_COMMODITY;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT || strSelectedExch == DISPLAY_EXCHANGE_NAME.NSECOMM_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTCOM:
                case SCRIP_INSTRUMENTS.OPTFUT:
                case SCRIP_INSTRUMENTS.FUTBAS:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_COMMODITY;
                    break;
                case SCRIP_INSTRUMENTS.FUTSPT_TEXT:
                    strGroupedSeg = "";
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.NSEL_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.NSELSPTCOM_TEXT:
                case SCRIP_INSTRUMENTS.MCXFUTSPT_TEXT:
                    strGroupedSeg = "";
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTCUR:
                case SCRIP_INSTRUMENTS.CURRENCY_TEXT:
                case SCRIP_INSTRUMENTS.CUR_TEXT:
                case SCRIP_INSTRUMENTS.OPTCUR_TEXT:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_CURR;
                    break;

                case SCRIP_INSTRUMENTS.EQUITIES:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQUITY;
                    break;
                case SCRIP_INSTRUMENTS.FUTURES_TEXT:
                case SCRIP_INSTRUMENTS.FUTIDX:
                case SCRIP_INSTRUMENTS.FUTSTK:
                case SCRIP_INSTRUMENTS.OPTIONS_TEXT:
                case SCRIP_INSTRUMENTS.OPTIDX:
                case SCRIP_INSTRUMENTS.OPTSTK:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQFAO;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTCUR:
                case SCRIP_INSTRUMENTS.OPTCUR_TEXT:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_CURR;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTCUR:
                case SCRIP_INSTRUMENTS.OPTCUR_TEXT:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_CURR;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.DSE_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.EQUITIES:
                    strGroupedSeg = EXCHANGE_TYPES.CONST_EQUITY;
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.BFX_EXCHANGE_TEXT) {
            switch (strSelectedInst) {
                case SCRIP_INSTRUMENTS.FUTURES_TEXT:
                case SCRIP_INSTRUMENTS.FUTCOM:
                case SCRIP_INSTRUMENTS.FUTCUR:
                case SCRIP_INSTRUMENTS.FUTIDX:
                    strGroupedSeg = "";
                    break;
                case SCRIP_INSTRUMENTS.OPTIONS_TEXT:
                case SCRIP_INSTRUMENTS.OPTCOM_TEXT:
                case SCRIP_INSTRUMENTS.OPTCUR_TEXT:
                case SCRIP_INSTRUMENTS.OPTIDX:
                    strGroupedSeg = "";
                    break;
                default:
                    strGroupedSeg = '';
                    break;
            }
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.ICEX_EXCHANGE_TEXT) {
            strGroupedSeg = EXCHANGE_TYPES.CONST_COMMODITY;
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.COMBINED_CASH.trim().toUpperCase()) {
            strGroupedSeg = EXCHANGE_TYPES.CONST_COMBINED_EQ;
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.COMBINED_FNO.trim().toUpperCase()) {
            strGroupedSeg = EXCHANGE_TYPES.CONST_COMBINED_DERV;
        }
        else if (strSelectedExch == DISPLAY_EXCHANGE_NAME.COMBINED_CDS.trim().toUpperCase()) {
            strGroupedSeg = EXCHANGE_TYPES.CONST_COMBINED_CUR;
        }

        return strGroupedSeg;
    } catch (e) {
        console.error(e);
    }
};

/*Mahesh S  : 03-08-2023 : BT-107422 -  Breeze- Positions Summary - End*/

const UnRealisedProfitLoss = (netPositionData, ltp) => {
    try {
        /* @type {number}*/
        let marketLotMultiPlier = calculateCVF(netPositionData);
        let numUnRealizedPandL = 0.00;
        if (parseFloat(ltp) > 0) {
            if (netPositionData.buy_quantity > 0) {   //Buy side Order
                if (netPositionData.sell_quantity === 0) { // Fully Open position case
                    numUnRealizedPandL = (parseFloat(ltp) * netPositionData.buy_quantity) - parseFloat(netPositionData.avg_buy_price) * netPositionData.buy_quantity;
                } else {
                    //partial open position case
                    if ((netPositionData.buy_quantity > netPositionData.sell_quantity) && netPositionData.sell_quantity > 0) { // Buy Side Position
                        numUnRealizedPandL = (parseFloat(ltp) * Math.abs(netPositionData.net_quantity)) - (parseFloat(netPositionData.avg_buy_price) * Math.abs(netPositionData.net_quantity));
                    } else if ((netPositionData.sell_quantity > netPositionData.buy_quantity) && netPositionData.buy_quantity > 0) { // Sell Side Position
                        numUnRealizedPandL = (parseFloat(netPositionData.avg_sell_price) * Math.abs(netPositionData.net_quantity)) - (parseFloat(ltp) * Math.abs(netPositionData.net_quantity));
                    }
                }
            } else if (netPositionData.sell_quantity > 0) { //Sell side Order
                if (netPositionData.buy_quantity === 0) { // Fully Open position case
                    numUnRealizedPandL = parseFloat(netPositionData.avg_sell_price) * netPositionData.sell_quantity - parseFloat(ltp) * netPositionData.sell_quantity; //Corrected
                } else {
                    //partial open position case
                    if ((netPositionData.sell_quantity > netPositionData.buy_quantity) && netPositionData.buy_quantity > 0) { // Buy Side Position
                        numUnRealizedPandL = (parseFloat(netPositionData.avg_sell_price) * Math.abs(netPositionData.net_quantity)) - (parseFloat(ltp) * Math.abs(netPositionData.net_quantity));
                    } else if ((netPositionData.buy_quantity > netPositionData.sell_quantity) && netPositionData.sell_quantity > 0) { // Sell Side Position
                        numUnRealizedPandL = (parseFloat(ltp) * Math.abs(netPositionData.net_quantity)) - (parseFloat(netPositionData.avg_buy_price) * Math.abs(netPositionData.net_quantity));
                    }
                }
            }
        }
        if (isNaN(numUnRealizedPandL)) {
            return 0.00;
        }
        else {
            return (numUnRealizedPandL * marketLotMultiPlier)?.toFixed(2);
        }
    }
    catch (e) {
        console.error(e);
    }
};

const RealisedProfitLoss = (netPositionData, ltp) => {
    try {
        /* @type {number}*/
        let marketLotMultiPlier = calculateCVF(netPositionData);
        let numRealisedPandL = 0.00;
        if (netPositionData.net_quantity === 0) { // Fully close position case
            numRealisedPandL = parseFloat(netPositionData.avg_sell_price) * netPositionData.sell_quantity - parseFloat(netPositionData.avg_buy_price) * netPositionData.buy_quantity;

        } else {
            if (netPositionData.buy_quantity > 0) {   //Buy side Order
                if (netPositionData.sell_quantity === 0) { // Fully Open position case
                    numRealisedPandL = 0.00;
                } else {
                    //partial open position case
                    if ((netPositionData.buy_quantity > netPositionData.sell_quantity) && netPositionData.sell_quantity > 0) { // Buy Side Position
                        numRealisedPandL = (parseFloat(netPositionData.avg_sell_price) * netPositionData.sell_quantity) - (parseFloat(netPositionData.avg_buy_price) * netPositionData.sell_quantity);

                    } else if ((netPositionData.sell_quantity > netPositionData.buy_quantity) && netPositionData.buy_quantity > 0) { // Sell Side Position
                        numRealisedPandL = (parseFloat(netPositionData.avg_sell_price) * netPositionData.buy_quantity) - (parseFloat(netPositionData.avg_buy_price) * netPositionData.buy_quantity);

                    }
                }
            } else if (netPositionData.sell_quantity > 0) { //Sell side Order
                if (netPositionData.buy_quantity === 0) { // Fully Open position case
                } else {
                    //partial open position case
                    if ((netPositionData.sell_quantity > netPositionData.buy_quantity) && netPositionData.buy_quantity > 0) { // Buy Side Position
                        numRealisedPandL = (parseFloat(netPositionData.avg_sell_price) * netPositionData.buy_quantity) - (parseFloat(netPositionData.avg_buy_price) * netPositionData.buy_quantity);

                    } else if ((netPositionData.buy_quantity > netPositionData.sell_quantity) && netPositionData.sell_quantity > 0) { // Sell Side Position
                        numRealisedPandL = (parseFloat(netPositionData.avg_sell_price) * netPositionData.sell_quantity) - (parseFloat(netPositionData.avg_buy_price) * netPositionData.sell_quantity);

                    }
                }
            }
        }
        if (isNaN(numRealisedPandL)) {
            return 0.00;
        }
        else {
            return (numRealisedPandL * marketLotMultiPlier)?.toFixed(2);
        }
    }
    catch (e) {
        console.error(e);
    }
};

const CalculateMTM = (dblSellVal, dblNetQty, dblLTP, dblRegLot, dblGenNum, dblGenDen, dblPriceNum, dblPriceDen, dblBuyValue, intMktSegID, dblRefRate) => {
    var dblMTMValue = 0;
    if (isNaN(dblLTP))
        dblLTP = 0;
    if (dblLTP === 0) {
        dblMTMValue = 0;
    }
    else if (intMktSegID === MARKET_SEGMENT_ID.MCX_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.NSEL_DERIVATIVES
        || intMktSegID === MARKET_SEGMENT_ID.DGCX_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.BFX_DERIVATIVES
        || intMktSegID === MARKET_SEGMENT_ID.UCX_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.MSX_FAO
    ) {
        if (isNaN(dblRefRate) || dblRefRate <= 0 || dblRefRate === null || dblRefRate === undefined)
            dblMTMValue = (dblSellVal + (dblNetQty * dblLTP * dblRegLot * (dblGenNum / dblGenDen) * (dblPriceNum / dblPriceDen))) - dblBuyValue;
        else
            dblMTMValue = (dblSellVal + (dblNetQty * (dblLTP * (dblRefRate / 10000000)) * dblRegLot * (dblGenNum / dblGenDen) * (dblPriceNum / dblPriceDen))) - dblBuyValue;
    }
    else if (intMktSegID === MARKET_SEGMENT_ID.MCX_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.NSX_DERIVATIVES
        || intMktSegID === MARKET_SEGMENT_ID.BSECDX_DERIVATIVES) {
        if (isNaN(dblRefRate) || dblRefRate === 1 || dblRefRate == null || dblRefRate === undefined)
            dblMTMValue = (dblSellVal + (dblNetQty * dblLTP * dblRegLot * (dblGenNum / dblGenDen) * (dblPriceNum / dblPriceDen))) - dblBuyValue;
        else
            dblMTMValue = (dblSellVal + (dblNetQty * (dblLTP * (dblRefRate / 10000000)) * dblRegLot * (dblGenNum / dblGenDen) * (dblPriceNum / dblPriceDen))) - dblBuyValue;
    }
    else if (intMktSegID === MARKET_SEGMENT_ID.NSE_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
        dblMTMValue = (dblSellVal + (dblNetQty * dblLTP)) - dblBuyValue;
    }
    else if (intMktSegID === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES || intMktSegID === MARKET_SEGMENT_ID.NMCE_DERIVATIVES) {
        dblMTMValue = (dblSellVal - dblBuyValue) + ((dblNetQty * dblLTP) * (dblPriceNum / dblPriceDen));
    }
    else {
        dblMTMValue = (dblSellVal + (dblNetQty * dblLTP)) - dblBuyValue;
    }
    return parseFloat(dblMTMValue.toFixed(2));
};

const TodaysProfitLoss = (netPositionData, ltp) => {
    try {
        let RegularLot = netPositionData.market_lot;
        let PriceNum = netPositionData.price_num;
        let PriceDen = netPositionData.price_den;
        let GenNum = netPositionData.gen_num;
        let GenDen = netPositionData.gen_den;
        {/* Azeem K : 15-01-2024 : BT-102298 NSE FO Netposition  – Start */ }
        let BuyValue = parseFloat(netPositionData.buy_value);
        let SellVal = parseFloat(netPositionData.sell_value);
        {/* Azeem K : 15-01-2024 : BT-102298 NSE FO Netposition  – End */ }
        let numTodayPandL = 0.00;
        numTodayPandL = CalculateMTM(SellVal, netPositionData.net_quantity, parseFloat(ltp), RegularLot, GenNum, GenDen, PriceNum, PriceDen, BuyValue, getMktSegIdFromApiExchangeName(netPositionData.preferred_exchange), netPositionData.reference_rate);

        if (isNaN(numTodayPandL)) {
            return 0.00;
        }
        else {
            // numTodayPandL = getFormattedNumbers(numTodayPandL);
            return numTodayPandL?.toFixed(2);
        }
    }
    catch (e) {
        console.error(e);
    }

};
const OverAllProfitLoss = (netPositionData, ltp) => {
    try {
        let RegularLot = netPositionData.market_lot;
        let PriceNum = netPositionData.price_num;
        let PriceDen = netPositionData.price_den;
        let GenNum = netPositionData.gen_num;
        let GenDen = netPositionData.gen_den;
        let numOverAllPandL = 0.00;
        if ((parseFloat(netPositionData.cf_sell_value) > 0 || parseFloat(netPositionData.cf_buy_value) > 0) && netPositionData.daily_or_expiry == NET_POSITION_EXPIRY.EXPIRY && (netPositionData.instrument.substring(0, 3) === SCRIP_INSTRUMENTS.FUT || netPositionData.instrument.substring(0, 3) === SCRIP_INSTRUMENTS.OPT)) {
            numOverAllPandL = CalculateMTM(parseFloat(netPositionData.cf_sell_value), netPositionData.net_quantity, parseFloat(ltp), RegularLot, GenNum, GenDen, PriceNum, PriceDen, parseFloat(netPositionData.cf_buy_value), getMktSegIdFromApiExchangeName(netPositionData.preferred_exchange), netPositionData.reference_rate);
        }
        if (isNaN(numOverAllPandL)) {
            return 0.00;
        }
        else {
            return numOverAllPandL?.toFixed(2);
        }
    }
    catch (e) {
        console.error(e);
    }
};

const postionOverviewPercentageChange = (profitLoss, totalNetValue) => {
    let numPercentChange = 0.00;
    if (totalNetValue) {
        numPercentChange = (profitLoss / totalNetValue) * MULTIPLIER.HUNDRED;
    }
    return numPercentChange?.toFixed(2);
};

const TodayPercentageChange = (netPositionItem, NetQty, ltp) => {
    let percentageChange = 0.00;
    if (NetQty && parseFloat(netPositionItem.net_price) != 0 && (parseFloat(ltp) != parseFloat(netPositionItem.net_price))) {
        percentageChange = (((parseFloat(ltp) - parseFloat(netPositionItem.net_price)) / parseFloat(netPositionItem.net_price)) * 100).toFixed(2);
        percentageChange = NetQty < 0 ? (percentageChange * -1) : percentageChange;
        percentageChange = percentageChange === '-100.00' ? 0.00 : percentageChange;
    } else {
        percentageChange = 0.00;
    }
    return percentageChange;
};

const DecimalLocatorPositions = (ltp, avg_price, exchange) => {
    let decimalPlace = avg_price?.split('.')[1]?.length || 0;//num of decimals
    const dlvalue = getDecimalLocatorFromApiExchangeName(exchange);
    let decimalValue = (ltp / dlvalue).toFixed(decimalPlace);
    return decimalValue;
};


const handlePositionsChange = (matchedNetPoition, arrTouchLineData) => {
    try {
        let wfhObj = {
            //Azeem K : 28-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Bug Fixes - Start 
            ...matchedNetPoition,
            //Azeem K : 28-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Bug Fixes - End 
            id: matchedNetPoition.id,
            net_position_detail: '',
            title: matchedNetPoition.title,
            ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
            buy_value: matchedNetPoition.buy_value,
            sell_value: matchedNetPoition.sell_value,
            closePrice: arrTouchLineData[TL_INDEX.CLOSE_PRICE],
            total_profit_loss: TodaysProfitLoss(matchedNetPoition, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            profit_loss: TodayPercentageChange(matchedNetPoition, matchedNetPoition.net_quantity, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            realised_pl: RealisedProfitLoss(matchedNetPoition, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            unrealised_pl: UnRealisedProfitLoss(matchedNetPoition, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            todays_pl: TodaysProfitLoss(matchedNetPoition, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            overAll_pl: OverAllProfitLoss(matchedNetPoition, arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]),
            cmv: (arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) * matchedNetPoition.net_quantity,
            net_quantity: matchedNetPoition.net_quantity,
            avg_buy_price: (matchedNetPoition.avg_buy_price === '0.00' ? matchedNetPoition.cf_net_price : matchedNetPoition.avg_buy_price),
            product_type: matchedNetPoition.product_type,
            net_value: matchedNetPoition.net_value,
            buy_quantity: matchedNetPoition.buy_quantity,
            sell_quantity: matchedNetPoition.sell_quantity,
            series: matchedNetPoition.series,
            avg_sell_price: matchedNetPoition.avg_sell_price,
            net_price: matchedNetPoition.net_price,
            slTrigger: matchedNetPoition.slTrigger,
            preferred_exchange: matchedNetPoition.preferred_exchange,
            preferred_scrip_token: matchedNetPoition.preferred_scrip_token,
            market_lot: matchedNetPoition.market_lot,
            price_den: matchedNetPoition.price_den,
            price_num: matchedNetPoition.price_num,
            gen_den: matchedNetPoition.gen_den,
            gen_num: matchedNetPoition.gen_num,
            cf_buy_value: matchedNetPoition.cf_buy_value,
            cf_net_price: matchedNetPoition.cf_net_price,
            cf_sell_value: matchedNetPoition.cf_sell_value,
            instrument: matchedNetPoition.instrument,
            daily_or_expiry: matchedNetPoition.daily_or_expiry,
            exchange: matchedNetPoition.exchange,
            segment_id_token: matchedNetPoition.segment_id_token,
            strike_price: matchedNetPoition.strike_price,
            option_type: matchedNetPoition.option_type,
            order_type: matchedNetPoition.order_type,
            validity: matchedNetPoition.validity,
            expiry_date: matchedNetPoition.expiry_date,
            preferred_mktSegId: matchedNetPoition.preferred_mktSegId,
            displayExchange: matchedNetPoition.displayExchange,
            customSegment: matchedNetPoition.customSegment,
            ltpPercentChange: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
            decimalLocator: getDecimalLocatorFromApiExchangeName(matchedNetPoition.exchange),
            modified_quantity: matchedNetPoition.modified_quantity,
            range: arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE],
            market_type: matchedNetPoition.market_type,
            scrip_token: matchedNetPoition.scrip_token,
            ScripData: matchedNetPoition.ScripData,
            lastTradePrice: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
            ltpChange: arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR],
            lowDPRRange: arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE] ? arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE]?.split('-')[0] : 0,
            highDPRRange: arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE] ? arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE]?.split('-')[1] : 0
        };
        return wfhObj;
    } catch (e) {
        console.error(e);
    }
};


/*Mahesh S  : 01-06-2023 : BT-107422 -  Breeze- Positions Overview - End*/

const getArrSingleScripOrderInfo = (data) => {
    const arr = Array(Object.keys(WATCHLIST_GRID_INDEX)?.length)?.fill(0);
    arr[WATCHLIST_GRID_INDEX.SYMBOL] = data?.title;
    arr[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = data?.mktId + '_' + data?.scripToken;
    arr[WATCHLIST_GRID_INDEX.EXCHANGE] = data?.exchange?.split('_')[0];
    arr[WATCHLIST_GRID_INDEX.TOKEN] = data?.scripToken;
    arr[WATCHLIST_GRID_INDEX.SEGMENT_ID] = data?.mktId;
    arr[WATCHLIST_GRID_INDEX.EXPIRYDATE] = data?.expiryDate;
    arr[WATCHLIST_GRID_INDEX.STRIKEPRICE] = data?.strikePrice;
    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD OrderBook - Start
    arr[WATCHLIST_GRID_INDEX.OPTIONTYPE] = data?.optionType;
    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD OrderBook - Start
    arr[WATCHLIST_GRID_INDEX.SERIES] = data?.series;
    arr[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = data?.exchangeSegment || data?.exchange;
    arr[WATCHLIST_GRID_INDEX.INSTRUMENT] = data?.instrument;
    arr[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = data?.assetToken;
    arr[WATCHLIST_GRID_INDEX.PRICE_TICK] = data?.priceTick;
    arr[WATCHLIST_GRID_INDEX.REGULAR_LOT] = data?.regularLot;
    arr[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] = data?.max_transaction_quantity; //BREEZE-16 : Order Slicing Feature :  ManasaB : 13-11-2024 : Reorder issue
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    arr[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = data?.ltp;
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    if (data?.expiryDate) {
        arr[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = data?.title + " " + data?.expiryDate + " " + data?.strikePrice + " " + data?.optionType;
    } else {
        arr[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = data?.title;
    }
    arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = data?.decimalLocator;
    arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = data?.decimalLocatorLength;
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    arr[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] = data?.sSurvMeasureDescription;
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    arr[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] = data?.sSurvMeasureDescription;
    arr[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = data?.sQtyUnit?.trim() || 'Qty';
    // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    arr[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR] = data.nPriceNum;
    arr[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR] = data.nPriceDen;
    arr[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN] = data.nAVMBuyMargin;
    arr[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN] = data.nAVMSellMargin;
    arr[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(data?.mktId)); //Vaibhav S : 29-02-2024 : BT-102298 Added MktsegID in Singlescrip Order function
    // Ajitesh: 20/03/2024 Adding ISIN code for edis scrip check for modify order
    arr[WATCHLIST_GRID_INDEX.ISIN_CODE] = data?.sISINCode;
    return arr;
};

const getArrSipScripOrderInfo = (data) => {
    const arr = [];
    arr[WATCHLIST_GRID_INDEX.SYMBOL] = data?.symbol;
    arr[WATCHLIST_GRID_INDEX.ASK_PRICE] = data?.cap_price;
    arr[WATCHLIST_GRID_INDEX.ASK_QTY] = data?.traded_quantity;
    arr[WATCHLIST_GRID_INDEX.EXCHANGE] = data?.exchange;
    arr[WATCHLIST_GRID_INDEX.TOKEN] = data?.scrip_token;
    arr[WATCHLIST_GRID_INDEX.SEGMENT_ID] = data?.segment_id;
    arr[WATCHLIST_GRID_INDEX.SERIES] = data?.series;

    return arr;
};

let IPO_APP_URL = "";
const getIpoAppUrl = (URL) => {

    IPO_APP_URL = URL;
};
// // ---BT-113521_SrikanthRao_17-07-2023_ConvertingCFTStr-Start

const getClientFacilityTemplate = (str, appInfo) => {
    const obj = {};
    const keyValuePairs = str?.split('$');
    keyValuePairs?.forEach((each) => {
        const objCFT = each.split('|');
        obj[objCFT[0]?.toUpperCase()] = +objCFT[1];
    });

    //HiralK : 01-08-2023 : Client Facility Template - Start
    if (obj.IPO === FACILITY_NUM.ON) {
        const isShowIPO = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_IPO, appInfo);
        if (isShowIPO?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowIPO === FACILITY_NUM.ON || isShowIPO?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
            obj.IPO = FACILITY_NUM.ON;
            getIpoAppUrl(getAppInfoData(APP_INFO_PARAMS?.APP_IPO_LINK, appInfo));
        } else {
            obj.IPO = FACILITY_NUM.OFF;
        }
    } else { }

    // if (obj.BULKORDER === FACILITY_NUM.ON) { --commented as per disussrion with samadan_BT-106965_27_02_2024_SrikanthRao_ordercart
    const isShowOrderCart = getAppInfoData(APP_INFO_PARAMS?.APP_ORDERCART, appInfo);
    const multiIsin = getAppInfoData(APP_INFO_PARAMS.APP_MULTI_ISIN_NSDL, appInfo);

    if ((isShowOrderCart?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowOrderCart === FACILITY_NUM.ON || isShowOrderCart?.toString()?.toLowerCase() === FACILITY_BOOL.ON) && multiIsin) {
        obj.BULKORDER = FACILITY_NUM.ON;
    } else {
        obj.BULKORDER = FACILITY_NUM.OFF;
    }
    // } else { }
    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
    //BT-135024 : Regression - Bug Fixing - Global Search - Modified condition as per wave on suggestion of of Hiral : ManasaB : 14-05-2024 - Start
    if (obj.MULTILEG === FACILITY_NUM.ON) {
        const isShowMultileg = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_MULTILEGORDER, appInfo);
        if (isShowMultileg?.toString()?.toUpperCase() === FACILITY_STR.OFF || isShowMultileg === FACILITY_NUM.OFF || isShowMultileg?.toString()?.toLowerCase() === FACILITY_BOOL.OFF) {
            obj.MULTILEG = FACILITY_NUM.OFF;
        } else {
            obj.MULTILEG = FACILITY_NUM.ON;
        }
        //BT-135024 : Regression - Bug Fixing - Global Search - Modified condition as per wave on suggestion of of Hiral : ManasaB : 14-05-2024 - End
    } else {
        obj.MULTILEG = FACILITY_NUM.OFF;
    }
    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
    if (obj.SIPORSWP === FACILITY_NUM.ON) {
        const isShowSIP = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_EQSIP, appInfo);
        if (isShowSIP?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowSIP === FACILITY_NUM.ON || isShowSIP?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
            obj.SIPORSWP = FACILITY_NUM.ON;
        } else {
            obj.SIPORSWP = FACILITY_NUM.OFF;
        }
    } else { }

    if (obj.ALERT === FACILITY_NUM.ON) {
        const isShowAlert = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_ALERT, appInfo);
        if (isShowAlert?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowAlert === FACILITY_NUM.ON || isShowAlert?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
            obj.ALERT = FACILITY_NUM.ON;
        } else {
            obj.ALERT = FACILITY_NUM.OFF;
        }
    } else { }

    const isShowMF = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_MF, appInfo);
    if (isShowMF?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowMF === FACILITY_NUM.ON || isShowMF?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
        obj.MF = FACILITY_NUM.ON;
    } else {
        obj.MF = FACILITY_NUM.OFF;
    }

    obj.MF = FACILITY_NUM.OFF; /* Shuaib Peerjade : 17-04-2024 This is temporary as mutual fund is not implemented now */

    {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
    if (obj.GTD === FACILITY_NUM.ON) {
        const isShowGTD = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_GTD, appInfo);
        if (isShowGTD?.toString()?.toUpperCase() === FACILITY_STR.ON || isShowGTD === FACILITY_NUM.ON || isShowGTD?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
            obj.GTD = FACILITY_NUM.ON;
        } else {
            obj.GTD = FACILITY_NUM.OFF;
        }
    }
    {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */ }
    // Azeem K:07-05 - 2025 : added conditionally GTT and GTD --Start
    const isGTTSupport = getAppInfoData(APP_INFO_PARAMS?.APP_BREEZE_GTT_SUPPORT, appInfo);

    if (isGTTSupport?.toString()?.toUpperCase() === FACILITY_STR.ON || isGTTSupport === FACILITY_NUM.ON || isGTTSupport?.toString()?.toLowerCase() === FACILITY_BOOL.ON) {
        obj.GTTSUPPORT = FACILITY_NUM.ON;
    } else {
        obj.GTTSUPPORT = FACILITY_NUM.OFF;

    }
    // Azeem K:07-05 - 2025 : added conditionally GTT and GTD --End

    //HiralK : 01-08-2023 : Client Facility Template - End

    // //---KAMESH RANE- 27-07-2023_IPO LICENSESING
    // if (obj.IPO === FACILITY.ON) {
    //     const ipoShowAPP = getAppInfoData(APP_INFO_PARAMS?.APP_SHOW_IPO, appInfo);
    //     const ipoLinkAPP = getAppInfoData(APP_INFO_PARAMS?.APP_IPO_LINK, appInfo);

    //     if (ipoShowAPP?.length != 0) {
    //         if (ipoShowAPP == true) {
    //             Object.keys(obj).forEach((element) => {
    //                 if (element == "IPO") {
    //                     return obj[element] = 1;
    //                 }
    //             });
    //             if (ipoLinkAPP?.length != "") {
    //                 getIpoAppUrl(ipoLinkAPP);
    //             } else {
    //             }

    //         }
    //         else {
    //             Object.keys(obj).forEach((element) => {
    //                 if (element == "IPO") {
    //                     return obj[element] = 0;
    //                 }
    //             });

    //         }
    //     }

    // }
    return obj;
};

let dontMissCol = false;

const setDontMissCol = (prams) => {
    dontMissCol = prams;
};




function findMissingElement(arr1, arr2) {
    for (const obj1 of arr1) {
        let found = false;
        for (const obj2 of arr2) {
            if (isEqual(obj1, obj2)) {
                found = true;
                break;
            }
        }
        if (!found) {
            return obj1;
        }
    }
}
const getNumericMonth = (sMonth) => {
    let sRetval = "";
    switch (sMonth) {
        case "JAN":
            sRetval = "00";
            break;
        case "FEB":
            sRetval = "01";
            break;
        case "MAR":
            sRetval = "02";
            break;
        case "APR":
            sRetval = "03";
            break;
        case "MAY":
            sRetval = "04";
            break;
        case "JUN":
            sRetval = "05";
            break;
        case "JUL":
            sRetval = "06";
            break;
        case "AUG":
            sRetval = "07";
            break;
        case "SEP":
            sRetval = "08";
            break;
        case "OCT":
            sRetval = "09";
            break;
        case "NOV":
            sRetval = "10";
            break;
        case "DEC":
            sRetval = "11";
            break;
        default:
            sRetval = "";
            break;
    }
    return sRetval;
};




//Vaibhav Singh : BT-109089 : 26-10-2023: Error Handling in function
const convertDateToSeconds = (dateToConvert) => {

    let dBseDate = new Date(1980, 0, 1, 0, 0, 0, 0);

    let day = parseInt(dateToConvert?.substr(0, 2));
    let month = parseInt(getNumericMonth(dateToConvert?.substr(2, 3)));
    let year = parseInt(dateToConvert?.substr(5, 4));

    let dSelDate = new Date(year, month, day, 0, 0, 0, 0);

    let diff = Math?.abs(Math?.floor(dSelDate - dBseDate)) / 1000;
    return diff;

};

const checkNonBlankNonZero = (strInput) => {
    var bStatus = false;
    try {

        try {
            if (strInput.length > 0 && strInput != "0")
                bStatus = true;
        }
        catch (e) {
            bStatus = false;
        }
        return bStatus;
    } catch (error) {
        return bStatus;
    }
};

const CheckForNonMinusOne = (strVerificationString) => {
    var bStatus = false;
    try {
        try {
            if (parseFloat(strVerificationString).toFixed(2).toString() == "-1.00")
                bStatus = false;
            else
                bStatus = true;
        }
        catch (e) {
            bStatus = false;
        }
        return bStatus;
    } catch (error) {
        return bStatus;
    }
};

const formatToPercentage = (strUnmodified) => {
    var strModified = "";
    try {
        if (strUnmodified.length > 0)
            strModified = parseFloat(strUnmodified).toFixed(2).toString() + " %";
    }
    catch (e) {
        strModified = "";
    }
    return strModified;
};
//Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
const compareDates = (date1, date2) => {
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();
    const day1 = date1.getDate();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();
    const day2 = date2.getDate();

    if (year1 === year2 && month1 === month2 && day1 === day2) { //compares date,month and year
        return true;
    }
    else {
        return false;
    }
};
//Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - End

const getFixedFloatedValue = (value, nFormat) => {
    const floatedValue = parseFloat(value.toFixed(nFormat));
    return floatedValue;
};
//Vaibhav Singh: BT-107421: 06-02-24: Added Validation in calculateions Updated: Start 
const getSummaryData = (holdingDataItem, holdingDataItemOld, temp = { currentValue: 0, investedValue: 0, overAllPL: 0, todaysPL: 0, prevCloseValue: 0, todaysPLPer: 0, PLPer: 0 }, isWFH, zeroVal, nFormat, calcMethod) => {
    if (holdingDataItem && holdingDataItemOld) {
        temp.currentValue = temp?.currentValue ? getFixedFloatedValue((parseFloat(temp?.currentValue) + (parseFloat(holdingDataItem?.CMV) - parseFloat(holdingDataItemOld?.CMV || calcMethod ? holdingDataItemOld?.CMV : holdingDataItem?.CMV))), nFormat) : getFixedFloatedValue(parseFloat(holdingDataItem?.CMV), nFormat);
        if (temp?.currentValue) {//  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings condition modified
            temp.todaysPL = temp?.todaysPL ? getFixedFloatedValue(parseFloat(temp.todaysPL) + (parseFloat(holdingDataItem?.TodaysPandL || 0) - parseFloat(holdingDataItemOld.TodaysPandL || calcMethod ? holdingDataItemOld?.TodaysPandL : holdingDataItem?.TodaysPandL)), nFormat) : getFixedFloatedValue(parseFloat(holdingDataItem?.TodaysPandL), nFormat);
            temp.overAllPL = getFixedFloatedValue(parseFloat(temp?.currentValue) - parseFloat(temp?.investedValue), nFormat);
            if (isWFH) {
                temp.prevCloseValue = temp?.prevCloseValue ? getFixedFloatedValue((parseFloat(temp.prevCloseValue) + (parseFloat(holdingDataItem.PrevCloseValue) - parseFloat(holdingDataItemOld?.PrevCloseValue || calcMethod ? holdingDataItemOld?.PrevCloseValue : holdingDataItem?.PrevCloseValue))), nFormat) : getFixedFloatedValue(parseFloat(holdingDataItem?.PrevCloseValue), nFormat);
            }
            temp.todaysPLPer = temp.prevCloseValue ? getFixedFloatedValue(((parseFloat(temp.currentValue) - parseFloat(temp.prevCloseValue)) / parseFloat(temp.prevCloseValue)) * MULTIPLIER.HUNDRED, nFormat) : getFixedFloatedValue(zeroVal, nFormat);//Azeem K :27-02-2024:BT-102298: removed  / MULTIPLIER.HUNDRED
            //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :Start
            if (temp.investedValue > 0) {
                temp.PLPer = getFixedFloatedValue(((parseFloat(temp?.currentValue) - parseFloat(temp?.investedValue)) / parseFloat(temp?.investedValue)) * MULTIPLIER.HUNDRED, nFormat);
            } else {
                temp.PLPer = 0;
            }
            //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :End
        }
    }
    return temp;
};
//Vaibhav Singh: BT-107421: 06-02-24: Added Validation in calculateions Updated: End

const updateHoldingData = (holdingDataItem, objMultiTLResp, nFormat, zeroVal) => {


    const total_free_quantity = parseInt(holdingDataItem?.TOTALFREEQUANTITY);

    holdingDataItem.ltp = objMultiTLResp?.LTP || zeroVal.toFixed(objMultiTLResp?.PriceFormat);
    //Vaibhav Singh: 09-07-2025: ClosePrice from multitouchline is added as closeprice from holding api is also not functional in wave as implemented earlier
    holdingDataItem.closePrice =  objMultiTLResp?.ClosePrice ? (objMultiTLResp?.ClosePrice || zeroVal.toFixed(objMultiTLResp?.PriceFormat)) : holdingDataItem.ClosePrice;
    holdingDataItem.PandL = ((parseFloat(holdingDataItem.ltp) - parseFloat(holdingDataItem.nBuyAvgPrice)) * total_free_quantity).toFixed(nFormat);
    holdingDataItem.CMV = (parseFloat(holdingDataItem?.ltp) * total_free_quantity)?.toFixed(2);
    holdingDataItem.PrevCloseValue = ((parseFloat(holdingDataItem.closePrice) * total_free_quantity)).toFixed(nFormat);//Azeem K :27-02-2024:BT-102298: removed  / MULTIPLIER.HUNDRED
    holdingDataItem.ltpChange = objMultiTLResp.ltpChange;
    if (parseFloat(holdingDataItem.InvestedValue) == 0) {
        holdingDataItem.perPandL = (0).toFixed(nFormat);//  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings 
    } else {
        holdingDataItem.perPandL = (((holdingDataItem.CMV - holdingDataItem.InvestedValue) / holdingDataItem.InvestedValue) * MULTIPLIER.HUNDRED
        ).toFixed(nFormat);
    }
    if (!holdingDataItem.sCurvRecvFree || parseInt(holdingDataItem.sCurvRecvFree) == 0) {
        holdingDataItem.TodaysPandL = ((parseFloat(holdingDataItem.ltp) - parseFloat(holdingDataItem.closePrice)) * total_free_quantity).toFixed(nFormat);
        holdingDataItem.TodaysPandLDisplay = getFormattedNumbers(holdingDataItem.TodaysPandL);
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :Start
        if (holdingDataItem.closePrice > 0) {

            holdingDataItem.perTodaysPandL = ((((parseFloat(holdingDataItem.ltp)) - (parseFloat(holdingDataItem.closePrice))) / (parseFloat(holdingDataItem.closePrice))) * MULTIPLIER.HUNDRED).toFixed(nFormat);
        } else {
            holdingDataItem.perTodaysPandL = (0).toFixed(nFormat);
        }
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :End
    } else {
        let todays_qty = parseInt(holdingDataItem.sCurvRecvFree);
        let old_qty = total_free_quantity - todays_qty;
        let avgprice = holdingDataItem?.nTodayAvgBuyPrice ? holdingDataItem?.nTodayAvgBuyPrice : holdingDataItem?.nBuyAvgPrice; //Azeem K :01-07-2025:Zendesk #177953  
        let todays_PandL = (parseFloat(holdingDataItem.ltp) - parseFloat(avgprice)) * todays_qty; //Azeem K :01-07-2025:Zendesk #177953  
        let old_PandL = (parseFloat(holdingDataItem.ltp) - parseFloat(holdingDataItem.closePrice)) * old_qty;
        let todays_value = parseFloat(avgprice) * todays_qty; //Azeem K :01-07-2025:Zendesk #177953  
        let old_value = parseFloat(holdingDataItem.closePrice) * old_qty;
        holdingDataItem.TodaysPandL = (todays_PandL + old_PandL).toFixed(nFormat);
        holdingDataItem.TodaysPandLDisplay = getFormattedNumbers(holdingDataItem.TodaysPandL);
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :Start
        const sumPandL = todays_value + old_value;
        if (sumPandL > 0) {

            holdingDataItem.perTodaysPandL = (((todays_PandL + old_PandL) / sumPandL) * MULTIPLIER.HUNDRED).toFixed(nFormat);
        } else {
            holdingDataItem.perTodaysPandL = (0).toFixed(nFormat);
        }
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :End
    }
    return holdingDataItem;
};

const onTouchLineSubscriptionForPortfolioSummary = (arrTouchLineData) => {
    if (arrTouchLineData?.length) {
        const obj = {
            ATP: arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE],
            BuyPrice: arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE],
            BuyQty: arrTouchLineData[TL_INDEX.BUY_QTY],
            ClosePrice: arrTouchLineData[TL_INDEX.CLOSE_PRICE],
            DecimalLocator: 0,
            DPR: arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE],
            HighOpenInt: arrTouchLineData[TL_INDEX.OPEN_INTEREST],
            HighPrice: arrTouchLineData[TL_INDEX.HIGH_PRICE],
            LifeTimeHigh: arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH],
            LifeTimeLow: arrTouchLineData[TL_INDEX.LIFE_TIME_LOW],
            LowOpenInt: arrTouchLineData[TL_INDEX.OPEN_INTEREST],
            LowPrice: arrTouchLineData[TL_INDEX.LOW_PRICE],
            LTP: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
            LTQ: arrTouchLineData[TL_INDEX.LAST_TRADE_QTY],
            LTT: arrTouchLineData[TL_INDEX.LAST_TRADE_TIME],
            LUT: arrTouchLineData[TL_INDEX.LAST_UPDATED_TIME],
            NetChangeInRs: arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR],
            OpenInt: arrTouchLineData[TL_INDEX.OPEN_INTEREST],
            OpenPrice: arrTouchLineData[TL_INDEX.OPEN_PRICE],
            PercNetChange: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
            PercOpenInt: arrTouchLineData[TL_INDEX.OPEN_INTEREST],
            Scrip: {
                isGlobal: "0",
                isIndex: false,
                sIndexDesc: "",
                token: arrTouchLineData[TL_INDEX.TOKEN],
                _MapMktSegId: arrTouchLineData[TL_INDEX.SEGMENT_ID],
                _MktSegId: arrTouchLineData[TL_INDEX.SEGMENT_ID],
            },
            SellPrice: arrTouchLineData[TL_INDEX.SELL_PRICE],
            SellQty: arrTouchLineData[TL_INDEX.SELL_QTY],
            TotalBuyQty: arrTouchLineData[TL_INDEX.TOTAL_BUY_QTY],
            TotalSellQty: arrTouchLineData[TL_INDEX.TOTAL_SELL_QTY],
            Volume: arrTouchLineData[TL_INDEX.VOLUME],
            ltpChange: arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR],
        };
        return obj;
    }
    else {
        return undefined;
    }

};

// // Neha Kumari : 08-08-23  : BT-107433 - Fibonacci calculator calculation start
// let uptrendExtension = 0;
// let uptrendRetracement = 0;
// let downtrendRetracement = 0;
// let downtrendExtension = 0;

// const calculateFibonacciLevels = (arrStandardRetracementLevels, arrStandardExtensionLevels, calculatorInputs, toggleUptrendDowntrendBtn, toggleRetracementExtensionBtn) => {
//     const arrUptrendExtension = [];
//     const arrUptrendRetracement = [];
//     const arrDowntrendRetracement = [];
//     const arrDowntrendExtension = [];
//     //for uptrend extension -> UE
//     if (toggleUptrendDowntrendBtn === 0 && toggleRetracementExtensionBtn === 1) {
//         for (let i = 0; i < arrStandardExtensionLevels.length; i++) {
//             uptrendExtension = Number(calculatorInputs?.fibonacciHighPrice) + ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardExtensionLevels[i]);
//             arrUptrendExtension.push(uptrendExtension.toFixed(1));
//         }
//         return arrUptrendExtension;
//     }
//     //for uptrend retracement -> UR
//     else if (toggleUptrendDowntrendBtn === 0 && toggleRetracementExtensionBtn === 0) {
//         for (let i = 0; i < arrStandardRetracementLevels.length; i++) {
//             uptrendRetracement = Number(calculatorInputs?.fibonacciHighPrice) - ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardRetracementLevels[i]);
//             arrUptrendRetracement.push(uptrendRetracement.toFixed(1));
//         }
//         return arrUptrendRetracement;
//     }
//     // for downtrend retracement -> DR
//     else if (toggleUptrendDowntrendBtn === 1 && toggleRetracementExtensionBtn === 0) {
//         for (let i = 0; i < arrStandardRetracementLevels.length; i++) {
//             downtrendRetracement = Number(calculatorInputs?.fibonacciLowPrice) + ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardRetracementLevels[i]);
//             arrDowntrendRetracement.push(downtrendRetracement).toFixed(1);
//         }
//         return arrDowntrendRetracement;
//     }
//     // for downtrend extension -> DE
//     else if (toggleUptrendDowntrendBtn === 1 && toggleRetracementExtensionBtn === 1) {
//         for (let i = 0; i < arrStandardExtensionLevels.length; i++) {
//             downtrendExtension = Number(calculatorInputs?.fibonacciLowPrice) - ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardExtensionLevels[i]);
//             arrDowntrendExtension.push(downtrendExtension.toFixed(1));
//         }
//         return arrDowntrendExtension;
//     } else { }
// };
// // // Neha Kumari : 08-08-23  : BT-107433 - Fibonacci calculator calculation start

// Vaibhav Singh: 06-12-23: BT-109089: added pagecalled param and updated R4 S4 logic : Start
const calculateSupportRestistanceValues = (arrActiveScripInformation, CALMETHOD, PPFORMULA, nPriceFormat, pageCalled = false) => {
    // Vaibhav singh: BT-109089 : 25-10-23: Updated Support resistance function accordingly 
    var prevDayOpen = arrActiveScripInformation?.PrevOpen ?? arrActiveScripInformation?.[WATCHLIST_GRID_INDEX.OPEN] ?? 0;
    var prevDayHigh = arrActiveScripInformation?.PrevHigh ?? arrActiveScripInformation?.[WATCHLIST_GRID_INDEX.HIGH] ?? 0;
    var prevDayLow = arrActiveScripInformation?.PrevLow ?? arrActiveScripInformation?.[WATCHLIST_GRID_INDEX.LOW] ?? 0;
    var prevDayClose = arrActiveScripInformation?.PrevClose ?? arrActiveScripInformation?.[WATCHLIST_GRID_INDEX.CLOSE] ?? 0;

    var resistance4 = ('0.0000');
    var resistance3 = ('0.0000');
    var resistance2 = ('0.0000');
    var resistance1 = ('0.0000');

    var pivotPoint = ('0.0000');

    var support1 = ('0.0000');
    var support2 = ('0.0000');
    var support3 = ('0.0000');
    var support4 = ('0.0000');


    var calculationMethod = (CALMETHOD);
    var PPFormula = (PPFORMULA);

    var minimum = ('0.0000');
    var maximum = ('0.0000');

    var range = ('0.0000');

    var midPoint1 = ('0.0000');
    var midPoint2 = ('0.0000');
    var midPoint3 = ('0.0000');
    var midPoint4 = ('0.0000');
    var midPoint5 = ('0.0000');
    var midPoint6 = ('0.0000');
    var midPoint7 = ('0.0000');
    var midPoint8 = ('0.0000');


    const calculatePP = () => {
        var pivotPoint;
        switch (PPFormula) {
            case "(H+L+C)/3":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + parseFloat(prevDayClose)) / 3).toFixed(nPriceFormat);
                break;
            case "(H+L+O)/3":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + parseFloat(prevDayOpen)) / 3).toFixed(nPriceFormat);
                break;
            case "(H+L+C+O)/4":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + parseFloat(prevDayClose) + parseFloat(prevDayOpen)) / 4).toFixed(nPriceFormat);
                break;
            case "(H+L+C+C)/4":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + parseFloat(prevDayClose) + parseFloat(prevDayClose)) / 4).toFixed(nPriceFormat);

                break;
            case "(H+L+O+O)/4":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + parseFloat(prevDayOpen) + parseFloat(prevDayOpen)) / 4).toFixed(nPriceFormat);
                break;
            case "(H+L)/2":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow)) / 2).toFixed(nPriceFormat);
                break;
            case "(H+C)/2":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayClose)) / 2).toFixed(nPriceFormat);
                break;
            case "(L+C)/2":
                pivotPoint = ((parseFloat(prevDayLow) + parseFloat(prevDayClose)) / 2).toFixed(nPriceFormat);
                break;
            case "(H + L + 2C)/4":
                pivotPoint = ((parseFloat(prevDayHigh) + parseFloat(prevDayLow) + (2 * parseFloat(prevDayClose))) / 4).toFixed(nPriceFormat);
                break;
            default:
                break;
        }
        pivotPoint = (pivotPoint);
        const supportResistanceInfo = calculateSupportResistance(pivotPoint, pageCalled);
        return { supportResistanceInfo: supportResistanceInfo, pivotPoint: pivotPoint };


    };

    const calculateSupportResistance = (pivotPoint, pageCalled) => {
        calculaterange();
        switch (calculationMethod) {
            //Vaibhav Singh : 07-10-23: Reverted changes done by manasa for classic Changed Formula: Start 
            case "Classic":
                maximum = ((parseFloat(pivotPoint) + parseFloat(range) * 3).toFixed(nPriceFormat));
                minimum = ((parseFloat(pivotPoint) - parseFloat(range) * 3).toFixed(nPriceFormat));
                calculateMinimum(maximum, minimum);
                resistance1 = ((2 * parseFloat(pivotPoint) - parseFloat(prevDayLow)).toFixed(nPriceFormat));
                resistance2 = ((parseFloat(pivotPoint) + parseFloat(range)).toFixed(nPriceFormat));
                resistance3 = ((parseFloat(resistance2) + parseFloat(range)).toFixed(nPriceFormat));
                resistance4 = ((parseFloat(resistance3) + parseFloat(range)).toFixed(nPriceFormat));
                support1 = ((2 * parseFloat(pivotPoint) - parseFloat(prevDayHigh)).toFixed(nPriceFormat));
                support2 = ((parseFloat(pivotPoint) - parseFloat(range)).toFixed(nPriceFormat));
                support3 = ((parseFloat(support2) - parseFloat(range)).toFixed(nPriceFormat));
                support4 = ((parseFloat(support3) - parseFloat(range)).toFixed(nPriceFormat));
                break;
            //Vaibhav Singh : 07-10-23: Reverted changes done by manasa for classic Changed Formula: End 
            case "Woodie":
                maximum = ((parseFloat(pivotPoint) + parseFloat(range) * 3).toFixed(nPriceFormat));
                minimum = ((parseFloat(pivotPoint) - parseFloat(range) * 3).toFixed(nPriceFormat));
                calculateMinimum(maximum, minimum);
                resistance2 = (parseFloat(pivotPoint) + parseFloat(range)).toFixed(nPriceFormat);
                resistance1 = ((2 * parseFloat(pivotPoint)) - parseFloat(prevDayLow)).toFixed(nPriceFormat);
                support1 = ((2 * parseFloat(pivotPoint) - parseFloat(prevDayHigh))).toFixed(nPriceFormat);
                support2 = ((parseFloat(pivotPoint) - parseFloat(range)).toFixed(nPriceFormat));
                break;
            case "Camarilla":
                maximum = ((parseFloat(prevDayClose) + parseFloat(range) * (1.1 / 2)).toFixed(nPriceFormat));
                minimum = ((parseFloat(prevDayClose) - parseFloat(range) * (1.1 / 2)).toFixed(nPriceFormat));
                calculateMinimum(maximum, minimum);
                resistance4 = (parseFloat(prevDayClose) + (parseFloat(range) * (1.1 / 2))).toFixed(nPriceFormat);
                resistance3 = (parseFloat(prevDayClose) + (parseFloat(range) * (1.1 / 4))).toFixed(nPriceFormat);
                resistance2 = (parseFloat(prevDayClose) + (parseFloat(range) * (1.1 / 6))).toFixed(nPriceFormat);
                resistance1 = (parseFloat(prevDayClose) + (parseFloat(range) * (1.1 / 12))).toFixed(nPriceFormat);
                support1 = (parseFloat(prevDayClose) - (parseFloat(range) * (1.1 / 12))).toFixed(nPriceFormat);
                support2 = (parseFloat(prevDayClose) - (parseFloat(range) * (1.1 / 6))).toFixed(nPriceFormat);
                support3 = (parseFloat(prevDayClose) - (parseFloat(range) * (1.1 / 4))).toFixed(nPriceFormat);
                support4 = (parseFloat(prevDayClose) - (parseFloat(range) * (1.1 / 2))).toFixed(nPriceFormat);
                break;
            case "Fibonacci":
                var FBRatio1 = ('0.3820');
                var FBRatio2 = ('0.6180');
                var FBRatio3 = ('1.0000');
                var FBRatio4 = ('1.3820');

                maximum = ((parseFloat(pivotPoint) + parseFloat(range) * parseFloat(FBRatio4)).toFixed(nPriceFormat));
                minimum = ((parseFloat(pivotPoint) - parseFloat(range) * parseFloat(FBRatio4)).toFixed(nPriceFormat));
                calculateMinimum(maximum, minimum);
                resistance3 = (parseFloat(pivotPoint) + (parseFloat(range) * parseFloat(FBRatio3))).toFixed(nPriceFormat);
                resistance2 = (parseFloat(pivotPoint) + (parseFloat(range) * parseFloat(FBRatio2))).toFixed(nPriceFormat);
                resistance1 = (parseFloat(pivotPoint) + (parseFloat(range) * parseFloat(FBRatio1))).toFixed(nPriceFormat);
                support1 = (parseFloat(pivotPoint) - (parseFloat(range) * parseFloat(FBRatio1))).toFixed(nPriceFormat);
                support2 = (parseFloat(pivotPoint) - (parseFloat(range) * parseFloat(FBRatio2))).toFixed(nPriceFormat);
                support3 = (parseFloat(pivotPoint) - (parseFloat(range) * parseFloat(FBRatio3))).toFixed(nPriceFormat);
                break;
            case "Tom DeMark": {
                let value;
                if (prevDayClose < prevDayOpen) {
                    value = (parseFloat(prevDayHigh) + (2 * parseFloat(prevDayLow)) + parseFloat(prevDayClose)).toFixed(nPriceFormat);
                }
                else if (prevDayClose > prevDayOpen) {
                    value = ((2 * parseFloat(prevDayHigh)) + parseFloat(prevDayLow) + parseFloat(prevDayClose)).toFixed(nPriceFormat);
                }
                else if (prevDayClose == prevDayOpen) {
                    value = (parseFloat(prevDayHigh) + parseFloat(prevDayLow) + (2 * parseFloat(prevDayClose))).toFixed(nPriceFormat);
                }
                //ManasaB : 04/12/2023 : Resolved Bug in Pivot POint Calculator - Start
                resistance1 = ((parseFloat(value) / 2) - parseFloat(prevDayLow)).toFixed(nPriceFormat);
                support1 = ((parseFloat(value) / 2) - parseFloat(prevDayHigh)).toFixed(nPriceFormat);
                //ManasaB : 04/12/2023 : Resolved Bug in Pivot POint Calculator - End
                break;
            }
            default:
                break;
        }
        const midPoint = calculateMidpoint(pivotPoint, resistance1, resistance2, resistance3, resistance4, support1, support2, support3, support4);
        let result = {};
        let objResistance = {};
        let objSupport = {};
        // Vaibhav Singh: 06-12-23: BT-109089: added pagecalled param and updated R4 S4 logic updated : Start
        if (resistance1 > 0) {
            objResistance["R1"] = resistance1;
        }
        else {
            objResistance["R1"] = pageCalled ? resistance1 : "-";
        }
        if (resistance2 > 0) {
            objResistance["R2"] = resistance2;
        }
        else {
            objResistance["R2"] = pageCalled ? resistance2 : '-';
        }
        if (resistance3 > 0) {
            objResistance["R3"] = resistance3;
        }
        else {
            objResistance["R3"] = pageCalled ? resistance3 : '-';
        }
        if (resistance4 > 0) {
            objResistance["R4"] = resistance4;
        }
        else {
            objResistance["R4"] = pageCalled ? resistance4 : '-';
        }
        result["resistance"] = objResistance;

        if (support1 > 0) {
            objSupport["S1"] = support1;
        }
        else {
            objSupport["S1"] = pageCalled ? support1 : '-';
        }
        if (support2 > 0) {
            objSupport["S2"] = support2;
        }
        else {
            objSupport["S2"] = pageCalled ? support2 : '-';
        }
        if (support3 > 0) {
            objSupport["S3"] = support3;
        }
        else {
            objSupport["S3"] = pageCalled ? support3 : '-';
        }
        if (support4 > 0) {
            objSupport["S4"] = support4;
        }
        else {
            objSupport["S4"] = pageCalled ? support4 : '-';
        }
        result["support"] = objSupport;
        result["midPoint"] = midPoint;
        return result;
    };
    // Vaibhav Singh: 06-12-23: BT-109089: added pagecalled param and updated R4 S4 logic updated : End
    const calculateMidpoint = (pivotPoint, resistance1, resistance2, resistance3, resistance4, support1, support2, support3, support4) => {
        if (resistance4 > 0) {
            midPoint1 = ((parseFloat(resistance4) + parseFloat(resistance3)) / 2).toFixed(nPriceFormat);
        }
        if (resistance3 > 0) {
            midPoint2 = ((parseFloat(resistance3) + parseFloat(resistance2)) / 2).toFixed(nPriceFormat);
        }
        if (resistance2 > 0) {
            midPoint3 = ((parseFloat(resistance2) + parseFloat(resistance1)) / 2).toFixed(nPriceFormat);
        }
        if (resistance1 > 0) {
            midPoint4 = ((parseFloat(resistance1) + parseFloat(pivotPoint)) / 2).toFixed(nPriceFormat);
        }
        if (support1 > 0) {
            midPoint5 = ((parseFloat(pivotPoint) + parseFloat(support1)) / 2).toFixed(nPriceFormat);
        }
        if (support2 > 0) {
            midPoint6 = ((parseFloat(support1) + parseFloat(support2)) / 2).toFixed(nPriceFormat);
        }
        if (support3 > 0) {
            midPoint7 = ((parseFloat(support2) + parseFloat(support3)) / 2).toFixed(nPriceFormat);
        }
        if (support4 > 0) {
            midPoint8 = ((parseFloat(support3) + parseFloat(support4)) / 2).toFixed(nPriceFormat);
        }
        let objMidPoint = {};
        let objSupportMidPoint = {};
        if (midPoint1 > 0) {
            objMidPoint["midPoint1"] = midPoint1;
        }
        if (midPoint2 > 0) {
            objMidPoint["midPoint2"] = midPoint2;
        }
        if (midPoint3 > 0) {
            objMidPoint["midPoint3"] = midPoint3;
        }
        if (midPoint4 > 0) {
            objMidPoint["midPoint4"] = midPoint4;
        }
        if (midPoint5 > 0) {
            objSupportMidPoint["midPoint5"] = midPoint5;
        }
        if (midPoint6 > 0) {
            objSupportMidPoint["midPoint6"] = midPoint6;
        }
        if (midPoint7 > 0) {
            objSupportMidPoint["midPoint7"] = midPoint7;
        }
        if (midPoint8 > 0) {
            objSupportMidPoint["midPoint8"] = midPoint8;
        }
        const midPointInfo = {
            resistanceMidPoint: objMidPoint,
            supportMidPoint: objSupportMidPoint
        };
        return midPointInfo;
    };
    //ManasaB : 21/11/2023 : BT-115296 Calculator Bug Fixing - End

    const calculaterange = () => {
        range = (parseFloat(prevDayHigh) - parseFloat(prevDayLow));
    };


    const calculateMinimum = (maximum, minimum) => {
        if ((parseFloat(maximum) - parseFloat(minimum)) <= 40) {
            minimum = (parseFloat(minimum) - (parseFloat(maximum) - parseFloat(minimum) / 9)).toFixed(nPriceFormat);
        }
        else {
            minimum = (parseFloat(minimum) - 10);
        }
    };

    return calculatePP();
};
// ---BT-113521_SrikanthRao_17-07-2023-Start
const bExchahangesAllowed = (exchangeId) => {
    let objActiveSession = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    let arrSessionExchange = objActiveSession?.data?.exchanges;
    const strExchangeNameFromMktSegId = getApiExchangeNameFromMktSegId(exchangeId);
    const nIndex = arrSessionExchange.findIndex(e => e === strExchangeNameFromMktSegId);
    if (nIndex < 0) {
        return false;
    } else { return true; }

};
// ---BT-113521_SrikanthRao_17-07-2023-end

const getDateLivepulse = (seconds, strFormat) => {
    var d1 = new Date("01/01/1970 00:00:00");
    d1.setSeconds(seconds);
    var t = "";
    if (strFormat == undefined || strFormat == null || strFormat == '') {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'sep', 'Oct', 'Nov', 'Dec'];
        t = this.getFormattedDays(d1.getDate()) + ' ' + months[d1.getMonth()].toUpperCase() + ' ' + (parseInt(d1.getHours().toString())) + ':' + (parseInt(d1.getMinutes().toString())) + ':' + d1.getSeconds();
        return t;
    }
    else { }
};
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

function fnRoundUp(dblPrice, dblPriceTick, MPDecPrecision, MPDecLoc) {
    let dblval = 0;
    let dblFactor = fnGetDivFactor(dblPrice.toFixed(MPDecPrecision), MPDecLoc) % fnGetDivFactor(dblPriceTick);
    if (dblFactor == 0) {
        dblval = dblPrice;
    }
    else {
        dblval = dblPrice + (dblPriceTick - (dblPrice % dblPriceTick));
    }
    return dblval;
}

function fnRoundDown(dblPrice, dblPriceTick, MPDecPrecision, MPDecLoc) {
    let dblval = 0;
    try {
        let dblFactor = fnGetDivFactor(dblPrice.toFixed(MPDecPrecision), MPDecLoc) % fnGetDivFactor(dblPriceTick);
        if (dblFactor == 0) {
            dblval = dblPrice;
        }
        else {
            dblval = dblPrice - (dblPrice % dblPriceTick);
        }

    } catch (error) {
        console.error(error);
    }
    return dblval;
}

function fnGetDivFactor(dblVal, MPDecLoc) {
    return Math.round(parseFloat(dblVal) * MPDecLoc);
}

function getProductTypeValue(productType) {

    productType = productType?.trim();
    var strProdType = "";
    switch (productType) {
        case ORDER_PRODUCT_TYPES.MARGIN:
        case ORDER_PRODUCT_TYPES.INTRADAY:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.MARGIN_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.DELIVERY:
        case ORDER_PRODUCT_TYPES.CARRYFORWARD:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.DELIVERY_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.MTF:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.MTF_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.COVER:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.MP_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.PTST:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.PTST_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.AMO_MARGIN:
        case ORDER_PRODUCT_TYPES.AMO_INTRADAY:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.AMO_MARGIN_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.AMO_DELIVERY:
        case ORDER_PRODUCT_TYPES.AMO_CARRYFORWARD:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.AMO_DELIVERY_VALUE;
            break;
        case ORDER_PRODUCT_TYPES.BRACKET:
            strProdType = ORDER_PRODUCT_TYPES_VALUES.BRACKET_VALUE;
            break;
        default:
            strProdType = '';
            break;
    }
    return strProdType;
}
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End


const getTradeTimeForValue = (seconds) => {

    let _returnTime = "";
    var d1 = new Date("01/01/1980 00:00:00");
    d1.setSeconds(seconds);
    let _ampm = new Date(d1).getHours() >= 12 ? 'PM' : 'AM';
    let _minutes = new Date(d1).getMinutes() > 9 ? new Date(d1).getMinutes().toString() : ('0' + new Date(d1).getMinutes().toString());
    let _hrs = new Date(d1).getHours() % 24 > 0 ? new Date(d1).getHours() % 24 : new Date(d1).getHours();//BT-120319 : Scrip Overview – Market Movement : Bug Fixing : Manasa B : 23/10/2023 
    let _sec = new Date(d1).getSeconds();
    if (_hrs < 10) {
        _hrs = '0' + _hrs;
    }
    _returnTime = _hrs + ':' + _minutes + ':' + (_sec > 9 ? _sec : ('0' + _sec));
    return _returnTime;
};


const removeExpiriedScrip = (expiryDate) => {
    try {
        if (expiryDate && expiryDate != 0 && expiryDate != "NA") {
            let current_datetime = new Date();
            let currentFormattedDate = new Date(current_datetime.getFullYear(), current_datetime.getMonth(), current_datetime.getDate());
            let expiredDate = new Date("01/01/1980 00:00:00");
            expiredDate.setSeconds(expiryDate);
            if (currentFormattedDate > expiredDate)
                return false;
            else
                return true;
        }
        else {
            return true;
        }

    } catch (error) {

    }

};


const convertColumnsDatatoGridColumns = (columns) => {
    const updatedColumnDef = columns?.map((eachColumn) => {
        const settings = eachColumn?.sSettings;
        return { field: (settings.field)?.toString(), headerName: eachColumn?.sColumnName, filter: settings?.filterType, hide: settings?.hide ? true : false, nSequenceNo: eachColumn?.nSequenceNo };

    });
    //updatedColumnDef?.unshift({ headerName: '' });
    const sortedColumnDefs = updatedColumnDef?.sort((a, b) => a?.nSequenceNo - b?.nSequenceNo);
    return sortedColumnDefs;
};


const filterObjects = (element) => {
    return Array.isArray(element);
};


//BT-115082 : Creating common function for search : Generating ViewAllowed : ManasaB : 03/08/2023 - Start
export const getApiExchangeMktSegment = (arrExchName) => {
    let iMtSegVal = 0;
    for (let index = 0; index < arrExchName?.length; index++) {
        const strExchName = arrExchName[index];

        if (strExchName == EXCHANGE_NAME_API.NSE_EQ_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH;
            continue;
        }
        if (strExchName == EXCHANGE_NAME_API.NSE_DERV_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_DERIVATIVES;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.BSE_EQ_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.BSE_DERV_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_DERIVATIVES;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.MCX_DERV_API) { //MCX_FUTURES_API
            //   iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_MCX_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.NCDEX_DERV_API) { //NCDEX_FUTURES_API
            //  iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_NCDEX_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES;
            continue;
        }
        //NSE CUR
        if (strExchName == EXCHANGE_NAME_API.NSX_DERV_API) { //NSE_CUR_API
            // iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_NSX_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_DERIVATIVES;
            continue;
        }
        //BSE CUR
        if (strExchName == EXCHANGE_NAME_API.BSECDX_DERV_API) { //BSE_CUR_API
            // iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_BSECDX_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECDX_DERIVATIVES;
            continue;
        }
        //NSE_COMM
        if (strExchName == EXCHANGE_NAME_API.NSE_COMM_API) {
            //  iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_NSECOMM_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_NSECOMM_DERIVATIVES;
            continue;
        }
        //BSE_COMM
        if (strExchName == EXCHANGE_NAME_API.BSE_COMM_API) {
            //  iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_BSECOMM_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_BSECOMM_DERIVATIVES;
            continue;
        }
        // //ICEX_DERV_API
        if (strExchName == EXCHANGE_NAME_API.ICEX_DERV_API) {
            // iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_ICEX_DERIVATIVES;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_ICEX_DERIVATIVES;
            continue;
        }
        // //NSE_OTS_API
        if (strExchName == EXCHANGE_NAME_API.NSE_OTS_API) {
            // iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_OFS_IPO_BONDS;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_OFS_IPO_BONDS;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.MCXSX_CURR_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_DERIVATIVES;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.MCXSX_EQ_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_CASH;
            continue;
        }

        if (strExchName == EXCHANGE_NAME_API.MCXSX_DERV_API) {
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_MSX_FAO;
            continue;
        }


        //<BT-64716/BT-40448> <MF and NFO in Wave 2.0> START
        if (strExchName == EXCHANGE_NAME_API.MUTUAL_FUND) {
            // iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_MUTUAL_FUND;
            iMtSegVal += MAPPED_MARKET_SEGMENT_ID.MAPPED_MUTUAL_FUND;
            continue;
        }//<BT-64716/BT-40448> <MF and NFO in Wave 2.0> END
        //MSX_FIM_API
        // if (strExchName == DYANMIC_URL_CONSTANTS.MSX_FIM_API) {
        //     iMtSegVal += DYANMIC_URL_CONSTANTS.C_V_MAPPED_OFS_IPO_BONDS;
        //     continue;
        // }
    }
    return iMtSegVal;
};


const includeSpotMarket = (mappedMarketAllowed) => {
    if (mappedMarketAllowed & MAPPED_MARKET_SEGMENT_ID.NSE_DERIVATIVES) {
        mappedMarketAllowed = mappedMarketAllowed | MAPPED_MARKET_SEGMENT_ID.NSE_CASH;
    }
    if (mappedMarketAllowed & MAPPED_MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
        mappedMarketAllowed = mappedMarketAllowed | MAPPED_MARKET_SEGMENT_ID.BSE_CASH;
    }
    if (mappedMarketAllowed & MAPPED_MARKET_SEGMENT_ID.MCX_DERIVATIVES) {
        mappedMarketAllowed = mappedMarketAllowed | MAPPED_MARKET_SEGMENT_ID.MCX_SPOT;
    }
    if (mappedMarketAllowed & MAPPED_MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
        mappedMarketAllowed = mappedMarketAllowed | MAPPED_MARKET_SEGMENT_ID.NCDEX_SPOT;
    }
    return mappedMarketAllowed;
};
const getViewAllowed = (objLoginSession) => {
    const mktSegAllowed = getApiExchangeMktSegment(objLoginSession?.data?.exchanges);
    const broadcastSegAllowed = getApiExchangeMktSegment(objLoginSession?.data?.bcastExchanges);
    const viewAllowed = broadcastSegAllowed || includeSpotMarket(mktSegAllowed);
    return viewAllowed;
};
//BT-115082 : Creating common function for search : Generating ViewAllowed : ManasaB : 03/08/2023 - End

//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -based on allowed market only indices are allowed --Start
const exchangeAllowed = (SegmentId, objLoginSession) => {
    let type = "OFF";
    let exChanges = objLoginSession?.data?.exchanges;
    let bcastExchanges = objLoginSession?.data?.bcastExchanges;
    if (exChanges?.findIndex(each => each === getApiExchangeNameFromMktSegId(SegmentId)) !== -1 || bcastExchanges?.findIndex(each => each === getApiExchangeNameFromMktSegId(SegmentId)) !== -1) {
        type = "ON";
    }
    return type;
};
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -based on allowed market only indices are allowed --End

//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -based on allowed market only indices are allowed --Start
export const isMktDataAllowed = (SegmentId, objLoginSession) => {
    try {
        var isMarketAllowed = false;

        // if (clsGlobal.User.isGuestUser) { //ShivaniG [BT-88282] 05/07/2022 [Using clsGlobal.User.isGuestUser instead of clsGlobal.IsGuestUser]
        //     let allowedExchanges: any = JSON.parse(clsGlobal.dConfigMaster.getItem("APP_GUEST_EXCHANGE_ALLOWED"));
        //     if (allowedExchanges.indexOf(SegmentId.toString()) != -1) {
        //         return true;
        //     }
        //     else {
        //         return false;
        //     }
        // }

        var strSegmentStatus = exchangeAllowed(SegmentId, objLoginSession);
        if (strSegmentStatus === "ON")
            isMarketAllowed = true;

        return isMarketAllowed;
    } catch (e) {

        return false;
    }
};
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -based on allowed market only indices are allowed --End

const filterSpCharsAndSpacesOut = (value) => {
    const filteredValue = value?.replace(/[^a-zA-Z0-9]/g, '');
    return filteredValue;
};
// ---BT-107433_SrikanthRao_16-08-2023_Option Calculator || Functional Implementation


const getAssetExchangeName = (segmentid) => {
    let intMktSegId = parseInt(segmentid);
    var strExName = "";

    switch (intMktSegId) {
        case MARKET_SEGMENT_ID.NSE_CASH:
        case MARKET_SEGMENT_ID.NSE_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.NSE_EQ_API;
            break;

        case MARKET_SEGMENT_ID.BSE_CASH:
        case MARKET_SEGMENT_ID.BSE_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.BSE_EQ_API;
            break;

        case MARKET_SEGMENT_ID.MCX_SPOT:
        case MARKET_SEGMENT_ID.MCX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.MCX_SPOT_API;
            break;

        case MARKET_SEGMENT_ID.NCDEX_SPOT:
        case MARKET_SEGMENT_ID.NCDEX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.NCDEX_SPOT_API;
            break;

        case MARKET_SEGMENT_ID.MSX_CASH:
        case MARKET_SEGMENT_ID.MSX_FAO:
            strExName = EXCHANGE_NAME_API.MCXSX_EQ_API;
            break;

        case MARKET_SEGMENT_ID.MSX_SPOT:
        case MARKET_SEGMENT_ID.MSX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.MSE_SPOT;
            break;

        case MARKET_SEGMENT_ID.NSX_SPOT:
        case MARKET_SEGMENT_ID.NSX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.NSX_SPOT_API;
            break;

        case MARKET_SEGMENT_ID.BSECDX_SPOT:
        case MARKET_SEGMENT_ID.BSECDX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.BSECDX_SPOT_API;
            break;

        // BT-105190 BT-105191, NSE BSE Commodity Segment, Samadhan S, 18/04/2023 : Start

        case MARKET_SEGMENT_ID.UCX_DERIVATIVES:
            strExName = EXCHANGE_NAME_API.NSE_COMM_API;
            break;

        case MARKET_SEGMENT_ID.NMCE_DERVIVATIVES:
            strExName = EXCHANGE_NAME_API.BSE_COMM_API;
            break;
        default: ;

        // BT-105190 BT-105191, NSE BSE Commodity Segment, Samadhan S, 18/04/2023 : End
    }
    return strExName.trim();
};
const removeDuplicatesAndSort = (arr) => {

    const uniqueValueSet = new Set(arr);

    const uniqueValueArray = Array.from(uniqueValueSet);

    uniqueValueArray.sort((a, b) => a - b);

    return uniqueValueArray;

};

// ---BT-107433_SrikanthRao_16-08-2023_Option Calculator || Functional Implementation

//BT-113692 : Function For Holdings Upadtion : Vaibhav Singh : 19-08-2023
const getChangeInRs = (LTP, ClosePrice, nFormat, isMktWatch, arrowType) => {

    try {
        let arrChnageData = [];
        if (LTP != '' && ClosePrice != '') {
            // ClosePrice= ClosePrice/100
            let NetChgRs = parseFloat(LTP) - parseFloat(ClosePrice);
            let NetChangeInRs = NetChgRs.toFixed(nFormat);
            let PercNetChng = parseFloat(ClosePrice) != 0 ? (parseFloat(NetChangeInRs) / parseFloat(ClosePrice)) * 100 : 0;
            let PercNetChange = PercNetChng.toFixed(2);
            let LTPTrend = '';

            if (parseFloat(NetChangeInRs) > 0) {
                arrChnageData.push('+' + Math.abs(parseFloat(NetChangeInRs)).toFixed(nFormat));
                arrChnageData.push("+" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%");
                ///arrChnageData.push("+" + Math.abs(parseFloat(PercNetChange)).toFixed(2));
                LTPTrend = "color-positive";
            }
            else if (parseFloat(NetChangeInRs) < 0) {
                arrChnageData.push('-' + Math.abs(parseFloat(NetChangeInRs)).toFixed(nFormat));
                arrChnageData.push("-" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%");
                //arrChnageData.push("-" + Math.abs(parseFloat(PercNetChange)).toFixed(2));
                LTPTrend = "color-negative";
            } else {
                arrChnageData.push(Math.abs(parseFloat(NetChangeInRs)).toFixed(nFormat));
                //arrChnageData.push("(" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%)");
                arrChnageData.push("" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "");
                LTPTrend = "";
            }
            arrChnageData.push(LTPTrend);
            arrChnageData.push(parseFloat(PercNetChange));

            if (isMktWatch != undefined && isMktWatch)
                arrChnageData.push(PercNetChange);

        } else {
            let zeroVal = 0;
            arrChnageData.push(zeroVal.toFixed(nFormat));
            arrChnageData.push('(0.00)');
            arrChnageData.push('');
            if (isMktWatch != undefined && isMktWatch)
                arrChnageData.push('0.00');
        }

        return arrChnageData;

    } catch (error) {
        return error;

    }
};





function findIndexForValueBetween(array, value) {
    for (let i = 0; i < array.length - 1; i++) {
        if (value >= array[i] && value < array[i + 1]) {
            return i + 1;
        }
    }
    return -1;
}

/**BT-109096 -- Shuaib.P OPTION_CHAIN --start*/
function getInstrumentName(strInstrumentName) {

    if (strInstrumentName == 'EQUITIES') {

        return "OPTSTK";
    }
    else if (strInstrumentName == 'FUTCOM') {
        return "OPTFUT";
    }
    else {
        let instsub = strInstrumentName.substr(3, 3);
        return "OPT" + instsub;
    }
}
/**BT-109096 -- Shuaib.P OPTION_CHAIN --end*/


/**BT-109096 -- Shuaib.P OPTION_CHAIN --start*/
function getDistinctExpiryDates(arrOfDates) {
    try {
        let arrDistinctDates = arrOfDates?.length && [...new Set(arrOfDates.map(item => item?._source?.nExpiryDate1))];
        return arrDistinctDates;
    } catch (error) {
        console.error("error", error);
    }
}
/**BT-109096 -- Shuaib.P OPTION_CHAIN--start*/



function removeSpacesAndNumberFromWords(inputString) {
    let cleanedString = inputString?.replace(/[^0-9.]/g, '');
    return parseFloat(cleanedString);
}


/**BT-109096 -- Shuaib.P Setting reference in  option chain --start*/
let OPTION_CALL_REF = null;
let OPTION_PUT_REF = null;


function setOptionCallRef(objGridRef) {
    OPTION_CALL_REF = objGridRef;
}

function setOptionPutRef(objGridRef) {
    OPTION_PUT_REF = objGridRef;
}
/**BT-109096 -- Shuaib.P Setting reference in  option chain --end*/



const checkColdefwithPiviots = (arrColdef, arrStrings) => {
    for (let i = 0; i < arrColdef?.length; i++) {
        const eachColumField = arrColdef[i];
        if (arrStrings?.includes(eachColumField?.headerName)) {
            return true;
        } else {

        }
    }
    return false;
};


const returnCountWithPad = (length) => {
    if (length === 0) {
        return 0;
    } else {
        return String(length)?.padStart(2, "0");
    }
};

const compareObjectsAndArrageInSequence = (a, b) => {
    const seqA = parseInt(a?.nSequenceNo || '0', 10);
    const seqB = parseInt(b?.nSequenceNo || '0', 10);

    return seqA - seqB;
};
//BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - Start
const dateDifferenceInDay = (currentdate, guestRegisteredDate) => {
    var t = currentdate.getTime() - guestRegisteredDate;//.getTime(); 
    var day = t / (1000 * 3600 * 24);
    return Math.abs(Math.round(day));
};


//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
const convertTOVariable = (inputString) => {
    const columnViewType = store?.getState()?.watchList?.columnViewType;

    if (inputString?.length > 0) {
        let stringWithOutQuestionMark = inputString?.replace("?", "");
        stringWithOutQuestionMark = inputString?.replace(",", "");
        const [objectName, propertyName] = stringWithOutQuestionMark?.split(".");
        switch (columnViewType) {
            case MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE:
                const index = WATCHLIST_GRID_INDEX[`${propertyName}`];
                if (index) {
                    return index;
                } else {
                    return stringWithOutQuestionMark;
                }
            case MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE:
                const nIndex = WATCHLIST_GRID_INDEX[`${propertyName}`];
                if (nIndex) {
                    return nIndex.toString();
                } else {
                    return stringWithOutQuestionMark;
                }
            default:
                const converted = WATCHLIST_GRID_INDEX[`${propertyName}`];
                if (converted) {
                    return converted;
                } else {
                    return stringWithOutQuestionMark;
                }
        }
    } else { }
};
//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

const checkGuestLogin = (guestRegisteredDate, nGuestTrialDays) => {
    let currentDate = new Date();
    let diff = dateDifferenceInDay(currentDate, guestRegisteredDate);
    if (diff <= nGuestTrialDays) {
        return false;
    }
    else {
        return true;
    }
};
//BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - End
const getScripDisplayDescription = (data) => {
    if (data?.length > 0) {
        if ((data[WATCHLIST_GRID_INDEX.EXPIRYDATE] && data[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            data[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
            return (`${data[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${data[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${data[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${data[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `);
        } else if (!data[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !data[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            !data[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
            return data[WATCHLIST_GRID_INDEX.SERIES];
        }
        else if (data[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !data[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
            return (`${data[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${data[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${data[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `
            );
        }
        else {
            return '';
        }
    } else {
        return '';
    }
};

const setNotificationToLocalStorage = (dataForNotification, user_id, NotificationType) => {
    let strData = JSON.stringify(dataForNotification);
    let encryptedData = cryptoJS.AES.encrypt(strData, COVER.AES).toString();
    localStorage.setItem(`${LOCAL_STORAGE_KEYS.NOTIFICATION_DETAILS}_${NotificationType}_${user_id}`, encryptedData);
};


const getNotificationFromLocalStorage = (strItemName) => {
    const storedEncryptedText = localStorage.getItem(strItemName);
    if (storedEncryptedText) {
        const decrypted = cryptoJS.AES.decrypt(storedEncryptedText, COVER.AES).toString(cryptoJS.enc.Utf8);
        const decryptedObject = JSON.parse(decrypted);
        return decryptedObject;
    }
};

// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - Start
const hasUserGrantedPOA = () => {
    const loggedInUserInfo = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    let hasUserGrantedPOA = false;
    if (loggedInUserInfo) {
        loggedInUserInfo?.data?.others?.POA === "2" ? hasUserGrantedPOA = false : hasUserGrantedPOA = true;
        return hasUserGrantedPOA;
    }
    else {
        return false;
    }
};

const findDPAndCliendId = (userDPDetails, userDepository) => {
    let data = [];
    let dpId = userDPDetails.sDPId;
    let clientId = userDPDetails.nBeneficiaryAccountNumber;

    if (userDepository === DEPOSITORY_CDSL) {
        if (dpId.length > 6) {
            dpId = dpId.substring(dpId.length - 6);
        }
        else {
            dpId = dpId.padStart(6, "0");
        }
        clientId = (userDPDetails.sDPId + "#" + userDPDetails.nBeneficiaryAccountNumber).replace(/[^\w\s]/gi, '');
    }
    data = [dpId, clientId];

    return data;
};
// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - End

//Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
const handleClassColors = (className, color) => {

    const elements = document.getElementsByClassName(className);
    if (elements?.length) {
        for (let i = 0; i < elements.length; i++) {
            if (className.includes('background')) {
                elements[i].style.backgroundColor = color;
            } else {
                elements[i].style.color = color;
            }
        }
    }

    const defaultElements = document.getElementsByClassName('notrend-backgroundcolor');   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
    if (defaultElements?.length) {
        for (let j = 0; j < defaultElements.length; j++) {
            defaultElements[j].style.backgroundColor = '';
        }
    }
};

const getGlobalFontColor = (currentPreference, tenantUserPreference) => {
    const colorConfig = currentPreference?.sInAppNotification ? JSON.parse(currentPreference?.sInAppNotification) : {};
    const defaultColorConfig = tenantUserPreference?.sInAppNotification ? JSON.parse(tenantUserPreference?.sInAppNotification) : {};
    if (colorConfig?.light && colorConfig?.dark) {
        return { theme: currentPreference?.sTheme, colors: colorConfig };
    } else if (colorConfig?.light && !colorConfig?.dark) {
        return { theme: currentPreference?.sTheme, colors: { light: colorConfig.light, dark: defaultColorConfig?.dark } };
    } else if (!colorConfig?.light && colorConfig?.dark) {
        return { theme: currentPreference?.sTheme, colors: { light: defaultColorConfig.light, dark: colorConfig?.dark } };
    }
};
//Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - End

//Ameersha N : 15-11-2023 : BT-95888 Create Watchlist || Converting touchline indexs to wathclist to avoid conflict in between --Start
const convertTouclineIndexToWatchlistGridIndex = (touchilineData, watchlistData = []) => {
    let arrWatchlistGridRowData = [];
    if (watchlistData?.length) {
        arrWatchlistGridRowData = [...watchlistData];
    } else {
        const arrWatchlistIndex = Object.values(WATCHLIST_GRID_INDEX).sort((a, b) => a - b);
        arrWatchlistGridRowData = new Array(arrWatchlistIndex[arrWatchlistIndex.length - 1] + 1).fill('0.00');
    }
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] = touchilineData[TL_INDEX.SEGMENT_ID];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOKEN] = touchilineData[TL_INDEX.TOKEN];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_UPDATED_TIME] = touchilineData[TL_INDEX.LAST_UPDATED_TIME];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_TIME] = touchilineData[TL_INDEX.LAST_TRADE_TIME];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = touchilineData[TL_INDEX.LAST_TRADE_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = touchilineData[TL_INDEX.NET_CHANGE_INDICATOR];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = touchilineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_QTY] = touchilineData[TL_INDEX.LAST_TRADE_QTY];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.VOLUME] = touchilineData[TL_INDEX.VOLUME];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.AVG_TRADED_PRICE] = touchilineData[TL_INDEX.AVG_TRADED_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.BUY_QTY] = touchilineData[TL_INDEX.BUY_QTY];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.BUY_PRICE] = touchilineData[TL_INDEX.BUY_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SELL_QTY] = touchilineData[TL_INDEX.SELL_QTY];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SELL_PRICE] = touchilineData[TL_INDEX.SELL_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOTAL_BUY_QTY] = touchilineData[TL_INDEX.TOTAL_BUY_QTY];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOTAL_SELL_QTY] = touchilineData[TL_INDEX.TOTAL_SELL_QTY];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.CLOSE] = touchilineData[TL_INDEX.CLOSE_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPEN] = touchilineData[TL_INDEX.OPEN_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.HIGH] = touchilineData[TL_INDEX.HIGH_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LOW] = touchilineData[TL_INDEX.LOW_PRICE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPEN_INTEREST] = touchilineData[TL_INDEX.OPEN_INTEREST];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LIFE_TIME_HIGH] = touchilineData[TL_INDEX.LIFE_TIME_HIGH];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.LIFE_TIME_LOW] = touchilineData[TL_INDEX.LIFE_TIME_LOW];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MARKET_TYPE] = touchilineData[TL_INDEX.MARKET_TYPE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE] = touchilineData[TL_INDEX.EXCHANGE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] = touchilineData[TL_INDEX.DAILY_PRICE_RANGE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.BUY_PRICE_INDICATOR] = touchilineData[TL_INDEX.BUY_PRICE_INDICATOR];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SELL_PRICE_INDICATOR] = touchilineData[TL_INDEX.SELL_PRICE_INDICATOR];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = touchilineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
    arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PERCENT_OI] = touchilineData[TL_INDEX.OPEN_INTEREST_PERCENT] === '' ? (0).toFixed(2) : touchilineData[TL_INDEX.OPEN_INTEREST_PERCENT];

    return arrWatchlistGridRowData;
};
//Ameersha N : 15-11-2023 : BT-95888 Create Watchlist || Converting touchline indexs to wathclist to avoid conflict in between --Start


//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --start

const validateUpiId = (input) => {
    const upiRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z]+$/;
    if (input) {
        if (upiRegex.test(input)) {
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }
};

//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --end

// Ameersha N : 17-11-2023 : function to select the desired row in grid   – Start
const makeGridRowSelected = (gridRef, rowIndex = 0) => {
    if (gridRef?.current) {
        gridRef?.current?.api?.forEachNode((node) => {
            if (node?.rowIndex === rowIndex) {
                node.setSelected(true);
            } else { }
        });
    } else { }
};
// Ameersha N : 17-11-2023 : function to select the desired row in grid   – End

//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
const isUserIsAGuest = (strType) => {
    let guestUserPrevalages = {
        allowedSections:
        {
            Dashboard: 1,
            watchList: 1,
            qucikWatch: 1,
            sideBarNetPosition: 1,
            indices: 1,
            screeners: 1,
            investment: 1,
            livepuluse: 1,
            news: 1,
            events: 1,
            Calculators: 1,
            Links: 1,
            notification: 0,
            alerts: 0,
            edis: 0,
            Portfolio: 0,
            Orders: 0,
            Funds: 0,
            orders: 0,
            recommendataion: 0,
            buy_sell: 0,
            Order_Cart: 0,
            Back_Office_Reports: 0,
            SSO_Link: 0,
            Reports: 0,
            Pledge: 0,
            chart: 0,
            shareWatchlist: 0,
            analysis: 0,
            portfolio_analyzer: 0,
            option_chain: 0
        },

    };
    let objLoginSession = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    //Changes done by Vaibhav related to Side place order test cases failed : ManasaB : 07/03/2025 - Start
    const isGuestUser = Object?.keys(objLoginSession ? objLoginSession : {})?.includes('guestMode');
    if (isGuestUser || Object?.keys(objLoginSession?.data ? objLoginSession?.data : {})?.includes('trial_expired')) {
        //Changes done by Vaibhav related to Side place order test cases failed : ManasaB : 07/03/2025 - End
        if (guestUserPrevalages?.allowedSections[`${strType}`] === 0) {
            store?.dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
            return true;
        } else {
            return false;
        }

    } else {
        return false;
    }
};
//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End


//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
const isGuestUser = () => {
    let objLoginSession = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    //Changes done by Vaibhav related to Side place order test cases failed : ManasaB : 07/03/2025 - Start
    const isGuestUser = Object?.keys(objLoginSession ? objLoginSession : {})?.includes('guestMode');
    //Changes done by Vaibhav related to Side place order test cases failed : ManasaB : 07/03/2025 - End
    return isGuestUser || Object?.keys(objLoginSession?.data ? objLoginSession?.data : {})?.includes('trial_expired');
};
//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

// BT-106965_27-02-2024-SrikanthRao_ordercart_START

const convertEditCart = (arrOrderCart) => {
    if (arrOrderCart?.length > 0) {
        const arrWatchlistGridData = arrOrderCart.map((element) => {
            const arrWatchlistIndex = Object.values(WATCHLIST_GRID_INDEX).sort((a, b) => a - b);
            const arrWatchlistGridRowData = new Array(arrWatchlistIndex[arrWatchlistIndex.length - 1] + 1).fill('0.00');
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.ASK_QTY] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.BID_QUANTITY] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.DONT_MISS] = '';
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.VOLUME] = 0;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] = element?.scripDetail?.scripDet?._MktSegId;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = element?.scripDetail?.scripDet?._MapMktSegId;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.TOKEN] = element?.scripDetail?.scripDet?.token;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = element?.scripDetail?.scripDet?._MktSegId + '_' + element?.scripDetail?.scripDet?.token;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL] = element?.scripDetail?.symbol;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE] = element?.scripDetail?._ExchangeName;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SERIES] = element?.scripDetail?._Series;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] = element?.scripDetail?._InstrumentName;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] = element?.scripDetail?._ExpiryDate;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] = element?.scripDetail?._StrikePrice;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE] = element?.scripDetail?._OptionType;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = element?.scripDetail?.DecimalLocator;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = getDynamicParamsForToFixed(element?.requestBody?.scrip_info?.exchange);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = element?.scripDetail?.AssetToken;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_TICK] = (element?.scripDetail?.PriceTick / element?.scripDetail?.DecimalLocator);
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.NSPREAD] = element?.scripDetail?.Spread;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.REGULAR_LOT] = element?.scripDetail?.MarketLot;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] = element?.scripDetail?.sSurvMeasureDescription;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [];
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DONT_MISS] = element?.scripDetail?.dontMiss ? element?.scripDetail?.dontMiss : [];
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR] = element?.scripDetail?.priceNumerator ? element?.scripDetail?.priceNumerator : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR] = element?.scripDetail?.priceDenominator ? element?.scripDetail?.priceDenominator : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN] = element?.scripDetail?.AVMBuyMargin ? element?.scripDetail?.AVMBuyMargin : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN] = element?.scripDetail?.AVMSellMargin ? element?.scripDetail?.AVMSellMargin : 1;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.IS_FO_EXIST] = element?.scripDetail?.FOExists;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = element?.scripDetail?.sQtyUnit?.trim() || 'Qty'; //ManasaB : 03-Sep-2024 : OrderCart blank screen issue
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] = element?.scripDetail?.ISIN;
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX?.SECURITY_DESCRIPTION] = element?.scripDetail?.SecurityDesc; //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order 
            if (element?.scripDetail?._ExpiryDate == 0) {
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL];
            } else {
                arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SYMBOL] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] + " " + arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE];
            }
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.SECTOR] = "";
            arrWatchlistGridRowData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = element?.requestBody?.scrip_info?.exchange;

            return arrWatchlistGridRowData;
        });
        return arrWatchlistGridData;
    } else {
        return [];
    }
};
// BT-106965_27-02-2024-SrikanthRao_ordercart_START




const modifySymbol = (strSymbol) => {
    if (strSymbol.includes('Nifty')) {
        return 'nifty';
    } else if (strSymbol.includes('SENSEX')) {
        return 'sensex';
    } else {
        return strSymbol;
    }
};
// Azeem K : 25-01-2024 : BT-102298 NSECDS OrderBook  –--Start

const collapseRow = (gridRef, isCloseAll, key, rowData) => {
    //this function is make for closing rows of Grid
    //about parameters ==>  
    //  gridRef is ref from ag grid
    // isCloseAll ==> if isCloseAll is true it will close all rows
    // key ==> key is unique id from row data
    // rowData ==> data of particular row which we want to close

    gridRef?.current?.api?.forEachNode(node => {
        if (isCloseAll) {
            gridRef?.current?.api?.setRowNodeExpanded(node, false);
        }
        else if (rowData?.[key] === node?.data?.[key]) {
            gridRef?.current?.api?.setRowNodeExpanded(node, false);
        } else { }

    });
};
// Azeem K : 25-01-2024: BT-102298 BT-102298 NSECDS  OrderBook –--End


const decryptChartData = (strDecryptedData) => {

    strDecryptedData = strDecryptedData.replaceAll(")", ",0,0,0,0,");       //9
    strDecryptedData = strDecryptedData.replaceAll("(", ",0,0,0,");         //7
    strDecryptedData = strDecryptedData.replaceAll("!", ",0,0,");                 //6
    strDecryptedData = strDecryptedData.replaceAll("|", ",0,");                   //5   
    strDecryptedData = strDecryptedData.replaceAll(":", "0,");                    //4
    strDecryptedData = strDecryptedData.replaceAll("{", ",+");                    //10
    strDecryptedData = strDecryptedData.replaceAll("}", ",-");                    //11        
    strDecryptedData = strDecryptedData.replaceAll("%", "5,");                    //3         
    strDecryptedData = strDecryptedData.replaceAll("~", "10");                    //12        
    strDecryptedData = strDecryptedData.replaceAll("@", "20");                    //13        
    strDecryptedData = strDecryptedData.replaceAll("#", "30");                    //14        
    strDecryptedData = strDecryptedData.replaceAll("$", "40");                    //15        
    strDecryptedData = strDecryptedData.replaceAll("^", "50");                    //16
    strDecryptedData = strDecryptedData.replaceAll("&", "60");                    //17
    strDecryptedData = strDecryptedData.replaceAll("*", "70");                    //18
    strDecryptedData = strDecryptedData.replaceAll("<", "80");                    //19
    strDecryptedData = strDecryptedData.replaceAll(">", "90");                    //20
    strDecryptedData = strDecryptedData.replaceAll("a", "0");
    strDecryptedData = strDecryptedData.replaceAll("b", "1");
    strDecryptedData = strDecryptedData.replaceAll("b", "1");
    strDecryptedData = strDecryptedData.replaceAll("b", "1");
    strDecryptedData = strDecryptedData.replaceAll("c", "2");
    strDecryptedData = strDecryptedData.replaceAll("d", "3");
    strDecryptedData = strDecryptedData.replaceAll("e", "4");
    strDecryptedData = strDecryptedData.replaceAll("f", "5");
    strDecryptedData = strDecryptedData.replaceAll("g", "6");
    strDecryptedData = strDecryptedData.replaceAll("h", "7");
    strDecryptedData = strDecryptedData.replaceAll("i", "8");
    strDecryptedData = strDecryptedData.replaceAll("j", "9");
    strDecryptedData = strDecryptedData.replaceAll(";", "00");                //8

    return strDecryptedData;

};

const convertToDateObj = (seconds) => {
    let d1 = new Date("01/01/1980 00:00:00");
    d1.setSeconds(seconds);
    return d1;
};

const ConvertToRe = (strPrice, intMktSegId, strDecimalLoc = "100") => { //default value

    if (!(strPrice))
        return '0.00';
    let strOutput = '0.00';

    if (intMktSegId == clsConstants.C_V_MAPPED_MSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_MSX_SPOT || intMktSegId == clsConstants.C_V_MSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_MSX_SPOT || intMktSegId == clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_BSECDX_SPOT || intMktSegId == clsConstants.C_V_MAPPED_MCX_DERIVATIVES) {
        if (intMktSegId == clsConstants.C_V_MAPPED_MCX_DERIVATIVES && strDecimalLoc.trim() == "0")
            strDecimalLoc = "100";

        if (strDecimalLoc.trim() == "0")
            strDecimalLoc = "10000";
    }
    else if (intMktSegId == clsConstants.C_V_MAPPED_NSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_NSX_SPOT ||
        intMktSegId == clsConstants.C_V_NSX_DERIVATIVES || intMktSegId == clsConstants.C_V_NSX_SPOT) {
        if (strDecimalLoc.trim() == "0")
            strDecimalLoc = clsConstants.C_V_NSECDS_DECLOC;
    }
    else if (intMktSegId == clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_BSECDX_SPOT ||
        intMktSegId == clsConstants.C_V_BSECDX_DERIVATIVES || intMktSegId == clsConstants.C_V_BSECDX_SPOT) {
        if (strDecimalLoc.trim() == "0")
            strDecimalLoc = clsConstants.C_V_BSECDX_DECLOC;
    }
    else if (intMktSegId == clsConstants.C_V_MAPPED_BFX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_BFX_SPOT ||
        intMktSegId == clsConstants.C_V_BFX_DERIVATIVES || intMktSegId == clsConstants.C_V_BFX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_MSX_CASH || intMktSegId == clsConstants.C_V_MAPPED_MSX_FAO ||
        intMktSegId == clsConstants.C_V_MSX_CASH || intMktSegId == clsConstants.C_V_MSX_FAO) {
        if (strDecimalLoc.trim() == "0")
            strDecimalLoc = "100";
    }
    else {
        strDecimalLoc = "100";
    }

    let strPriceFormat = 2;//this.GetPriceFormatterWithDLAndMksSegID(strDecimalLoc, intMktSegId);
    if (intMktSegId == clsConstants.C_V_MSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MSX_SPOT ||
        intMktSegId == clsConstants.C_V_NSX_DERIVATIVES || intMktSegId == clsConstants.C_V_NSX_SPOT ||
        intMktSegId == clsConstants.C_V_BSECDX_DERIVATIVES || intMktSegId == clsConstants.C_V_BSECDX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_MSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_MSX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_NSX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_NSX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_BSECDX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_BFX_DERIVATIVES || intMktSegId == clsConstants.C_V_MAPPED_BFX_SPOT ||
        intMktSegId == clsConstants.C_V_BFX_DERIVATIVES || intMktSegId == clsConstants.C_V_BFX_SPOT ||
        intMktSegId == clsConstants.C_V_MAPPED_MSX_CASH || intMktSegId == clsConstants.C_V_MAPPED_MSX_FAO ||
        intMktSegId == clsConstants.C_V_MSX_CASH || intMktSegId == clsConstants.C_V_MSX_FAO)
        strOutput = (parseFloat(strPrice) / parseFloat(strDecimalLoc)).toFixed(strPriceFormat);
    else
        strOutput = (parseFloat(strPrice) / 100).toFixed(strPriceFormat);
    return strOutput;

};
// Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - Start
const getLegObject = (data, index, legNumber, reorder = false) => {
    return {
        legNumber: legNumber,
        legPrice: data?.legPrice || (reorder && data?.order_price) || data?.info?.[index.LAST_TRADE_PRICE] || "0.00",
        // Ajitesh 25-07-2024 Adds last condition inside OR condition below as during update from currency, watchlist grid index ltp comes blank string
        ltp: (data?.info?.[index.LAST_TRADE_PRICE] == "0.00" || data?.info?.[index.LAST_TRADE_PRICE] == undefined || data?.info?.[index.LAST_TRADE_PRICE] == "") && data?.ltp ? data?.ltp : data?.info?.[index.LAST_TRADE_PRICE] || "0.00",
        sellPrice: data?.sellPrice || (reorder && data?.order_price) || data?.info?.[index.SELL_PRICE] || data?.legPrice || data?.info?.[index.LAST_TRADE_PRICE] || 0,
        buyPrice: data?.buyPrice || (reorder && data?.order_price) || data?.info?.[index.SELL_PRICE] || data?.legPrice || data?.info?.[index.LAST_TRADE_PRICE] || 0,
        expiryDate: data?.expiryDate || (reorder && data?.expiry_date) || data?.info?.[index.EXPIRYDATE],
        symbol: data?.symbol || data?.info?.[index.SYMBOL],
        ltpPercent: data?.ltpPercent || data?.info?.[index.LTP_PERCENT] || 0,
        changeInLtp: data?.changeInLtp || data?.info?.[index.CHANGE_IN_LTP] || 0,
        strikeprice: (reorder ? data?.strike_price <= 0 ? "NA" : data?.strike_price : data?.strikeprice <= 0 ? "NA" : data?.strikeprice) || data?.info?.[index.STRIKEPRICE] || "NA",
        optiontype: (reorder ? data?.option_type === "XX" ? "NA" : data?.option_type : data?.optiontype === "XX" ? "NA" : data?.optiontype) || data?.info?.[index.OPTIONTYPE] || "NA",
        exchange: data?.exchange || data?.info?.[index.EXCHANGE],
        ask_qty: data?.ask_qty || (reorder && data?.market_lot) || data?.info?.[index.REGULAR_LOT] || 0,
        activeButtonToggleIndex: (reorder ? data?.transaction_type === 'BUY' ? 0 : 1 : data?.activeButtonToggleIndex) || 0,
        // Ajitesh 30-07-2024 Adds condtion for OPTSTK to show correct qty in Qty/LOT field in case of reorder
        count: data?.count || (reorder && (data.instrument?.trim() === SCRIP_INSTRUMENTS.FUTSTK || data.instrument?.trim() === SCRIP_INSTRUMENTS.OPTSTK ? data?.total_quantity / data?.market_lot : data?.total_quantity || 1)) || 1,  //Parshva S : 5/4/24 : BT 102679 Mltileg Order
        token: data?.token || (reorder && data?.scrip_token) || data?.info?.[index.TOKEN],
        priceTick: data?.priceTick || (reorder && data?.price_tick) || data?.info?.[index.PRICE_TICK],
        instrument: data?.instrument || data?.info?.[index.INSTRUMENT],
        orderType: 'RL-MKT',
        expiryList: data?.expiryList || [],
        selectedExpiry: data?.selectedExpiry || {},
        decLoc: data?.decLoc || undefined,
        extraInfo: data?.info || [],
        decimalLocatorLength: data?.decimalLocatorLength
    };
};
// Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - End


// Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--Start
const getOrderDisplayDiscription = (objRowData) => {

    if ((objRowData?.expiryDate && objRowData?.strikePrice && objRowData?.strikePrice > 0 &&
        objRowData?.instrument)) {
        return `${moment(objRowData?.expiryDate).format("DDMMMYYYY").toUpperCase().slice(0, 2)}  ${moment(objRowData?.expiryDate).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${objRowData?.strikePrice} ${objRowData?.optionType} `; //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    } else if (!objRowData?.expiryDate && (!objRowData?.strikePrice || objRowData?.strikePrice <= 0) &&
        !objRowData?.optionType) {
        return objRowData?.series; //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    }
    else if (objRowData?.expiryDate && (!objRowData?.strikePrice || objRowData?.strikePrice <= 0)) {
        return `${moment(objRowData?.expiryDate).format("DDMMMYYYY").toUpperCase().slice(0, 2)} ${moment(objRowData?.expiryDate).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${objRowData?.instrument?.slice(0, 3)} `; //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings

    } else {
        return null;
    }
};
// Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--End
//Shuaib P : 21-02-2024  Handle Reconnection --Start

const ReconnectSocket = () => {
    let reconnectionCount = store?.getState()?.wfh?.reconnectionCount;
    let subscribedTouchlineScrips = store?.getState()?.wfh?.objTouchline;
    let subscribedBestFiveScrips = store?.getState()?.wfh?.objBestFive;

    let strTouchline;
    let strBestfive;

    if (subscribedTouchlineScrips) {
        let filteredObj = Object.fromEntries(
            Object.entries(subscribedTouchlineScrips).filter(([key, value]) => value > 0)
        );
        strTouchline = Object.keys(filteredObj).join(',');
    }

    if (strBestfive) {
        strBestfive = Object.keys(subscribedBestFiveScrips).join(',');
    }

    if (reconnectionCount > 0) {
        connectSocket();
        let remainingAttempts = reconnectionCount - 1;
        store?.dispatch(updateReconnectionCount(remainingAttempts));
    } else if (reconnectionCount === -1) {
        connectSocket();
    } else {
        console.error('Reconnection limit reached...');
    }

    setTimeout(() => {
        sendSubscription('TL', strTouchline, true);
        sendSubscription('B5', strBestfive, true);
    }, 1000);
};

//Shuaib P : 21-02-2024  Handle Reconnection --End
// Vaibhav S : 26-02-2024 : Average Price Calculation added:Start
const getAveragePrice = (data, strExchange) => {
    let nDdecimalLocatorLength = getDynamicParamsForToFixed(strExchange);

    let strTradedValue = 0;
    let strTotalQty = 0;
    data?.forEach(eleTrade => {
        let price = eleTrade?.trade_price ? eleTrade?.trade_price : eleTrade?.order_price;
        let qty = eleTrade?.trade_quantity ? eleTrade?.trade_quantity : eleTrade?.traded_quantity;
        strTradedValue = strTradedValue + parseFloat(price) * parseFloat(qty);
        strTotalQty = strTotalQty + parseFloat(qty);
    });
    let averagePrice = (strTradedValue / strTotalQty)?.toFixed(nDdecimalLocatorLength);
    return averagePrice;
};
// Vaibhav S : 26-02-2024 : Average Price Calculation added:End




function filterUsername(text) {
    const cleanedText = text.replace(/\s/g, '').replace(/[^\w\s]/gi, '');
    const uppercaseText = cleanedText.toUpperCase();
    return uppercaseText;
}




// Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - Start

const handlePledgeUnpledgeRedirect = () => {
    const appInfo = store.getState()?.appInfo?.appInfo;
    let baseUrl = getAppInfoData(APP_INFO_PARAMS.APP_NETNET_PG_URL, appInfo);
    let urlForPledgeUnpledge = _generateUrlForPledgeUnpledge(baseUrl);
    const pledgeUnpledgeWindow = window.open(urlForPledgeUnpledge);
};




const handleRouteChangeForHamberger = (id, route, navigate) => {
    const { dispatch, getState } = store;
    let selectedMenu;
    if (route == '/setting') {
        selectedMenu = {
            "id": 312,
            "name": "settings",
            "displayName": "Settings",
            "menuDescription": "Settings",
            "sequenceNo": 12,
            "menuUrl": "/setting",
            "guestMode": 0,
            "tradingMode": 0,
            "iconUrl": "icon-settings",
            "childs": "",
            "isUrl": 0,
            "openMode": 0
        };
    } else {
        selectedMenu = getState()?.appInfo?.dynamicMenus?.hamburgerMenu?.items?.find(item => item.id === id);
    }
    const objLoginSession = getState()?.auth?.objLoginSession;
    switch (id) {
        case 305:
            dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
            dispatch(handleModalData({ header: "SSO Links", data: selectedMenu?.childs ? selectedMenu?.childs : [], name: HAMBURGER_LIST.SSO_LINKS, id: 305 }));
            break;
        case 304:
            if (selectedMenu?.childs?.length > 0) {
                dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
                dispatch(handleModalData({ header: "Back Office Reports", data: selectedMenu?.childs, id: 304 }));
            } else {
                if (selectedMenu?.openMode == LINK_OPEN_MODES.IFRAME) {
                    dispatch(updateInAppIFrame({ url: selectedMenu?.menuUrl, title: "Back Office Reports" }));
                    dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
                } else {
                    window.open(selectedMenu?.menuUrl);
                }
            }
            break;
        case 306:
            dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
            dispatch(handleModalData({ header: "Links", data: selectedMenu?.childs ? selectedMenu?.childs : [], name: HAMBURGER_LIST.EXCHANGE_LINKS, id: 306 }));
            break;
        case 404:
            dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
            dispatch(handleModalData({ header: "Reports", data: selectedMenu?.childs, id: 404 }));
            break;

        case 310:
            // navigate('/' + route);
            dispatch(handleModal([{ "MESSAGES": true }]));
            dispatch(getMessages());
            dispatch(getMessagesBroker());
            break;
        case 303:
            {/* Hari K:08-11-2023 :BT-119138:Funds View-added funds modal-start*/ }
            dispatch(handleModal([{ 'FUNDS_MODAL': true }]));
            {/* Hari K:08-11-2023 :BT-119138:Funds View-added funds modal-end*/ }

            break;
        case 309:
            handlePledgeUnpledgeRedirect();
            break;
        case 405:
            //Hari k:14-04-2025-market status - need to dispatch market status modal and action function
            dispatch(handleModal([{ 'MARKET_STATUS': true }]));
            break;
        default:
            let isEncrypted = false;
            if (selectedMenu?.isUrl) {
                if (id === 315) {
                    isEncrypted = false;
                } else {
                    isEncrypted = true;
                }
                const URL = getDyanmicURL({ url: selectedMenu.menuUrl }, objLoginSession, isEncrypted);

                if (selectedMenu?.openMode == LINK_OPEN_MODES.IFRAME) {
                    dispatch(updateInAppIFrame({ url: URL, title: selectedMenu?.displayName }));
                    dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
                }
                else {
                    window.open(URL);
                }
            } else {
                navigate(route);
            }

            break;
    }
};

//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
const hamburgerRoutes = (each, navigate) => {
    const { id, route, guestMode } = each;
    const { dispatch } = store;
    
    if (!isGuestUser()) {
        handleRouteChangeForHamberger(id, route, navigate);
    } else if (guestMode === 1 && isGuestUser()) {
        handleRouteChangeForHamberger(id, route, navigate);
    } else if (guestMode === 0 && isGuestUser()) {
        dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
    } else {

    }


};
//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
// Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - End



// open orderEntry modal by prefilling data --Shuaib Peerjade --Start

const setOrderEntryScripPrice = (activeButtonToggleIndex, arrScripData) => {
    //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict
    const nAskPrice = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.SELL_PRICE]);
    const nLTP = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
    const nBidPrice = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.BUY_PRICE]);
    if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
        if (nAskPrice > 0) {
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nAskPrice, arrScripData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
        } else {
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nLTP, arrScripData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
        }
    } else {
        if (nBidPrice > 0) {
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nBidPrice, arrScripData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
        } else {
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nLTP, arrScripData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
        }
    }
};

async function openOrderEntryModal(arrScripData, arrRowData, objLoginSession, segmentId, token, nIsBuyOrSell) {
    // This function should be use to open order entry modal anywhere from the project
    // There can be two cases, it can either open from ag grid or from any popover or modal
    // Case 1 - If it is open from Ag-grid, send liveData or send rowData and for segment id and token send null
    // Case 2 - If it is opened from anywhere other than ag grid, in place of arrScripData and arrRowData send null. And send segId and token

    let arrRowDataLiveData;
    let scripData;
    if (arrScripData !== null && arrRowData !== null) {
        const objLasTickData = store?.getState()?.wfh?.objTouchlineLastTick;
        const arrTouchLineData = objLasTickData?.[arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
        if (arrTouchLineData) {
            const objIndex = { [arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: 0 };// Azeem K -05-07-2024 : Watchlist Optimization
            arrRowDataLiveData = handleUpdateWatchlistGrid(arrTouchLineData, { scrips: [arrRowData] }, objIndex);
        }
    }
    const strExchangeName = arrRowData !== null ? getApiExchangeNameFromMktSegId(arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID]) : getApiExchangeNameFromMktSegId(segmentId);

    if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
        if (arrRowDataLiveData) {
            scripData = arrRowDataLiveData;
        } else if (arrRowData) {
            scripData = arrRowData;
        } else {
            const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(segmentId), token: token }];
            const objResp = await getScripbyTokenAndMktSegId(arrScrips);
            if (objResp?.data?.result?.length) {
                [scripData] = convertScripResponseWatchlistGrid(objResp?.data?.result);
            } else {
                store.dispatch(toastConfig({ autoDismiss: true, show: true, message: `Unable to get scrip details` }));
            }
        }
        store.dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: scripData }));
        store.dispatch(updateSingleScripOrderConfirmed(false));
        setOrderEntryScripPrice(nIsBuyOrSell, scripData);
        await store.dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
    } else {
        store.dispatch(toastConfig({ autoDismiss: true, show: true, message: `You are currently not allowed to place/modify/cancel order in this segment` }));
    }

}

// open orderEntry modal by prefilling data --Shuaib Peerjade --End

const openOverviewModal = async (pageCalled, arrRowData, setIsExpanded, setIsSideBar, dispatch, modalData) => {
    if (setIsExpanded && setIsSideBar) {
        setIsSideBar(false);
        setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //BT-112513 Closing side menu on right click of grid : ManasaB : 11/07/2023 Functionality modified by Hiral Mam side menu should close on click of options in the pop over grid
    } else { }
    setTimeout(() => {
        dispatch(toastConfig({}));
    }, 50);
    _resetGridFeatures(WATCHLIST_GRID_REF);
    dispatch(updateSelectedArrRowData(arrRowData));
    if (pageCalled) {
        if (arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] && arrRowData[WATCHLIST_GRID_INDEX.TOKEN]) {
            const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrRowData[WATCHLIST_GRID_INDEX.TOKEN] }]);
            const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
            const scripData = convertScripResponseWatchlistGrid(scripDataObj);
            if (scripData?.[0]?.length) {
                dispatch(setIsIndicesOverview(false));
                dispatch(setScripOverviewData(scripData?.[0]));
                dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
                dispatch(handleModalData({ ...modalData, tab: 'overview' }));
            } else {
                setTimeout(() => {
                    dispatch(toastConfig({ show: true, autoDismiss: true, timer: 5000, message: 'Cannot open scrip overview of following Scrip', }));
                }, 1000);
            }
        } else {
            setTimeout(() => {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 5000, message: 'Cannot open scrip overview of following Scrip', }));
            }, 1000);
        }
    } else {
        dispatch(setScripOverviewData(arrRowData));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        dispatch(handleModalData({ ...modalData, tab: 'overview' }));
    }


    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End

};

function getViewAllowedOptnChain(_iMappedMarketSegmentId, objLoginSession) {
    let viewAllowed = getViewAllowed(objLoginSession);
    let mktAllowed = viewAllowed || -1;
    try {
        switch (parseInt(_iMappedMarketSegmentId)) {

            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH:
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_DERIVATIVES:
                mktAllowed = MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_DERIVATIVES + MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH:
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_DERIVATIVES:
                mktAllowed = MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_DERIVATIVES + MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_SPOT:
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES:
                mktAllowed = MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_DERIVATIVES + MAPPED_MARKET_SEGMENT_ID.MAPPED_MCX_SPOT;
                break;
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_SPOT:
            case MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES:
                mktAllowed = MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_DERIVATIVES + MAPPED_MARKET_SEGMENT_ID.MAPPED_NCDEX_SPOT;
                break;
            // case clsConstants.C_V_MAPPED_NSEL_SPOT: 
            // case clsConstants.C_V_MAPPED_NSEL_DERIVATIVES:
            //     mktAllowed = clsConstants.C_V_MAPPED_NSEL_DERIVATIVES + clsConstants.C_V_MAPPED_NSEL_SPOT;
            //     break;
            // case clsConstants.C_V_MAPPED_MSX_SPOT: 
            // case clsConstants.C_V_MAPPED_MSX_DERIVATIVES:
            //     mktAllowed = clsConstants.C_V_MAPPED_MSX_DERIVATIVES + clsConstants.C_V_MAPPED_MSX_SPOT;
            //     break;
            // case clsConstants.C_V_MAPPED_NSX_SPOT: 
            // case clsConstants.C_V_MAPPED_NSX_DERIVATIVES:
            //     mktAllowed = clsConstants.C_V_MAPPED_NSX_DERIVATIVES + clsConstants.C_V_MAPPED_NSX_SPOT;
            //     break;
            // case clsConstants.C_V_MAPPED_BSECDX_SPOT: 
            // case clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES:
            //     mktAllowed = clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES + clsConstants.C_V_MAPPED_BSECDX_SPOT;
            //     break;
            // case clsConstants.C_V_MAPPED_MSX_CASH:
            // case clsConstants.C_V_MAPPED_MSX_FAO:
            //     mktAllowed = clsConstants.C_V_MAPPED_MSX_FAO + clsConstants.C_V_MAPPED_MSX_CASH;
            //     break;
            default:
                mktAllowed = viewAllowed || -1;
                break;
        }
    }
    catch (e) {
        throw e;
        //LogManager.WriteLog('Exception: ' + e.message, 'GetMarketSegmentID', 'tr_TradingMethods.js', '');

    }
    return mktAllowed;
}

// Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- Start
function nullCheck(param) {
    if (param === undefined || param === null) {
        return 'NA';
    } else if (param === '') {
        return '-';
    } else {
        return param;
    }
} // Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- End


//Ameersha N -BREEZE - BT-109096 - 12-04-2024 -- Scrip Overview Option Chain --Start
function sortDateInStringsInSequence(dateString) {
    const parts = dateString?.match(/(\d{2})([A-Z]{3})(\d{4})/);
    if (!parts) {
        throw new Error('Error in date strings');
    }
    const months = {
        JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5,
        JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11
    };
    return new Date(parts[3], months[parts[2]], parts[1]);

}
//Ameersha N -BREEZE - BT-109096 - 12-04-2024 -- Scrip Overview Option Chain --End


//Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE -- Scrip Overview Option Chain --Start
function isAppDisableClosePrice() {
    const { appInfo } = store?.getState()?.appInfo;
    const isAppDisableClosePrice = getAppInfoData(APP_INFO_PARAMS.APP_DISABLE_CLOSE_PRICE, appInfo);
    return isAppDisableClosePrice;
}
//Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE -- Scrip Overview Option Chain --End
// Hari k:17-04-2024: BT-108447: create watchlist from list- start

const generateUniqueName = (baseName, globalWatchlists, watchlists) => {
    let suffix = 1;
    let uniqueName = baseName?.replace(/[^\w\s]/g, '').replace(/\s/g, '');

    const allObjects = [...globalWatchlists, ...watchlists];
    for (let i = 0; i < allObjects?.length; i++) {
        if (allObjects.some(obj => obj.sWatchListName?.toLowerCase() === uniqueName?.toLowerCase())) {
            uniqueName = baseName?.replace(/[^\w\s]/g, '').replace(/\s/g, '') + suffix;
            suffix++;
        } else { }
    }
    return uniqueName;
};
const createNewWatchlist = (objLoginSession, arrScrips, watchlistType, tenantId, watchListName, listName, dispatch) => {
    const objNewWatchlist = {
        "sUserId": objLoginSession?.data?.user_id,
        "scrips": arrScrips,
        "tenantId": tenantId,
        "sTenantId": tenantId,
        "bIsDefault": false,
        "sSettings": null,
        "sWatchListName": watchListName?.replace(/[^\w\s]/g, '').replace(/\s/g, ''),
        "userId": objLoginSession?.data?.user_id,
        "bIsPrivate": false,
        "sWtachlistType": watchlistType,
        "sListName": listName
    };
    dispatch(getGlobalWatchlistScrips(objNewWatchlist));
    dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": true }]));
};
// Hari k:17-04-2024: BT- 108447:create watchlist from list- end

function getIPOPaymentStatus(strPaymentStatus) {
    let _sPaymentStatus = '';
    try {

        if (!strPaymentStatus) {
            return 'NA';
        }
        else {
            switch (strPaymentStatus.trim()) {
                case IPO_CODE.IPO_PAYMENT_CODE_P:
                    _sPaymentStatus = IPO_CODE.IPO_PAYMENT_STATUS_PENDING;
                    break;
                case IPO_CODE.IPO_PAYMENT_CODE_S:
                    _sPaymentStatus = IPO_CODE.IPO_PAYMENT_STATUS_SUCCESS;
                    break;
                case IPO_CODE.IPO_PAYMENT_CODE_F:
                    _sPaymentStatus = IPO_CODE.IPO_PAYMENT_STATUS_FAILED;
                    break;
                case IPO_CODE.IPO_PAYMENT_CODE_R:
                    _sPaymentStatus = IPO_CODE.IPO_PAYMENT_STATUS_REJECTED;
                    break;
                case IPO_CODE.IPO_PAYMENT_CODE_REL:
                    _sPaymentStatus = IPO_CODE.IPO_PAYMENT_STATUS_RELEASE;
                    break;
                default:
                    _sPaymentStatus = 'NA';
                    break;
            }
        }
    }
    catch (e) {
        _sPaymentStatus = '';
    }
    return _sPaymentStatus;
}
//Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing -Start
const getQtyType = (exchange) => {
    if (exchange === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || exchange === DISPLAY_EXCHANGE_NAME.NSECOMM_EXCHANGE_TEXT || exchange === DISPLAY_EXCHANGE_NAME.BSECOMM_EXCHANGE_TEXT || exchange === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT || exchange === DISPLAY_EXCHANGE_NAME.NSX_SPOT_TEXT || exchange === DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT) {
        return 'Lot';
    } else {
        return 'Qty';
    }

};
//Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing - End

// Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
const displayZeroStateForGrid = (ref, isLoading = false) => {
    if (!ref) return;

    const displayedRowCount = ref?.current?.api?.getDisplayedRowCount();
    if (displayedRowCount == 0) {
        ref?.current?.api?.showNoRowsOverlay();
    } else {
        ref?.current?.api?.hideOverlay();
    }

    return displayedRowCount;
};
// Vinit R - 04-07-2024 -- Add zero state for AG grid -- End

function decryptWithAEScbc(sKey, str) {
    const combined = cryptoJS.enc.Base64.parse(str);    // Parse the Base64-encoded input.

    // Extract the IV from the first 16 bytes
    const extractedIv = cryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
    extractedIv.sigBytes = 16;

    // Extract the ciphertext from the remaining bytes
    const ciphertext = cryptoJS.lib.WordArray.create(combined.words.slice(4));
    ciphertext.sigBytes = combined.sigBytes - 16;

    const key = cryptoJS.enc.Utf8.parse(sKey);      // Parse the key to a WordArray object
    const decrypted = cryptoJS.AES.decrypt({ ciphertext }, key, {       // Decrypt the ciphertext using the extracted IV
        iv: extractedIv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
    });
    return decrypted.toString(cryptoJS.enc.Utf8);        // Return the decrypted result as a UTF-8 string.
}
function generateAESKey(keyBytes = 32) {
    const key = cryptoJS.lib.WordArray.random(keyBytes);
    return key;
}

function encryptWithRSAPublicKey(data, publicKey) {
    const rsaPublicKey = forge.pki.publicKeyFromPem(publicKey);
    const encrypted = rsaPublicKey.encrypt(data, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
    });
    return forge.util.encode64(encrypted);
};

function encryptPublicKey(key, publicKey) {

    let strPublicKey = Buffer.from(publicKey, 'base64').toString('utf-8');

    let strKey = forge.util.encodeUtf8(key); /* check type*/
    let encClientKey = encryptWithRSAPublicKey(strKey, strPublicKey);
    return encClientKey;
}


function encryptWithAEScbc(sKey, str) {
    const key = cryptoJS.enc.Utf8.parse(sKey);  // Parse the key to a WordArray object.
    const iv = cryptoJS.lib.WordArray.random(16);  // Generate a random IV 128-bit.

    const encrypted = cryptoJS.AES.encrypt(str, key, {  // Encrypt the string.
        iv: iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7,
    });

    const combined = iv.concat(encrypted.ciphertext);   // Combine the IV and the encrypted ciphertext. new object starts with the 4 words from the iv followed by all the words from the encrypted.ciphertext
    return cryptoJS.enc.Base64.stringify(combined);     // Return the combined result as a Base64-encoded string.
}

async function getKeys() {
    let publicKey;
    let version;
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.PUBLIC_KEY) !== null) {
        publicKey = localStorage.getItem(LOCAL_STORAGE_KEYS.PUBLIC_KEY);
        version = localStorage.getItem(LOCAL_STORAGE_KEYS.VERSION);
    } else {
        let objGetInfo = await getInfo();
        publicKey = objGetInfo?.data?.data?.metaData;
        version = objGetInfo?.data?.data?.version;
        localStorage.setItem(LOCAL_STORAGE_KEYS.PUBLIC_KEY, objGetInfo?.data?.data?.metaData);
        localStorage.setItem(LOCAL_STORAGE_KEYS.VERSION, objGetInfo?.data?.data?.version);
    }
    let key;
    let clientKey;
    let objHandshake;
    if (publicKey) {
        key = generateAESKey();
        clientKey = encryptPublicKey(key, publicKey);
        const payload = {
            message: clientKey,
            version: version
        };
        objHandshake = await handshake(payload);
        if (objHandshake?.data?.data) {
            let objResp = decryptWithAEScbc(key, objHandshake?.data?.data);
            let parsedObjResp = JSON.parse(objResp);
            if (Object.keys(parsedObjResp).length) {
                localStorage.setItem(LOCAL_STORAGE_KEYS.SERVER_KEY, parsedObjResp?.serverKey);
                localStorage.setItem(LOCAL_STORAGE_KEYS.HEADER, parsedObjResp?.['x-bts-enc']);
                store.dispatch(updateIsLoading(true));
            }
        } else if (objHandshake.code === 'e-102') {
            localStorage.removeItem(LOCAL_STORAGE_KEYS.PUBLIC_KEY);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.VERSION);
            getKeys();
        }
    }
}
const handleBlink = (buttonId) => {
    const button = document.getElementById(buttonId);
    if (button) {
        button?.classList?.add('blink');
        setTimeout(() => {

            button?.classList?.remove('blink');

        }, 200);
    }

};

const handleKeyDownOnDiv = (e) => {
    if (e?.code === 'Space' || e?.key === ' ' || (e?.key === 'Enter' && e?.currentTarget?.tagName !== 'A')) {
        e?.target?.click();
        e?.preventDefault();
    }
};


function searchLocalStorage(word) {
    let bFlag = false;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith(word)) {
            return bFlag = true;
        }
    }
    return bFlag;
}

// Shuaib P. [15/10/2024] :To count maximum number of scrips in a watchlist --Start

function getscripCountPerWatchlist() {
    let appInfo = store.getState().appInfo;
    let appInfoLimit = getAppInfoData(APP_INFO_PARAMS.APP_WATCHLIST_SCRIP_COUNT, appInfo);
    if (appInfoLimit) {
        return appInfoLimit;
    } else {
        return 50;
    }
}

// Shuaib P. [15/10/2024] :To count maximum number of scrips in a watchlist --End

// Hari K:17-10-2024:To update dontmiss data to arraRowdata -start
const updateDontmissToArrRowData = (groupedDontMissData, arraScripInfo) => {
    const updatedData = arraScripInfo.map((each) => {
        if (groupedDontMissData[each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]?.length) {
            each[WATCHLIST_GRID_INDEX.DONT_MISS] = groupedDontMissData[each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            return each;
        } else { return each; }
    });
    return updatedData;
};
// Hari K:17-10-2024:To update dontmiss data to arraRowdata -end

const GridDateSortingComparator = (date1, date2) => {
    const parseDate1 = new Date(date1);
    const parseDate2 = new Date(date2);

    if (parseDate1 < parseDate2) return -1;
    if (parseDate1 > parseDate2) return 1;
    return 0;

};
function getDisclaimerText(id) {
    const appInfo = store.getState().appInfo;
    const obj = getAppInfoData(APP_INFO_PARAMS.APP_AUTH_DISCLAIMER, appInfo);
    let str;
    if (obj) {
        str = obj[id];
    } else {
        str = DISCLAIMER_NOTE[id];
    }
    return str;
}

// Ajitesh - function to return tabs for calculators; span margin to be returned only when argument key passed is true
const getTabsForCalculator = (isSpanMarginCalcVisible) => {
    const calculatorTabItems = [
        {
            id: 1, name: 'Option Value', tab_key: 'option_value',
        },
        {
            id: 2, name: 'Future Fair Value', tab_key: 'fair_value',
        },
        {
            id: 3, name: 'Span Margin', tab_key: 'span_margin',
        },
        {
            id: 4, name: 'Pivot Point', tab_key: 'pivot_point',
        },
        {
            id: 5, name: 'Fibonacci', tab_key: 'fibonacci',
        }
    ];
    // Condition whether to add Span Margin tab to array or not based on mobile admin key is now below
    return calculatorTabItems.filter(tabItems => tabItems.name !== "Span Margin" && tabItems.id !== 3 ? tabItems : isSpanMarginCalcVisible ? tabItems : false);
};


function getPageSize(columnDefs) {
    if (columnDefs.length <= 19) {
        return 'A3';
    } else if (columnDefs.length > 19 && columnDefs.length <= 24) {
        return 'A2';
    } else if (columnDefs.length > 24 && columnDefs.length <= 31) {
        return 'A1';
    } else if (columnDefs.length > 31) {
        return 'A0';
    }
}

function getNumberSuffix(number) {
    var j = number % 10,
        k = number % 100;
    if (j == 1 && k != 11) {
        return "st";
    }
    if (j == 2 && k != 12) {
        return "nd";
    }
    if (j == 3 && k != 13) {

        return "rd";
    }
    return "th";

}

function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const result = emailRegex.test(email);
    if (result) {
        return true;
    } else {
        return false;
    }
}


// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -start
function getAlphaMonth(sMonth) {
    try {
        let sRetval = "";
        switch (sMonth) {
            case 0:
                sRetval = "Jan";
                break;
            case 1:
                sRetval = "Feb";
                break;
            case 2:
                sRetval = "Mar";
                break;
            case 3:
                sRetval = "Apr";
                break;
            case 4:
                sRetval = "May";
                break;
            case 5:
                sRetval = "Jun";
                break;
            case 6:
                sRetval = "Jul";
                break;
            case 7:
                sRetval = "Aug";
                break;
            case 8:
                sRetval = "Sep";
                break;
            case 9:
                sRetval = "Oct";
                break;
            case 10:
                sRetval = "Nov";
                break;
            case 11:
                sRetval = "Dec";
                break;
        }
        return sRetval;
    } catch (e) {
    }
}
// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End

// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -start
//this common function is created for calculation of days difrent between start and end date
function CalculateDays(startDate, endDate) {
    let today = startDate;
    let sExpiry =
        (endDate.getDate().toString().length == 1
            ? "0" + endDate.getDate()
            : endDate.getDate()) +
        getAlphaMonth(endDate.getMonth()) +
        endDate.getFullYear();

    let dd = today.getDate();
    let mm = today.getMonth();
    let yyyy = today.getFullYear();

    if (dd < 10) dd = "0" + dd;

    if (mm < 10) mm = "0" + mm;

    if (startDate != undefined && endDate != undefined) {
        let expdd = sExpiry.substring(0, 2);
        let expmmm = sExpiry.substring(2, 5);
        let expyyyy = sExpiry.substring(5);
        expmmm = expmmm ? expmmm.toUpperCase() : ""; //BT-127813: INDRESH G: 10-07-2024
        let smm = getNumericMonth(expmmm);

        let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        let firstDate = new Date(yyyy, mm, dd);
        let secondDate = new Date(expyyyy, smm, expdd);

        let diffDays = Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
        );

        return diffDays;
    } else return 0;
}

const handleMTFPledgeRequest = (selQuantity, appInfo, userId, objLoginSession, scripOrderInfo) => {
    try {
        let strUrl = getAppInfoData(APP_INFO_PARAMS.APP_MTF_NETNET_URL, appInfo);
        let type = 1;
        let theme = "L";
        let strProduct = PRODUCT_DETAILS.PLEDGE_PRODUCT;
        let strQS = `UserId=${userId}&GroupId=${objLoginSession?.data?.others?.groupId.trim()}&Product=${strProduct}&ManagerIP=${objLoginSession?.data?.others?.managerIP}&DealerCode=${objLoginSession?.data?.others?.userCode}&GroupCode=${objLoginSession?.data?.others?.groupCode}&theme=${theme}&SessionId=${objLoginSession?.data?.others?.ocToken}&strMTF=Y&strMTF_ISIN=${scripOrderInfo?.[WATCHLIST_GRID_INDEX.ISIN_CODE]}&strMTF_COLValue=0.00&strMTF_QTY=${selQuantity}&strMTF_ScripName=${scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}`;
        strUrl += `?type=${type}&enct=` + EncodeToBase64(strQS);
        return new Promise((resolve, reject) => {
            try {
                const form = document.createElement("form");
                form.setAttribute("name", "mtfPrePledgeForm");
                form.setAttribute("method", "Post"); //Deepti b. set form method to post for 100+ scrips authorization
                let windowObject = null;
                windowObject = window.open(strUrl, "_blank", "width=1000,height=800,location=no,toolbar=no,menubar=no,resizable=no");
                windowObject.document.body.appendChild(form);
                windowObject.document.forms[0].submit();
                if (windowObject) {
                    const timer = setInterval(() => {
                        if (windowObject.closed) {
                            clearInterval(timer);
                            reject("popup closed");
                        }
                    }, 1000);
                }
                else {
                    reject("popup not created");
                }
                window.addEventListener("message", (event) => {
                    if (event.data.messageCode === 'MTFResp' && windowObject.parent !== null) {
                        const responseData = JSON.parse(event.data.respdata);
                        if (responseData.length > 0) {
                            const arrSuccess = responseData.filter(scrip => scrip.ISINStatus === "Success" || scrip.sStatus === "Success");
                            if (arrSuccess.length > 0) {
                                resolve(arrSuccess);
                                windowObject.close();
                            }
                            else {
                                reject([]);
                                windowObject.close();
                            }
                        } else {
                            reject('User has pressed cancel button or Transaction Failed at Depository');
                            windowObject.close();
                        }
                    }
                });
            } catch (error) {
                reject(error.message);
            }
        });
    } catch (error) {
        console.error(error.message);
    }
};
// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End


function validUrl(url) {
    if (url.startsWith('http://') || url.startsWith('https://') || !url.includes('undefined')) {
        return true;
    }
    return false;
}
const getMarketAllowed = (arrExchName) => {
    let iMtSegVal = 0;

    for (let index = 0; index < arrExchName.length; index++) {
        const strExchName = arrExchName[index];

        switch (strExchName) {
            case EXCHANGE_NAME_API.NSE_EQ_API:
                iMtSegVal += clsConstants.C_V_MAPPED_NSE_CASH;
                break;

            case EXCHANGE_NAME_API.NSE_DERV_API:
                iMtSegVal += clsConstants.C_V_MAPPED_NSE_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.BSE_EQ_API:
                iMtSegVal += clsConstants.C_V_MAPPED_BSE_CASH;
                break;

            case EXCHANGE_NAME_API.BSE_DERV_API:
                iMtSegVal += clsConstants.C_V_MAPPED_BSE_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.MCX_FUTURES_API:
                iMtSegVal += clsConstants.C_V_MAPPED_MCX_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.NCDEX_FUTURES_API:
                iMtSegVal += clsConstants.C_V_MAPPED_NCDEX_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.NSE_CUR_API:
                iMtSegVal += clsConstants.C_V_MAPPED_NSX_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.BSE_CUR_API:
                iMtSegVal += clsConstants.C_V_MAPPED_BSECDX_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.NSE_COMM_API:
                iMtSegVal += clsConstants.C_V_MAPPED_NSECOMM_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.BSE_COMM_API:
                iMtSegVal += clsConstants.C_V_MAPPED_BSECOMM_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.ICEX_DERV_API:
                iMtSegVal += clsConstants.C_V_MAPPED_ICEX_DERIVATIVES;
                break;

            case EXCHANGE_NAME_API.NSE_OTS_API:
                iMtSegVal += clsConstants.C_V_MAPPED_OFS_IPO_BONDS;
                break;

            case EXCHANGE_NAME_API.MUTUAL_FUND:
                iMtSegVal += clsConstants.C_V_MAPPED_MUTUAL_FUND;
                break;

            case EXCHANGE_NAME_API.MCXSX_EQ_API:
                iMtSegVal += clsConstants.C_V_MAPPED_MSX_CASH;
                break;

            case EXCHANGE_NAME_API.MCXSX_DERV_API:
                iMtSegVal += clsConstants.C_V_MAPPED_MSX_FAO;
                break;

            case EXCHANGE_NAME_API.MCXSX_CURR_API:
                iMtSegVal += clsConstants.C_V_MAPPED_MSX_DERIVATIVES;
                break;

            default:
                break;
        }
    }

    return iMtSegVal;
};


export {
    getMarketAllowed,
    validUrl,
    getExchangeNameDescBySegmentId,
    getMktStatusColor,
    createPGURL,
    validateEmail,
    updateDontmissToArrRowData,
    bIsProd,
    getDisclaimerText,
    getscripCountPerWatchlist,
    searchLocalStorage,
    getKeys,
    encryptWithAEScbc,
    decryptWithAEScbc,
    ADDENDUM_STATUS_MODAL_REF,
    USED_MARGIN_MODAL_GRID_REF,
    MUTUAL_FUND_HOLDINGS_GRID_REF,
    MUTUAL_FUND_ORDERS_REF,
    COMMENTRY_GRID_REF,
    setCommentryGridRef,
    setAddendumStatusModalGridRef,
    setUsedMarginModalGridRef,
    setMutualFundHoldingGridRef,
    setMutualFundOrdersGridRef,
    isAppDisableClosePrice,
    sortDateInStringsInSequence,
    SCREENERS_HOLDINGS_GRID_REF,//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners
    setScreenersGoldingsGrifRef,//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners 
    createNewWatchlist, // Hari k:17-04-2024: BT-108447: create watchlist from list
    generateUniqueName,
    nullCheck,
    getViewAllowedOptnChain,
    getViewAllowed,
    openOrderEntryModal,
    hamburgerRoutes,
    isUserIsAGuest,
    isGuestUser,
    filterUsername,
    getOrderDisplayDiscription,
    modifySymbol,
    capitalizeFirstLetter,
    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    ADD_END_DUM_NOTICE_GRID_REF,
    setAddendumNoticeGridref,
    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End
    makeGridRowSelected,
    validateUpiId,
    convertTouclineIndexToWatchlistGridIndex,//Ameersha N : 15-11-2023 : BT-95888 Create Watchlist || Converting touchline indexs to wathclist to avoid conflict in between --Start
    INFINITY_GRID_REF,
    setInfinityGridRef,
    convertTOVariable,
    compareObjectsAndArrageInSequence,
    returnCountWithPad,
    convertColumnsDatatoGridColumns,
    checkColdefwithPiviots,
    removeSpacesAndNumberFromWords,
    setOptionPutRef,
    setOptionCallRef,
    OPTION_CALL_REF,
    OPTION_PUT_REF,
    findIndexForValueBetween,
    getDistinctExpiryDates,
    getInstrumentName,
    filterSpCharsAndSpacesOut,
    filterObjects,
    removeExpiriedScrip,
    setDontMissCol,
    dontMissCol,
    convertDateToSeconds,
    MUTUAL_FUNDS_WATCHLIST_GRID,
    getDecimalLocatorFromApiExchangeName,
    handleUpdateWatchlistGrid,
    getDynamicParamsForToFixed,
    getValidityByExchangeName,
    convertBestFiveResponseToMarketDepthGrid,
    setMutualFundsWatchlistGrid,
    getMktSegIdFromMappedMktSegId,
    getApiExchangeNameFromMktSegId,
    getMktSegIdFromApiExchangeName,
    getMappedMktSegIdFromApiExchangeName,
    convertNumberWithCommasForCurrency,
    changeNumberFormatWithCurrecyUnit,
    arrayGroupBy,
    timeConvert,
    getItemShade,
    calculateHistogram,
    encryptTDES,
    decryptTDES,
    entangle,
    disentangle,
    keyIvFromSalt,
    convertScripResponseWatchlistGrid,
    setInitialConfigs,
    WATCHLIST_GRID_REF,
    MULTISCRIP_ORDER_CART_GRID_REF,
    HEAT_MAP_REF,
    updateHoldingData,
    setGridRef,
    setMultiScripOrderCartGridRef,
    deepClone,
    ORDERS_GRID_REF,
    setOrdersGridRef,
    NETPOSITION_GRID_REF,
    setNetPositionGridRef,
    setHeatMapGridRef,
    setActiveTheme,
    onChangeToggleTheme,
    getUserLoggedIn, createChartUrl, findAppInfoParameters,
    HOILDING_GRID_REF,
    setHoldingpPortfolioGrid,
    getDyanmicURL,
    onUserLoggedInActiveSession,
    getAppInfoData,
    LOGIN_QR_INTERVAL,
    setLoginQRInterval,
    clearLoginQRInterval,
    isCommodityExchange,
    changeDataInGridFormat,
    handleUpdateConstituentsGrid,
    convertScripResponseConstituents,
    convertScripResponseGlobalIndices,
    dateFormatter,
    FUTURE_GRID_REF,
    setFutureTabGridRef,
    getNumberWithCurrencyFormat,
    getFormattedNumbers,
    arrangeObjectsInSequence,
    getAssetExchangeNameFromMktSegId,
    maskNumber,
    convertToDate,
    UnRealisedProfitLoss,
    RealisedProfitLoss,
    TodaysProfitLoss,
    OverAllProfitLoss,
    postionOverviewPercentageChange,
    handlePositionsChange,
    getArrSingleScripOrderInfo,
    getArrSipScripOrderInfo,
    getIsConfigExist,
    findMissingElement,
    getSummaryData,
    getFixedFloatedValue,
    checkNonBlankNonZero,
    CheckForNonMinusOne,
    formatToPercentage,
    compareDates,
    onTouchLineSubscriptionForPortfolioSummary,
    getBidAndAskGridRowData,
    convertAlertToWatchlistGrid,
    calculateSupportRestistanceValues,
    getClientFacilityTemplate,
    bExchahangesAllowed,
    getProductTypeValue,
    getToFixedParseFloat,
    fnRoundDown,
    fnRoundUp,
    getTradeTimeForValue,
    DecimalLocatorPositions,
    isValidDecimalDigits,
    getGSMGradeDescriptionFromScrip,
    validateLTPPriceBand,
    getOrderIdentifier,
    roundToNearest,
    ORDER_ENTRY_GRID_REF,
    setOrderEntryModalRef,
    IPO_APP_URL,
    getGroupedSegement,
    getExchangeName,
    setLivePulseRef,
    LIVE_PULSE_REF,
    INDICES_REF,
    setIndicesRef,
    setMySummaryRef,
    MY_SUMMARY_REF,
    setInvestmentsRef,
    INVESTMENTS_REF,
    setScreenersRef,
    SCREENER_REF, NEWS_REF,
    setNewsRef,
    setEventsRef,
    EVENT_REF,
    RECOMMENDATION_REF,
    setRecommendationsRef,
    getQtyLotCaption,
    sendDataToChart,
    sendDataToChartBestFive,
    setEncryptLocalStorage,
    getDecryptLocalStorage,
    ORDERBOOK_IPO_REF,
    setOrderbookIpoRef,
    ALERT_GRID_REF,
    setAlertGridRef,
    getAssetExchangeName,
    removeDuplicatesAndSort,
    getChangeInRs,
    defaultLandingPage,
    setHoldingsGridRef,
    createAndDownLoadPDF,
    TripleDESDecrypt,
    TripleDESEncrypt,
    checkGuestLogin,
    getScripDisplayDescription,
    setNotificationToLocalStorage,
    hasUserGrantedPOA,
    findDPAndCliendId,
    EncodeToBase64,
    handleClassColors,
    getGlobalFontColor,
    setLivePulseGridRef,
    LIVE_PULSE_GRID_REF,
    setOrderCartGridRef,
    ORDERCART_GRID_REF,
    convertEditCart,
    collapseRow,
    decryptChartData,
    convertToDateObj,
    ConvertToRe,
    getLegObject,
    getNotificationFromLocalStorage,
    ReconnectSocket,
    getAveragePrice,
    calculateCVF,
    getIPOPaymentStatus,
    setOrderEntryScripPrice,
    getQtyType,
    getEncryptString,
    openOverviewModal,
    addAdditionalScripDetailstoWatchlist,
    displayZeroStateForGrid,
    handleBlink,
    handleKeyDownOnDiv,
    handleIndicesCardColor,
    GridDateSortingComparator,
    getPageSize,
    getTabsForCalculator,
    getNumberSuffix,
    CalculateDays,
    handleMTFPledgeRequest
};
